/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(168));
	    processInclude(__webpack_require__(172));
	    processInclude(__webpack_require__(173));
	    processInclude(__webpack_require__(174));
	    processInclude(__webpack_require__(175));
	    if ($("#findInStoreButton").length > 0) {
	        processInclude(__webpack_require__(176));
	    }
	});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * create the opening hours template, based on the information available
	 * @param {Array} openingHours - an array (usually with a length of 7), which rapresent the days of the week
	 *
	 * @return {html} the template populated with opening hours data
	 */

	function buildCollectionPointHoursTemplate(openingHours) {
	    var $hoursTemplate = $('#clickCollectHoursTemplate').children().clone(),
	        $daytemplate,
	        dayOfWeek,
	        result = $(document.createElement("p"));

	    for (var i = 0; i < openingHours.length; i++) {
	        dayOfWeek = openingHours[i];
	        $daytemplate = $hoursTemplate.clone();
	        $daytemplate.find('.js-day').html(dayOfWeek.day + ':');
	        // Combine all hours into a single string, separated by commas
	        var combinedHours = dayOfWeek.hours.join(', ');
	        $daytemplate.find('.js-hour').html(combinedHours);

	        // Append the modified day template to the result
	        $daytemplate.appendTo(result);
	    }
	    return result;
	}

	/**
	 * Set store address
	 * @param {template} template Template
	 * @param {Object} store Store data object
	 * @param {Object} $address1 Store address1
	 * @param {Object} $address2 Store address2
	 */
	function fillStoreAddress(template, store, $address1, $address2) {
	    // For Bata IT, MY: Store address is splitted in two lines
	    if ($address2.length) {
	        if (store.a2) {
	            // store has address 2
	            $address1.html(store.a1 + '<br>');
	            $address2.html(store.a2 + '<br>');
	        } else {
	            $address1.html(store.a1 + '<br>');
	            $address2.html('');
	        }
	        // For the other sites: Both addresses (if address2 exists) are displayed in one line
	    } else {
	        $address1.html(store.a2 ? store.a1 + ' ' + store.a2 + '<br>' : store.a1 + '<br>');
	    }
	}

	/**
	 * Show COD allowed/disallowed message on each store's frontend
	 * @param {template} template Template
	 * @param {Object} store Store data object
	 */
	function showPickupPointCODAllowed(store, template) {
	    var codNotAvailableMsg = store.codAllowed === false ? $('#storeListResults').attr('data-cod-not-allowed-message') : "";
	    template.content.querySelector('.js-store-details-number').setAttribute('data-cod-allowed', store.codAllowed);
	    template.content.querySelector('.js-cod-allowed').textContent = codNotAvailableMsg;

	    var codAllowedString = store.codAllowed ? 'true' : 'false';
	    template.content.querySelector('.js-goto-store').setAttribute('data-codallowed', codAllowedString);
	}

	/**
	 * create the StoreLocator Tiles for Stores List view
	 * @param {Object} store - a store object
	 * @param {Element} template - the template to populate with stores's data
	 * @param {Boolean} isClickAndCollect - true if it is the pin for clickAndCollect template
	 * @param {Boolean} isFilterByStoreBrands - true if filtered by brand
	 * @param {String} controllerURL - the controller to call if the user clicks on the pin
	 * @param {Boolean} hideStoreDetailsButton - true if it is needed to hide the button to reach the store details
	 * @return {String} the template populated with stores's data
	 */
	// eslint-disable-next-line complexity
	function buildStoreMarkerPin(store, template, isClickAndCollect, isFilterByStoreBrands, controllerURL, hideStoreDetailsButton) {
	    var storeID = store.ID,
	        storeDetailUrl = controllerURL ? controllerURL + '?storeID=' + store.ID + '&distance=' + store.dist + '&distanceUnit=' + store.dUnit : '',
	        storePhone = store.phone,
	        type,
	        typeDV,
	        brand,
	        brandDV;

	    // set
	    var $storeInfo = template.find('.js-storeId');
	    $storeInfo.data('store-id', storeID);

	    if (store.brand === 'f') {
	        brand = 'flagship';
	        brandDV = 'Flagship store';
	    } else {
	        brand = store.brand;
	        brandDV = store.brandDV;
	    }
	    $storeInfo.data('storebrand', brand);

	    if (store.type === 'o') {
	        type = 'original';
	        typeDV = 'Original store';
	    } else {
	        type = store.type;
	        typeDV = store.typeDV;
	    }
	    $storeInfo.attr('type', type);

	    var $storeNameSection = template.find('.js-storeName'),
	        $phoneContainer = template.find('.js-phoneContainer'),
	        $phone = $phoneContainer.find('.js-storePhone'),
	        $storePCode = template.find('.js-postalCode'),

	    // zipCodePublic is only for pickup points in CZ, it has to be setted in the shipping address, but it has not to be displayed
	    zipCodeForShipping = store.pCodePublic,
	        openingHours = store.hours,
	        $address1 = template.find('.js-storeAddress'),
	        $address2 = template.find('.js-storeAddress2');
	    $storeNameSection.attr('href', storeDetailUrl);
	    $storeNameSection.html(store.name);
	    var distance = store.dist && store.dist !== 'null' ? store.dist + ' ' + store.dUnit : '';
	    template.find('.js-storeDistance').html(distance);

	    fillStoreAddress(template, store, $address1, $address2);

	    template.find('.js-storeCity').html(store.city ? store.city + ',' : '');
	    template.find('.js-storeStateCode').html(store.sCode ? store.sCode + ',' : '');
	    template.find('.js-storeDistrict').html(store.district ? store.district + ',' : '');
	    template.find('.js-storeSubdistrict').html(store.subdistrict ? store.subdistrict + ',' : '');
	    $storePCode.html(store.pCode);
	    $storePCode.attr('data-public-postal-code', zipCodeForShipping || '');
	    if ($phone.length > 0) {
	        if (storePhone && storePhone.trim() !== '') {
	            $phoneContainer.removeClass('d-none');
	            $phone.html(storePhone);
	            $phone.attr('href', 'tel:' + storePhone);
	        } else {
	            // if a store doesn't have a phone, also the phone icon will be hidden
	            $phoneContainer.addClass('d-none');
	        }
	    }
	    // for Click & Collect the hours is a string field in the DB, for Pickup Points is an array of days
	    if (typeof openingHours === 'string' || !openingHours) {
	        template.find('.js-storeHours').html(unescape(openingHours || ''));
	    } else {
	        var hoursTemplate = buildCollectionPointHoursTemplate(openingHours);
	        template.find('.js-storeHours').html(hoursTemplate);
	    }
	    if (!store.hours) {
	        template.find('.cc-icon-hours').addClass('d-none');
	    } else {
	        template.find('.cc-icon-hours').removeClass('d-none');
	    }
	    if (hideStoreDetailsButton) {
	        template.find('.storeDetails').addClass('d-none');
	    }
	    if (isClickAndCollect) {
	        template.find('.js-storeDetails').removeAttr('href');
	        var tileTemplateID = $('#queryStoreParam').data('template-tile');
	        var url = document.querySelector('#' + tileTemplateID).content.querySelector('.js-select-clickcollect-store').getAttribute('data-url');
	        var $storeInfoButton = template.find('.storeInfoButton');
	        $storeInfoButton.addClass('js-select-clickcollect-store');
	        $storeInfoButton.attr('data-url', url);
	        $storeInfoButton.attr('data-storeid', storeID);
	        $storeInfoButton.attr('data-title', store.name);
	        template.find('.js-storelocator-message').remove();
	    } else {
	        if (isFilterByStoreBrands === true) {
	            template.find('.js-storeTypeDisplayValue').html(brandDV);
	        } else {
	            template.find('.js-storeTypeDisplayValue').html(typeDV);
	        }
	        template.find('.js-storeDetails').attr('href', storeDetailUrl);

	        // Remove the click & collect exclusive element since they are not meant to be in the storelocator
	        template.find('.js-clickAndCollect-message').remove();
	    }
	    var storePinHtml = template.clone();
	    var storePin = {
	        name: store.name,
	        latitude: store.lat,
	        longitude: store.long,
	        type: type,
	        storeBrand: brand,
	        infoWindowHtml: storePinHtml.html()
	    };
	    return storePin;
	}

	/**
	 * create the StoreLocator Pin for Store
	 * @param {Object} store - a store object
	 * @param {Element} template - the template to populate with stores's data
	 * @return {String} the template populated with stores's data
	 */
	function buildStoreCard(store, template, isFilterByStoreBrands, controllerURL) {
	    var storePhone = store.phone,
	        storeDetailUrl = controllerURL + '?storeID=' + store.ID + '&distance=' + store.dist + '&distanceUnit=' + store.dUnit,
	        storeID = store.ID,
	        type,
	        typeDV,
	        brand,
	        brandDV;
	    // set
	    template.find('.js-store-details-number').attr('object', JSON.stringify(store));
	    template.find('.js-storeContainer').attr('id', storeID);
	    var $phone = template.find('.js-storePhone'),
	        $storePCode = template.find('.js-postalCode'),

	    // pCodePublic is only for pickup points in CZ, it has to be setted in the shipping address, but it has not to be displayed
	    zipCodeForShipping = store.pCodePublic;
	    template.find('.js-storeId').data('store-id', storeID);

	    if (store.brand === 'f') {
	        brand = 'flagship';
	        brandDV = 'Flagship store';
	    } else {
	        brand = store.brand;
	        brandDV = store.brandDV;
	    }
	    template.find('.js-storeId').attr('storebrand', brand);

	    if (store.type === 'o') {
	        type = 'original';
	        typeDV = 'Original store';
	    } else {
	        type = store.type;
	        typeDV = store.typeDV;
	    }
	    template.find('.js-storeId').attr('type', type);
	    var $storeNameSection = template.find('.js-storeName');
	    $storeNameSection.attr('href', storeDetailUrl);
	    $storeNameSection.html(store.name);
	    if (isFilterByStoreBrands === true) {
	        template.find('.js-storeTypeDisplayValue').html(brandDV);
	    } else {
	        template.find('.js-storeTypeDisplayValue').html(typeDV);
	    }
	    if (store.dist && store.dist !== 'null') {
	        template.find('.js-storeDistance').html(store.dist + ' ' + store.dUnit);
	    }

	    var $address1 = template.find('.js-storeAddress');
	    var $address2 = template.find('.js-storeAddress2');
	    fillStoreAddress(template, store, $address1, $address2);

	    template.find('.js-storeCity').html(store.city ? store.city + ',' : '');
	    template.find('.js-storeStateCode').html(store.sCode ? store.sCode + ',' : '');
	    template.find('.js-storeDistrict').html(store.district ? store.district + ',' : '');
	    template.find('.js-storeSubdistrict').html(store.subdistrict ? store.subdistrict + ',' : '');
	    $storePCode.html(store.pCode);
	    $storePCode.attr('data-public-postal-code', zipCodeForShipping || '');
	    if (storePhone && storePhone.length > 0) {
	        $phone.html(storePhone);
	        $phone.attr('href', 'tel:' + storePhone);
	        $phone.removeClass('d-none');
	    } else {
	        $phone.addClass('d-none');
	    }
	    template.find('.js-storeHours').html(unescape(store.hours ? store.hours : ''));
	    var storeTemplate = template.clone();

	    return storeTemplate[0].outerHTML;
	}

	/**
	 * Create pin and stores tile from Stores-Find response data
	 * @param {Object} data - the response from Stores-FindStores
	 * @return {Object} pins and store list templates
	 */
	function showStoresResults(data, isFilterByStoreBrands) {
	    var stores = data.stores,
	        pins = [],
	        storeList = '',
	        markerTemplate = $($('#storeMarkerTemplate')[0].content.children[0]),
	        listTemplate = $($('#storeTileTemplate')[0].content.children[0]),
	        controllerURL = data.controllerURL;
	    stores.forEach(function (store) {
	        pins.push(buildStoreMarkerPin(store, markerTemplate, false, isFilterByStoreBrands, controllerURL));
	        storeList += buildStoreCard(store, listTemplate, isFilterByStoreBrands, controllerURL);
	    });
	    return {
	        pins: pins,
	        storeList: storeList
	    };
	}

	/**
	 * Create a store tile from a collection point when the "select" button in checkout is selected
	 * @param {Object} pickupPoint - the collection point object
	 * @param {template} template -the template which will populated using the pickup point data
	 */
	function buildPickupPointCard(pickupPoint, template) {
	    var $storePCode = template.find('.js-postalCode'),
	        $city = template.find('.js-storeCity'),
	        $distanceContainer = template.find('.js-storeDistanceContainer'),
	        $storeNameSection = template.find('.js-storeName'),
	        $storeAddress = template.find('.js-storeAddress'),
	        $storeAddress2 = template.find('.js-storeAddress2'),

	    // Only some collections points have stateCode (InPost for IT)
	    $stateCode = template.find('.js-storeStateCode'),

	    // zipCodePublic is only for pickup points in CZ, it has to be setted in the shipping address, but it has not to be displayed
	    zipCodeForShipping = pickupPoint.pCodePublic,
	        openingHours = pickupPoint.hours;

	    $storeNameSection.html(pickupPoint.name);
	    if (pickupPoint.dist && pickupPoint.dist !== 'null') {
	        $distanceContainer.removeClass('d-none');
	        $distanceContainer.find('.js-storeDistance').html(pickupPoint.dist + ' ' + pickupPoint.dUnit);
	    } else {
	        $distanceContainer.addClass('d-none');
	    }
	    // only some pickup points have the id, check useParcelShopCode attribute inside the shipping method
	    template.attr('data-store-id', pickupPoint.ID);
	    template.attr('data-companyname', pickupPoint.name);
	    template.attr('data-cod-allowed', pickupPoint.codAllowed);

	    // Grabbing the codAllowed value of the closest "store" selected and setting it in the selected Card.
	    var codAllowed = template.attr('data-cod-allowed');
	    $('#selectedStore').attr('data-cod-allowed', codAllowed);
	    // Value that passes the codAllowed into the backend
	    $('.js-selected-store-container').attr('data-cod-allowed', codAllowed);

	    // Address2 is not present in pickup points
	    // It is added for future implementation
	    fillStoreAddress(template, pickupPoint, $storeAddress, $storeAddress2);

	    $city.html(pickupPoint.city ? pickupPoint.city + ',' : '');
	    $city.attr('data-city', pickupPoint.city);
	    $storePCode.html(pickupPoint.pCode);
	    $storePCode.attr('data-public-postal-code', zipCodeForShipping || '');
	    if ($stateCode.length) {
	        $stateCode.html(pickupPoint.sCode || '');
	    }
	    if (typeof openingHours === 'string' || !openingHours) {
	        template.find('.js-storeHours').html(unescape(openingHours || ''));
	    } else {
	        var hoursTemplate = buildCollectionPointHoursTemplate(openingHours, template.find('.js-storeHours'));
	        template.find('.js-storeHours').html(hoursTemplate);
	    }
	    var pickupPointTemplate = template.clone();
	    var result = pickupPointTemplate[0].outerHTML;

	    return result;
	}

	module.exports = {
	    buildCollectionPointHoursTemplate: buildCollectionPointHoursTemplate,
	    buildPickupPointCard: buildPickupPointCard,
	    showPickupPointCODAllowed: showPickupPointCODAllowed,
	    buildStoreMarkerPin: buildStoreMarkerPin,
	    showStoresResults: showStoresResults,
	    fillStoreAddress: fillStoreAddress
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	'use strict';

	// This file is used in storelocator, find in store, click & collect (+ collection point) page in order to manage the user position, wich is used to calculate the distances

	var userPositionData = {
	    userGeolocation: null,
	    userAddress: null
	};

	var lastAvailableGeolocationKey = 'lastAvailableGeolocation';

	function getUserPositionIfAvailable(callback) {
	    var coords = {
	        lat: null,
	        lng: null,
	        isDefaultCenterLocation: false
	    };
	    var success = function success(position) {
	        coords.lat = position.coords.latitude;
	        coords.lng = position.coords.longitude;
	        callback(coords);
	    };
	    if (navigator.permissions) {
	        navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
	            if (result.state === 'granted') {
	                navigator.geolocation.getCurrentPosition(success);
	            }
	        });
	    } else {
	        callback(JSON.parse(localStorage.getItem(lastAvailableGeolocationKey)));
	    }
	}

	/**
	 * @description set the user's position, based on the type of it
	 * @param {string} lat - the latitude to set
	 * @param {string} long - the longitude to set
	 * @param {string} type - 'userAddress' to set the user's Address, 'userGeolocation' to set user's geolocation position
	 */
	function setUserPosition(lat, long, type) {
	    if (lat && long) {
	        userPositionData[type] = {
	            lat: lat,
	            long: long
	        };
	    }
	    // if a browser does not support navigator permission -> save coords to localStorage
	    if (type === 'userGeolocation' && !navigator.permissions && lat && long) {
	        var coords = {
	            lat: lat,
	            lng: long,
	            isDefaultCenterLocation: false
	        };
	        localStorage.setItem(lastAvailableGeolocationKey, JSON.stringify(coords));
	    }
	}

	/**
	 * @description get the user position, if available
	 * @param {boolean} isGeolocationSearch - true if user's address needs to be retrieved, false only for geolocation position
	 * @return {Object.lat} the user's latitude if available
	 * @return {Object.long} the user's longitude if available
	 */
	function getUserPosition(isGeolocationSearch) {
	    var result = {
	        lat: null,
	        long: null
	    };
	    if (isGeolocationSearch && userPositionData.userAddress) {
	        result.lat = userPositionData.userAddress.lat;
	        result.long = userPositionData.userAddress.long;
	    }
	    if (userPositionData.userGeolocation) {
	        result.lat = userPositionData.userGeolocation.lat;
	        result.long = userPositionData.userGeolocation.long;
	    }
	    return result;
	}

	module.exports = {
	    setUserPosition: setUserPosition,
	    getUserPosition: getUserPosition,
	    getUserPositionIfAvailable: getUserPositionIfAvailable
	};

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	"use strict";

	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	"use strict";

	/**
	 * A function that detects user's device.
	 * @returns {Boolean} Returns `true` if user's device is mobile/tablet.
	 */
	function detectMobile() {
	    var toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

	    return toMatch.some(function (toMatchItem) {
	        return navigator.userAgent.match(toMatchItem);
	    });
	}

	module.exports = {
	    detectMobile: detectMobile
	};

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    setTabNextFocus: function setTabNextFocus(focusParams) {
	        var KEYCODE_TAB = 9;
	        var isTabPressed = focusParams.event.key === 'Tab' || focusParams.event.keyCode === KEYCODE_TAB;

	        if (!isTabPressed) {
	            return;
	        }

	        var firstFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.firstElementSelector);
	        var lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.lastElementSelector);

	        if ($(focusParams.containerSelector + ' ' + focusParams.lastElementSelector).is(':disabled')) {
	            lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.nextToLastElementSelector);
	            if ($('.product-quickview.product-set').length > 0) {
	                var linkElements = $(focusParams.containerSelector + ' a#fa-link.share-icons');
	                lastFocusableEl = linkElements[linkElements.length - 1];
	            }
	        }

	        if (focusParams.event.shiftKey) /* shift + tab */{
	                if ($(':focus').is(firstFocusableEl)) {
	                    lastFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            } else /* tab */{
	                if ($(':focus').is(lastFocusableEl)) {
	                    // eslint-disable-line
	                    firstFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            }
	    }
	};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	//enables lazyload in pdp

	var picture_lazy_load = __webpack_require__(119);
	picture_lazy_load.init();

	function hideAddToWishlistButtonInPDP() {
	    $('.product-detail .prices-add-to-cart-actions .add-to-wish-list').hide();
	}
	hideAddToWishlistButtonInPDP();

	function selectASizeHintWishList() {
	    $('.container').on('click', '.add-to-wish-list', function () {
	        var $self = $(this);
	        if (!$self.hasClass('to-add to-remove')) {

	            var $overlay = $self.parents('.product-tile').find('.js-tile-open-overlay');
	            if ($overlay.hasClass('js-noSize')) {
	                return;
	            } else {
	                $self.closest('.cc-col-tile').addClass('js-addWishlist');
	                $overlay.trigger('click');
	            }
	        }
	    });
	}

	selectASizeHintWishList();

	//this function is to use only if variationGroups have different type of size
	// function modifyUrlColorSwatchesToSingleVariant($sizeTile) {
	//     var urlVariantValue = $sizeTile.attr('value');
	//     var sizeValue = $sizeTile.attr('data-attr-value');
	//     var $colorSwatches = $('.attributes .swatches-container .color-attribute');
	//     var urlToReplace;
	//     $colorSwatches.each(function () {
	//         var element = $(this).find('.color-value');
	//         var colorValue = element.attr('data-attr-value');
	//         urlToReplace = urlVariantValue;
	//         urlToReplace = urlToReplace.replace(/(?<=size=)(.*?)((?=&)|(?=$))/, sizeValue);
	//         urlToReplace = urlToReplace.replace(/(?<=color=)(.*?)((?=&)|(?=$))/, colorValue);
	//         $(this).attr('data-url', urlToReplace);
	//     })
	// }

	/**
	 * Retrieves the relevant pid value
	 * @param {jquery} $el - DOM container for a given add to cart button
	 * @return {string} - value to be used when adding product to cart
	 */
	function getPidValue($el) {
	    var pid;

	    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length > 0) {
	        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
	    } else if ($($el).closest('.product-tile').length > 0) {
	        pid = $($el).data('pid');
	    } else if ($($el).closest('.product-set').length > 0 || $('.product-set').length > 0) {
	        pid = $($el).closest('.product-detail').find('.product-id').text();
	    } else {
	        pid = $('.product-detail:not(".bundle-item")').data('pid');
	    }

	    return pid;
	}

	/**
	 * Makes a call to the server to report the event of adding an item to the cart
	 *
	 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
	 */
	function miniCartReportingUrl(url) {
	    if (url) {
	        $.ajax({
	            url: url,
	            method: 'GET',
	            success: function success() {
	                // reporting urls hit on the server
	            },
	            error: function error() {
	                // no reporting urls hit on the server
	            }
	        });
	    }
	}

	module.exports = {
	    getPidValue: getPidValue,
	    miniCartReportingUrl: miniCartReportingUrl
	};

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	    init: function init() {
	        //var featureDetect = require('./featureDetect');

	        var lazySizesConfig = window.lazySizesConfig = window.lazySizesConfig || {};
	        lazySizesConfig.init = false;
	        lazySizesConfig.loadMode = 2;
	        lazySizesConfig.preloadAfterLoad = false;
	        lazySizesConfig.ricTimeout = 250;
	        lazySizesConfig.expand = 700;
	        lazySizesConfig.loadHidden = false;
	        lazySizesConfig.srcAttr = 'data-lazy';
	        lazySizesConfig.srcsetAttr = 'data-srcset';
	        lazySizesConfig.sizesAttr = 'data-sizes';
	        lazySizesConfig.lazyClass = 'b-lazyload';
	        lazySizesConfig.loadingClass = 'b-lazyload_loading';
	        lazySizesConfig.loadedClass = 'b-lazyload_loaded';

	        var lazysizes = __webpack_require__(120);

	        document.addEventListener('lazybeforeunveil', function (e) {
	            var bg = e.target.getAttribute('data-bg');
	            if (bg) {
	                e.target.style.backgroundImage = 'url(' + bg + ')';
	            }
	        });

	        lazysizes.init();
	        // if (!featureDetect.hasPicture) {
	        //     import( /* webpackChunkName: "picturefill" */ 'picturefill').then((loadedModule) => {
	        //         loadedModule.default();
	        //         lazysizes.init();
	        //     });
	        // } else {
	        //     lazysizes.init();
	        // }

	    }
	};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	(function (window, factory) {
		var lazySizes = factory(window, window.document);
		window.lazySizes = lazySizes;
		if (( false ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
			module.exports = lazySizes;
		}
	})(window, function l(window, document) {
		'use strict';
		/*jshint eqnull:true */

		if (!document.getElementsByClassName) {
			return;
		}

		var lazysizes, lazySizesConfig;

		var docElem = document.documentElement;

		var Date = window.Date;

		var supportPicture = window.HTMLPictureElement;

		var _addEventListener = 'addEventListener';

		var _getAttribute = 'getAttribute';

		var addEventListener = window[_addEventListener];

		var setTimeout = window.setTimeout;

		var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

		var requestIdleCallback = window.requestIdleCallback;

		var regPicture = /^picture$/i;

		var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

		var regClassCache = {};

		var forEach = Array.prototype.forEach;

		var hasClass = function hasClass(ele, cls) {
			if (!regClassCache[cls]) {
				regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
			}
			return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
		};

		var addClass = function addClass(ele, cls) {
			if (!hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
			}
		};

		var removeClass = function removeClass(ele, cls) {
			var reg;
			if (reg = hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
			}
		};

		var addRemoveLoadEvents = function addRemoveLoadEvents(dom, fn, add) {
			var action = add ? _addEventListener : 'removeEventListener';
			if (add) {
				addRemoveLoadEvents(dom, fn);
			}
			loadEvents.forEach(function (evt) {
				dom[action](evt, fn);
			});
		};

		var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
			var event = document.createEvent('Event');

			if (!detail) {
				detail = {};
			}

			detail.instance = lazysizes;

			event.initEvent(name, !noBubbles, !noCancelable);

			event.detail = detail;

			elem.dispatchEvent(event);
			return event;
		};

		var updatePolyfill = function updatePolyfill(el, full) {
			var polyfill;
			if (!supportPicture && (polyfill = window.picturefill || lazySizesConfig.pf)) {
				if (full && full.src && !el[_getAttribute]('srcset')) {
					el.setAttribute('srcset', full.src);
				}
				polyfill({ reevaluate: true, elements: [el] });
			} else if (full && full.src) {
				el.src = full.src;
			}
		};

		var getCSS = function getCSS(elem, style) {
			return (getComputedStyle(elem, null) || {})[style];
		};

		var getWidth = function getWidth(elem, parent, width) {
			width = width || elem.offsetWidth;

			while (width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth) {
				width = parent.offsetWidth;
				parent = parent.parentNode;
			}

			return width;
		};

		var rAF = function () {
			var running, waiting;
			var firstFns = [];
			var secondFns = [];
			var fns = firstFns;

			var run = function run() {
				var runFns = fns;

				fns = firstFns.length ? secondFns : firstFns;

				running = true;
				waiting = false;

				while (runFns.length) {
					runFns.shift()();
				}

				running = false;
			};

			var rafBatch = function rafBatch(fn, queue) {
				if (running && !queue) {
					fn.apply(this, arguments);
				} else {
					fns.push(fn);

					if (!waiting) {
						waiting = true;
						(document.hidden ? setTimeout : requestAnimationFrame)(run);
					}
				}
			};

			rafBatch._lsFlush = run;

			return rafBatch;
		}();

		var rAFIt = function rAFIt(fn, simple) {
			return simple ? function () {
				rAF(fn);
			} : function () {
				var that = this;
				var args = arguments;
				rAF(function () {
					fn.apply(that, args);
				});
			};
		};

		var throttle = function throttle(fn) {
			var running;
			var lastTime = 0;
			var gDelay = lazySizesConfig.throttleDelay;
			var rICTimeout = lazySizesConfig.ricTimeout;
			var run = function run() {
				running = false;
				lastTime = Date.now();
				fn();
			};
			var idleCallback = requestIdleCallback && rICTimeout > 49 ? function () {
				requestIdleCallback(run, { timeout: rICTimeout });

				if (rICTimeout !== lazySizesConfig.ricTimeout) {
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} : rAFIt(function () {
				setTimeout(run);
			}, true);

			return function (isPriority) {
				var delay;

				if (isPriority = isPriority === true) {
					rICTimeout = 33;
				}

				if (running) {
					return;
				}

				running = true;

				delay = gDelay - (Date.now() - lastTime);

				if (delay < 0) {
					delay = 0;
				}

				if (isPriority || delay < 9) {
					idleCallback();
				} else {
					setTimeout(idleCallback, delay);
				}
			};
		};

		//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
		var debounce = function debounce(func) {
			var timeout, timestamp;
			var wait = 99;
			var run = function run() {
				timeout = null;
				func();
			};
			var later = function later() {
				var last = Date.now() - timestamp;

				if (last < wait) {
					setTimeout(later, wait - last);
				} else {
					(requestIdleCallback || run)(run);
				}
			};

			return function () {
				timestamp = Date.now();

				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
			};
		};

		(function () {
			var prop;

			var lazySizesDefaults = {
				lazyClass: 'lazyload',
				loadedClass: 'lazyloaded',
				loadingClass: 'lazyloading',
				preloadClass: 'lazypreload',
				errorClass: 'lazyerror',
				//strictClass: 'lazystrict',
				autosizesClass: 'lazyautosizes',
				srcAttr: 'data-src',
				srcsetAttr: 'data-srcset',
				sizesAttr: 'data-sizes',
				//preloadAfterLoad: false,
				minSize: 40,
				customMedia: {},
				init: true,
				expFactor: 1.5,
				hFac: 0.8,
				loadMode: 2,
				loadHidden: true,
				ricTimeout: 0,
				throttleDelay: 125
			};

			lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

			for (prop in lazySizesDefaults) {
				if (!(prop in lazySizesConfig)) {
					lazySizesConfig[prop] = lazySizesDefaults[prop];
				}
			}

			window.lazySizesConfig = lazySizesConfig;

			setTimeout(function () {
				if (lazySizesConfig.init) {
					init();
				}
			});
		})();

		var loader = function () {
			var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

			var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

			var regImg = /^img$/i;
			var regIframe = /^iframe$/i;

			var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);

			var shrinkExpand = 0;
			var currentExpand = 0;

			var isLoading = 0;
			var lowRuns = -1;

			var resetPreloading = function resetPreloading(e) {
				isLoading--;
				if (!e || isLoading < 0 || !e.target) {
					isLoading = 0;
				}
			};

			var isVisible = function isVisible(elem) {
				if (isBodyHidden == null) {
					isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
				}

				return isBodyHidden || getCSS(elem.parentNode, 'visibility') != 'hidden' && getCSS(elem, 'visibility') != 'hidden';
			};

			var isNestedVisible = function isNestedVisible(elem, elemExpand) {
				var outerRect;
				var parent = elem;
				var visible = isVisible(elem);

				eLtop -= elemExpand;
				eLbottom += elemExpand;
				eLleft -= elemExpand;
				eLright += elemExpand;

				while (visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem) {
					visible = (getCSS(parent, 'opacity') || 1) > 0;

					if (visible && getCSS(parent, 'overflow') != 'visible') {
						outerRect = parent.getBoundingClientRect();
						visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
					}
				}

				return visible;
			};

			var checkElements = function checkElements() {
				var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
				var lazyloadElems = lazysizes.elements;

				if ((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {

					i = 0;

					lowRuns++;

					defaultExpand = !lazySizesConfig.expand || lazySizesConfig.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesConfig.expand;

					lazysizes._defEx = defaultExpand;

					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
					hFac = lazySizesConfig.hFac;
					isBodyHidden = null;

					if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
						currentExpand = preloadExpand;
						lowRuns = 0;
					} else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
						currentExpand = defaultExpand;
					} else {
						currentExpand = shrinkExpand;
					}

					for (; i < eLlen; i++) {

						if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
							continue;
						}

						if (!supportScroll) {
							unveilElement(lazyloadElems[i]);continue;
						}

						if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) {
							elemExpand = currentExpand;
						}

						if (beforeExpandVal !== elemExpand) {
							eLvW = innerWidth + elemExpand * hFac;
							elvH = innerHeight + elemExpand;
							elemNegativeExpand = elemExpand * -1;
							beforeExpandVal = elemExpand;
						}

						rect = lazyloadElems[i].getBoundingClientRect();

						if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesConfig.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
							unveilElement(lazyloadElems[i]);
							loadedSomething = true;
							if (isLoading > 9) {
								break;
							}
						} else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesConfig.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto'))) {
							autoLoadElem = preloadElems[0] || lazyloadElems[i];
						}
					}

					if (autoLoadElem && !loadedSomething) {
						unveilElement(autoLoadElem);
					}
				}
			};

			var throttledCheckElements = throttle(checkElements);

			var switchLoadingClass = function switchLoadingClass(e) {
				var elem = e.target;

				if (elem._lazyCache) {
					delete elem._lazyCache;
					return;
				}

				resetPreloading(e);
				addClass(elem, lazySizesConfig.loadedClass);
				removeClass(elem, lazySizesConfig.loadingClass);
				addRemoveLoadEvents(elem, rafSwitchLoadingClass);
				triggerEvent(elem, 'lazyloaded');
			};
			var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
			var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
				rafedSwitchLoadingClass({ target: e.target });
			};

			var changeIframeSrc = function changeIframeSrc(elem, src) {
				try {
					elem.contentWindow.location.replace(src);
				} catch (e) {
					elem.src = src;
				}
			};

			var handleSources = function handleSources(source) {
				var customMedia;

				var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

				if (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) {
					source.setAttribute('media', customMedia);
				}

				if (sourceSrcset) {
					source.setAttribute('srcset', sourceSrcset);
				}
			};

			var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
				var src, srcset, parent, isPicture, event, firesLoad;

				if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {

					if (sizes) {
						if (isAuto) {
							addClass(elem, lazySizesConfig.autosizesClass);
						} else {
							elem.setAttribute('sizes', sizes);
						}
					}

					srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
					src = elem[_getAttribute](lazySizesConfig.srcAttr);

					if (isImg) {
						parent = elem.parentNode;
						isPicture = parent && regPicture.test(parent.nodeName || '');
					}

					firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);

					event = { target: elem };

					addClass(elem, lazySizesConfig.loadingClass);

					if (firesLoad) {
						clearTimeout(resetPreloadingTimer);
						resetPreloadingTimer = setTimeout(resetPreloading, 2500);
						addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
					}

					if (isPicture) {
						forEach.call(parent.getElementsByTagName('source'), handleSources);
					}

					if (srcset) {
						elem.setAttribute('srcset', srcset);
					} else if (src && !isPicture) {
						if (regIframe.test(elem.nodeName)) {
							changeIframeSrc(elem, src);
						} else {
							elem.src = src;
						}
					}

					if (isImg && (srcset || isPicture)) {
						updatePolyfill(elem, { src: src });
					}
				}

				if (elem._lazyRace) {
					delete elem._lazyRace;
				}
				removeClass(elem, lazySizesConfig.lazyClass);

				rAF(function () {
					// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
					var isLoaded = elem.complete && elem.naturalWidth > 1;

					if (!firesLoad || isLoaded) {
						if (isLoaded) {
							addClass(elem, 'ls-is-cached');
						}
						switchLoadingClass(event);
						elem._lazyCache = true;
						setTimeout(function () {
							if ('_lazyCache' in elem) {
								delete elem._lazyCache;
							}
						}, 9);
					}
				}, true);
			});

			var unveilElement = function unveilElement(elem) {
				var detail;

				var isImg = regImg.test(elem.nodeName);

				//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
				var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
				var isAuto = sizes == 'auto';

				if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)) {
					return;
				}

				detail = triggerEvent(elem, 'lazyunveilread').detail;

				if (isAuto) {
					autoSizer.updateElem(elem, true, elem.offsetWidth);
				}

				elem._lazyRace = true;
				isLoading++;

				lazyUnveil(elem, detail, isAuto, sizes, isImg);
			};

			var onload = function onload() {
				if (isCompleted) {
					return;
				}
				if (Date.now() - started < 999) {
					setTimeout(onload, 999);
					return;
				}
				var afterScroll = debounce(function () {
					lazySizesConfig.loadMode = 3;
					throttledCheckElements();
				});

				isCompleted = true;

				lazySizesConfig.loadMode = 3;

				throttledCheckElements();

				addEventListener('scroll', function () {
					if (lazySizesConfig.loadMode == 3) {
						lazySizesConfig.loadMode = 2;
					}
					afterScroll();
				}, true);
			};

			return {
				_: function _() {
					started = Date.now();

					lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
					preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);

					addEventListener('scroll', throttledCheckElements, true);

					addEventListener('resize', throttledCheckElements, true);

					if (window.MutationObserver) {
						new MutationObserver(throttledCheckElements).observe(docElem, { childList: true, subtree: true, attributes: true });
					} else {
						docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
						docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
						setInterval(throttledCheckElements, 999);
					}

					addEventListener('hashchange', throttledCheckElements, true);

					//, 'fullscreenchange'
					['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function (name) {
						document[_addEventListener](name, throttledCheckElements, true);
					});

					if (/d$|^c/.test(document.readyState)) {
						onload();
					} else {
						addEventListener('load', onload);
						document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
						setTimeout(onload, 20000);
					}

					if (lazysizes.elements.length) {
						checkElements();
						rAF._lsFlush();
					} else {
						throttledCheckElements();
					}
				},
				checkElems: throttledCheckElements,
				unveil: unveilElement
			};
		}();

		var autoSizer = function () {
			var autosizesElems;

			var sizeElement = rAFIt(function (elem, parent, event, width) {
				var sources, i, len;
				elem._lazysizesWidth = width;
				width += 'px';

				elem.setAttribute('sizes', width);

				if (regPicture.test(parent.nodeName || '')) {
					sources = parent.getElementsByTagName('source');
					for (i = 0, len = sources.length; i < len; i++) {
						sources[i].setAttribute('sizes', width);
					}
				}

				if (!event.detail.dataAttr) {
					updatePolyfill(elem, event.detail);
				}
			});
			var getSizeElement = function getSizeElement(elem, dataAttr, width) {
				var event;
				var parent = elem.parentNode;

				if (parent) {
					width = getWidth(elem, parent, width);
					event = triggerEvent(elem, 'lazybeforesizes', { width: width, dataAttr: !!dataAttr });

					if (!event.defaultPrevented) {
						width = event.detail.width;

						if (width && width !== elem._lazysizesWidth) {
							sizeElement(elem, parent, event, width);
						}
					}
				}
			};

			var updateElementsSizes = function updateElementsSizes() {
				var i;
				var len = autosizesElems.length;
				if (len) {
					i = 0;

					for (; i < len; i++) {
						getSizeElement(autosizesElems[i]);
					}
				}
			};

			var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

			return {
				_: function _() {
					autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
					addEventListener('resize', debouncedUpdateElementsSizes);
				},
				checkElems: debouncedUpdateElementsSizes,
				updateElem: getSizeElement
			};
		}();

		var init = function init() {
			if (!init.i) {
				init.i = true;
				autoSizer._();
				loader._();
			}
		};

		lazysizes = {
			cfg: lazySizesConfig,
			autoSizer: autoSizer,
			loader: loader,
			init: init,
			uP: updatePolyfill,
			aC: addClass,
			rC: removeClass,
			hC: hasClass,
			fire: triggerEvent,
			gW: getWidth,
			rAF: rAF
		};

		return lazysizes;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)(module)))

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var focusHelper = __webpack_require__(113);

	/**
	 * Parses the html for a modal window
	 * @param {string} html - representing the body and footer of the modal window
	 *
	 * @return {Object} - Object with properties body and footer.
	 */
	function parseHtml(html) {
	    var $html = $('<div>').append($.parseHTML(html));

	    var body = $html.find('.choice-of-bonus-product');
	    var footer = $html.find('.modal-footer').children();

	    return {
	        body: body,
	        footer: footer
	    };
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @param {Object} data - data object used to fill in dynamic portions of the html
	 */
	function chooseBonusProducts(data) {
	    $('.modal-body').spinner().start();

	    if ($('#chooseBonusProductModal').length !== 0) {
	        $('#chooseBonusProductModal').remove();
	    }
	    var bonusUrl;
	    if (data.bonusChoiceRuleBased) {
	        bonusUrl = data.showProductsUrlRuleBased;
	    } else {
	        bonusUrl = data.showProductsUrlListBased;
	    }

	    var htmlString = '<!-- Modal -->' + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog choose-bonus-product-dialog" ' + 'data-total-qty="' + data.maxBonusItems + '"' + 'data-UUID="' + data.uuid + '"' + 'data-pliUUID="' + data.pliUUID + '"' + 'data-addToCartUrl="' + data.addToCartUrl + '"' + 'data-pageStart="0"' + 'data-pageSize="' + data.pageSize + '"' + 'data-moreURL="' + data.showProductsUrlRuleBased + '"' + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '    <span class="">' + data.labels.selectprods + '</span>' + '    <button type="button" class="close pull-right" data-dismiss="modal">' + '        <span aria-hidden="true">&times;</span>' + '        <span class="sr-only"> </span>' + '    </button>' + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer"></div>' + '</div>' + '</div>' + '</div>';
	    $('body').append(htmlString);
	    $('.modal-body').spinner().start();

	    $.ajax({
	        url: bonusUrl,
	        method: 'GET',
	        dataType: 'json',
	        success: function success(response) {
	            var parsedHtml = parseHtml(response.renderedTemplate);
	            $('#chooseBonusProductModal .modal-body').empty();
	            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
	            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
	            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
	            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
	            $('#chooseBonusProductModal').modal('show');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	module.exports = {

	    methods: {
	        editBonusProducts: function editBonusProducts(data) {
	            chooseBonusProducts(data);
	        }
	    },

	    chooseBonusProducts: chooseBonusProducts,

	    focusChooseBonusProductModal: function focusChooseBonusProductModal() {
	        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
	            $('#chooseBonusProductModal .close').focus();
	        });
	    },

	    onClosingChooseBonusProductModal: function onClosingChooseBonusProductModal() {
	        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
	        });
	    },

	    trapChooseBonusProductModalFocus: function trapChooseBonusProductModalFocus() {
	        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
	            var focusParams = {
	                event: e,
	                containerSelector: '#chooseBonusProductModal',
	                firstElementSelector: '.close',
	                lastElementSelector: '.add-bonus-products'
	            };
	            focusHelper.setTabNextFocus(focusParams);
	        });
	    },

	    selectBonusProduct: function selectBonusProduct() {
	        $(document).on('click', '.select-bonus-product', function () {
	            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
	            var pid = $(this).data('pid');
	            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
	            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
	            var totalQty = 0;
	            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
	                totalQty += $(this).data('qty');
	            });
	            totalQty += submittedQty;
	            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
	            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
	            if (totalQty <= maxPids) {
	                var selectedBonusProductHtml = '' + '<div class="selected-pid row" ' + 'data-pid="' + pid + '"' + 'data-qty="' + submittedQty + '"' + 'data-optionID="' + (optionID || '') + '"' + 'data-option-selected-value="' + (valueId || '') + '"' + '>' + '<div class="col-sm-11 col-9 bonus-product-name" >' + $choiceOfBonusProduct.find('.product-name').html() + '</div>' + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>' + '</div>';
	                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
	                $('.pre-cart-products').html(totalQty);
	                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	            } else {
	                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
	            }
	        });
	    },
	    removeBonusProduct: function removeBonusProduct() {
	        $(document).on('click', '.selected-pid', function () {
	            $(this).remove();
	            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
	            var count = 0;
	            if ($selected.length) {
	                $selected.each(function () {
	                    count += parseInt($(this).data('qty'), 10);
	                });
	            }

	            $('.pre-cart-products').html(count);
	            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	        });
	    },
	    enableBonusProductSelection: function enableBonusProductSelection() {
	        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
	            $('button.select-bonus-product', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);
	            var pid = response.product.id;
	            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
	        });
	    },
	    showMoreBonusProducts: function showMoreBonusProducts() {
	        $(document).on('click', '.show-more-bonus-products', function () {
	            var url = $(this).data('url');
	            $('.modal-content').spinner().start();
	            $.ajax({
	                url: url,
	                method: 'GET',
	                success: function success(html) {
	                    var parsedHtml = parseHtml(html);
	                    $('.modal-body').append(parsedHtml.body);
	                    $('.show-more-bonus-products:first').remove();
	                    $('.modal-content').spinner().stop();
	                },
	                error: function error() {
	                    $('.modal-content').spinner().stop();
	                }
	            });
	        });
	    },
	    addBonusProductsToCart: function addBonusProductsToCart() {
	        $(document).on('click', '.add-bonus-products', function () {
	            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
	            var queryString = '?pids=';
	            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
	            var pidsObject = {
	                bonusProducts: []
	            };

	            $.each($readyToOrderBonusProducts, function () {
	                var qtyOption = parseInt($(this).data('qty'), 10);

	                var option = null;
	                if (qtyOption > 0) {
	                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
	                        option = {};
	                        option.optionId = $(this).data('optionid');
	                        option.productId = $(this).data('pid');
	                        option.selectedValueId = $(this).data('option-selected-value');
	                    }
	                    pidsObject.bonusProducts.push({
	                        pid: $(this).data('pid'),
	                        qty: qtyOption,
	                        options: [option]
	                    });
	                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
	                }
	            });
	            queryString += JSON.stringify(pidsObject);
	            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
	            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
	            $.spinner().start();
	            $.ajax({
	                url: url + queryString,
	                method: 'POST',
	                success: function success(data) {
	                    $.spinner().stop();
	                    if (data.error) {
	                        $('#chooseBonusProductModal').modal('hide');
	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center"' + ' role="alert">' + data.errorMessage + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                        }, 3000);
	                    } else {
	                        $('.configure-bonus-product-attributes').html(data);
	                        $('.bonus-products-step2').removeClass('hidden-xl-down');
	                        $('#chooseBonusProductModal').modal('hide');

	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.minicart-quantity').html(data.totalQty);
	                        $('.add-to-cart-messages').append('<div class="alert alert-success add-to-basket-alert text-center"' + ' role="alert">' + data.msgSuccess + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                            if ($('.cart-page').length) {
	                                location.reload();
	                            }
	                        }, 1500);
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        });
	    }
	};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var base = __webpack_require__(118),
	    bonusProductHelpers = __webpack_require__(135),
	    detectDevice = __webpack_require__(111);

	function sizeIsSelectedFunc($elem) {
	    var isDisabled = $elem.data('is-disabled');
	    var isOneSizePLP = $elem.parents('.cc-content-button').prev('.color-swatches').find('.select-size').length <= 0;
	    var isOneSizePDP = $elem.parents('.pdp-col-description').find('.container-size-list').length <= 0;

	    if ((isDisabled === true || isDisabled === 'true') && (!isOneSizePLP || !isOneSizePDP)) {
	        // if button is disabled and prod is not a oneSize prod, no msg hint'll be shown
	        $elem.parents('.product-detail').find('.availability-msg .availability-msg-hint').removeClass('d-none'); // pdp size hint logic
	        $elem.parents('.container-tile-hover').find('.availability-msg .availability-msg-hint').removeClass('d-none'); // plp size hint logic
	        return false;
	    } else {
	        return true;
	    }
	}

	/**
	 * Retrieve product options
	 *
	 * @param {jQuery} $productContainer - DOM element for current product
	 * @return {string} - Product options and their selected values
	 */
	function getOptions($productContainer) {
	    var options = $productContainer.find('.product-option').map(function () {
	        var $elOption = $(this).find('.options-select');
	        var urlValue = $elOption.val();
	        var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
	        return {
	            optionId: $(this).data('option-id'),
	            selectedValueId: selectedValueId
	        };
	    }).toArray();

	    return JSON.stringify(options);
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @return {string} - The provided URL to use when adding a product to the cart
	 */
	function getAddToCartUrl() {
	    return $('.add-to-cart-url').val();
	}

	/**
	 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
	 * items with their selected variants
	 *
	 * @return {string[]} - List of selected bundle product item ID's
	 */
	function getChildProducts() {
	    var childProducts = [];
	    $('.bundle-item').each(function () {
	        childProducts.push({
	            pid: $(this).find('.product-id').text(),
	            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
	        });
	    });

	    return childProducts.length ? JSON.stringify(childProducts) : [];
	}

	/**
	 * Retrieve contextual quantity selector
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {jquery} - quantity selector DOM container
	 */
	function getQuantitySelector($el) {
	    return $el && $('.set-items').length ? $($el).closest('.product-detail').find('.quantity-select') : $('.quantity-select');
	}

	/**
	 * Retrieves the value associated with the Quantity pull-down menu
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {string} - value found in the quantity input
	 */
	function getQuantitySelected($el) {
	    return getQuantitySelector($el).val();
	}

	/**
	 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
	 * @param {string} response - ajax response from clicking the add to cart button
	 */
	function handlePostCartAdd(response) {
	    $('.minicart').trigger('count:update', response);
	    var messageType = response.error ? 'alert-danger' : 'alert-success';
	    // show add to cart toast
	    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
	        bonusProductHelpers.chooseBonusProducts(response.newBonusDiscountLineItem);
	    } else {
	        if ($('.add-to-cart-messages').length === 0) {
	            $('body').append('<div class="add-to-cart-messages"></div>');
	        }

	        $('.add-to-cart-messages').append('<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' + response.message + '</div>');

	        setTimeout(function () {
	            $('.add-to-basket-alert').remove();
	        }, 5000);
	    }
	}

	function showMiniCart(reportingURL) {
	    return new $.Deferred(function (deferred) {
	        base.miniCartReportingUrl(reportingURL);
	        $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	        var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	        if (minicartTimeout > 0) {
	            setTimeout(function () {
	                if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                    $('#closeMiniCartButton').click();
	                    $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                    deferred.resolve();
	                }

	                if ($('.js-header').hasClass('cc-header__tag__viewHeader') && window.isDesktop) {
	                    $('.js-header').removeClass('cc-header__tag__viewHeader');

	                    var $breadcrumbContainer = $('.js-breadcrumbContainer');
	                    var $filterWrapper = $('.cc-plp--filters--sticky');
	                    var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	                    var $categoryWrapperInner = $('.js-categoryPills');
	                    var $categoryWrapper = $('.cc-plp--categories--sticky');
	                    var heightFilter = 52;
	                    var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	                    $breadcrumbContainer.css('top', 0);
	                    if ($categoryWrapperInner.length > 0) {
	                        $categoryWrapper.css('top', 42 - breadcrumbHeigth);
	                        $filterWrapper.css('top', 117 + logoHeight - breadcrumbHeigth);
	                    } else {
	                        if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                            $filterWrapper.css('top', 0);
	                        } else {
	                            $filterWrapper.css('top', heightFilter - breadcrumbHeigth);
	                        }
	                    }
	                }
	            }, minicartTimeout);
	        }
	    }).promise();
	}

	module.exports = {
	    addToCart: function addToCart() {
	        $('.container').on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            e.stopImmediatePropagation();

	            var addToCartUrl;
	            var pid;
	            var pidsObj;
	            var setPids;

	            var $self = $(this);

	            var sizeIsSelected = sizeIsSelectedFunc($self);
	            if (!sizeIsSelected) {
	                return;
	            }

	            $('body').trigger('product:beforeAddToCart', this);

	            if ($('.set-items').length && $self.hasClass('add-to-cart-global')) {
	                setPids = [];

	                $('.product-detail').each(function () {
	                    if (!$self.hasClass('product-set-detail')) {
	                        setPids.push({
	                            pid: $self.find('.product-id').text(),
	                            qty: $self.find('.quantity-select').val(),
	                            options: getOptions($self)
	                        });
	                    }
	                });
	                pidsObj = JSON.stringify(setPids);
	            }

	            pid = base.getPidValue($self);

	            var $productContainer = $self.closest('.product-detail');
	            if (!$productContainer.length) {
	                $productContainer = $self.closest('.quick-view-dialog').find('.product-detail');
	            }

	            addToCartUrl = getAddToCartUrl();

	            var form = {
	                pid: pid,
	                pidsObj: pidsObj,
	                childProducts: getChildProducts(),
	                quantity: getQuantitySelected($self) || 1
	            };

	            if ($('body').hasClass('checkOutPage')) {
	                form.checkOutPage = true;
	            }

	            if (!$('.bundle-item').length) {
	                form.options = getOptions($productContainer);
	            }

	            //IN-AR TRY ON
	            var tryOnButton = $('.js-tryOn-button'),
	                dataEvent = {};

	            if (tryOnButton && tryOnButton.length > 0) {
	                var tryOnDesktopClick = 'false',
	                    tryOnMobileRedirect = 'false';
	                //If the device is Mobile/Tablet we will have the info of the Try-on usage in a specific div
	                if (detectDevice.detectMobile()) {
	                    tryOnMobileRedirect = $('.try-on-redirected').attr('data-used-try-on');
	                }
	                //If the device is Desktop we will have the info of the Try-on button clicked in the button itself
	                else {
	                        if (tryOnButton.length > 0) {
	                            tryOnDesktopClick = $('.js-tryOn-button').attr('data-ga-cliked');
	                        }
	                    }

	                form.tryOnDesktopClick = tryOnDesktopClick;
	                form.tryOnMobileRedirect = tryOnMobileRedirect;
	            }

	            // Analytics data
	            $('body').trigger('analytics:addToCartSubmitting', form);

	            $(this).trigger('updateAddToCartFormData', form);
	            if (addToCartUrl) {
	                $.ajax({
	                    url: addToCartUrl,
	                    method: 'POST',
	                    data: form,
	                    success: function success(data) {
	                        if (data.limitMessage || data.unavailableItemAdded) {
	                            $('#cartLimit-modal-body').text(data.limitMessage || '');
	                            $('#cartLimit-modal').modal('show');
	                            $.spinner().stop();
	                        } else {
	                            //normal behavior
	                            handlePostCartAdd(data);
	                            //update the minicart price total
	                            $('.js-header').removeClass('cc-header__tag__scrollDown');
	                            if ($('.minicartIconPrice').length > 0) {
	                                $('.minicartIconPrice').html(data.cart.totals.subTotal);
	                            }
	                            $('#analytics-cartInfo').data('value', data.cart && data.cart.totals && data.cart.totals.grandTotalDecimal);
	                            $('#analytics-cartInfo').data('couponsName', data.cart && data.cart.couponNamesString);
	                            $('body').trigger('product:afterAddToCart', data);

	                            //analytics event
	                            dataEvent.productID = pid;
	                            if (tryOnButton && tryOnButton.length > 0) {
	                                dataEvent.tryOnDesktopClick = tryOnDesktopClick;
	                                dataEvent.tryOnMobileRedirect = tryOnMobileRedirect;
	                            }

	                            $('body').trigger('analytics:addToCart', dataEvent);

	                            $.spinner().stop();
	                            base.miniCartReportingUrl(data.reportingURL);
	                            $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	                            var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	                            // if (minicartTimeout > 0) {
	                            //     setTimeout(function() {
	                            //         if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                            //             //close minicart only of is opened automatically from pdp or plp or wishlist
	                            //             $('#closeMiniCartButton').click();
	                            //             $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                            //         }
	                            //     }, minicartTimeout);
	                            // }

	                            var isCartPage = $('.cc-cart-container');

	                            showMiniCart(data.reportingURL).then(function () {
	                                if (isCartPage.length > 0) {
	                                    window.location.reload();
	                                }
	                            });
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }
	};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var bonusProductHelpers = __webpack_require__(135);
	var addToCartHelper = __webpack_require__(162);

	var PhotoSwipe = __webpack_require__(169);
	var PhotoSwipeUI_Default = __webpack_require__(170);
	var tryOnARHelper = __webpack_require__(171);

	var lastValidatedPincode = ' ';
	var lastPincodeInsered;

	window.slideToGo = 0;

	function initPdpOverlayImageCarousel() {
	    var $carouselCointainer = $('.js-pdp-overlay-main-carousel:not(.slick-initialized)');
	    $carouselCointainer.slick({
	        mobileFirst: true,
	        infinite: false,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        arrows: true,
	        dots: false,
	        fade: false,
	        focusOnSelect: true,
	        draggable: false,
	        swipe: false,
	        asNavFor: '.js-pdp-overlay-thumb',
	        responsive: [{
	            breakpoint: 1023.98,
	            settings: {
	                draggable: false,
	                swipe: false
	            }
	        }]
	    });
	}

	function triggerNextImagePDPEvent(prevIndex, nextIndex) {
	    if (prevIndex !== nextIndex) {
	        $(".cc-pdp-carousel-item").removeClass('js-analytics-nextImagePDP-active');
	        $(".cc-pdp-carousel-item[data-image-position=" + nextIndex + "]").addClass('js-analytics-nextImagePDP-active');
	        $('body').trigger('analytics:nextImagePDP');
	    }
	}

	function initPdpOverlayThumbs() {
	    var $carouselCointainer = $('.js-pdp-overlay-thumb:not(.slick-initialized)');
	    $carouselCointainer.slick({
	        mobileFirst: true,
	        infinite: false,
	        slidesToShow: 5,
	        slidesToScroll: 1,
	        asNavFor: '.js-pdp-overlay-main-carousel',
	        arrows: true,
	        dots: false,
	        focusOnSelect: true,
	        centerMode: false,
	        cssEase: 'linear',
	        speed: 0,
	        responsive: [{
	            breakpoint: 1023.98,
	            settings: {
	                vertical: true,
	                verticalSwiping: true
	            }
	        }]
	    });

	    $(document).on('keydown', function (e) {
	        if (e.key === "ArrowUp") {
	            $('.js-pdp-overlay-main-carousel').slick('slickPrev');
	        }
	        if (e.key === "ArrowDown") {
	            $('.js-pdp-overlay-main-carousel').slick('slickNext');
	        }

	        var $activeSlide = $('.slick-slide.slick-current.slick-active');
	        var carouselItem = $activeSlide.find('.cc-pdp-carousel-item');
	        var imagePosition = $(carouselItem).attr('data-image-position');
	        var prevIndex = window.slideToGo;
	        var nextIndex = parseInt(imagePosition);

	        $(".cc-pdp-carousel-item").removeClass('js-analytics-nextImagePDP-active');
	        triggerNextImagePDPEvent(prevIndex, nextIndex);
	    });
	}

	// Init slick pdp carousel
	function initPdpimagesCarousel() {
	    var pdpCarousel = $('.pdp-images-carousel');
	    pdpCarousel.not('.slick-initialized').slick({
	        infinite: true,
	        mobileFirst: true,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        arrows: false,
	        dots: true,
	        fade: false,
	        focusOnSelect: true,
	        prevArrow: '<button type="button" class="cc-pdp-images-carousel-arrow"><span class="icon-arrow-left" style="color:black"></span></button>',
	        nextArrow: '<button type="button" class="cc-pdp-images-carousel-arrow"><span class="icon-arrow-right" style="color:black"></span></button>',
	        responsive: [{
	            breakpoint: 767.98,
	            settings: "unslick"
	        }]
	    });
	    pdpCarousel.on('afterChange', function (event, slick, currentSlide) {
	        //needs to set class active to track item for open zoom on current slide
	        $(".cc-pdp-carousel-item").removeClass('active');
	        $(".cc-pdp-carousel-item[data-image-position=" + currentSlide + "]").addClass('active');
	    });

	    var startX = void 0,
	        startY = void 0,
	        isSwiping = false;

	    pdpCarousel.on('touchstart', function (event) {
	        startX = event.originalEvent.touches[0].clientX;
	        startY = event.originalEvent.touches[0].clientY;
	        isSwiping = false; // Reset swipe state
	    });

	    pdpCarousel.on('touchmove', function (event) {
	        var moveX = event.originalEvent.touches[0].clientX;
	        var moveY = event.originalEvent.touches[0].clientY;

	        var diffX = Math.abs(moveX - startX);
	        var diffY = Math.abs(moveY - startY);

	        // Check if user is swiping horizontally
	        if (diffX > diffY) {
	            isSwiping = true;
	            event.preventDefault(); // Stop vertical scrolling
	        }
	    }, { passive: false });

	    // Prevent vertical scrolling only during swipes
	    document.addEventListener('touchmove', function (event) {
	        if (isSwiping) {
	            event.preventDefault();
	        }
	    }, { passive: false });

	    $('body').on('shown.bs.modal', '#pdpImgModal', function () {
	        initPdpOverlayImageCarousel();
	        initPdpOverlayThumbs();

	        var indexImage = window.slideToGo;

	        setTimeout(function () {
	            $('.js-pdp-overlay-main-carousel').slick('slickGoTo', indexImage);
	            $('.js-pdp-overlay-thumb').slick('slickGoTo', indexImage);
	        }, 0);
	    });

	    $('.container').on('click', '.cc-pdp-carousel-item', function () {
	        var indexImage = $(this).attr('data-image-position');

	        triggerNextImagePDPEvent(window.slideToGo, parseInt(indexImage));
	        window.slideToGo = parseInt(indexImage);
	    });

	    $('.container').on('click', '.cc-container-zoom-icon', function () {
	        var indexImage = $('.cc-pdp-images-carousel .slick-current').length > 0 ? $('.cc-pdp-images-carousel .slick-current').attr('data-slick-index') : 0;

	        window.slideToGo = parseInt(indexImage);
	    });
	}
	$('.js-pdp-overlay-thumb').on('init', function (event, slick) {
	    slick.$slides.each(function (index, element) {
	        var $target = $(element).find('.cc-container-dis-picture');
	        if ($target.length) {
	            $target.addClass('thumb');
	        }
	    });
	});

	function callPhotoSwipe() {
	    var pswpElement = document.querySelectorAll('.pswp')[0];

	    var items = $("[data-zoom-images]").attr("data-zoom-images");
	    items = JSON.parse(items);

	    var options = {
	        barsSize: {
	            top: 0,
	            bottom: 'auto'
	        },
	        showHideOpacity: true,
	        pinchToClose: true,
	        closeOnVerticalDrag: false,
	        fullscreenEl: false,
	        captionEl: false,
	        counterEl: false,
	        shareEl: false,
	        arrowEl: false,
	        zoomEl: false,
	        closeEl: false,
	        index: $('.cc-pdp-carousel-item.active').data('image-position'), // open zoom on current slide
	        escKey: true,
	        clickToCloseNonZoomable: false,
	        history: false,
	        maxSpreadZoom: 3,
	        showAnimationDuration: 200,
	        hideAnimationDuration: 200,
	        closeOnScroll: false,
	        closeElClasses: ['button--close'],
	        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
	            return item.initialZoomLevel < 1 ? 1.5 : 2;
	        },
	        errorMsg: '<div class="pswp__error-msg">The image could not be loaded.</div>'
	    };

	    // Initializes and opens PhotoSwipe
	    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
	    gallery.init();
	    $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot').removeClass('slick-active');
	    $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot:nth-child(' + (gallery.getCurrentIndex() + 1) + ')').addClass('slick-active');

	    //function callback on event listner 'close'
	    gallery.listen('close', function () {
	        $('#zoom-target').css('display', 'none');
	    });

	    //function to close photoswipe
	    $('.pswp__button--close').on('click touchstart', function () {
	        gallery.close();
	    });

	    //function afterChange to update dots status
	    gallery.listen('afterChange', function () {
	        $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot').removeClass('slick-active');
	        $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot:nth-child(' + (gallery.getCurrentIndex() + 1) + ')').addClass('slick-active');
	    });

	    //function on close to update main carousel status
	    gallery.listen('close', function () {
	        $('.pdp-images-carousel').slick('slickGoTo', gallery.getCurrentIndex());
	    });

	    // go to pswp carousel item desktop function
	    $('.cc-zoom-target').find('.carousel-thumbnails .carousel-thumbnails-item').on('click', function () {
	        gallery.goTo($(this).data('slide-to'));
	        $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot').removeClass('slick-active');
	        $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot:nth-child(' + ($(this).data('slide-to') + 1) + ')').addClass('slick-active'); //needs to align mobile dots status on img change
	    });

	    // go to pswp carousel item mobile function
	    $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot').on('click', function () {
	        $('.cc-zoom-target').find('.pswp-slick-dots .cc-dot').removeClass('slick-active');
	        $(this).addClass('slick-active');
	        gallery.goTo($(this).data('slide-to'));
	    });
	}

	function zoomCarousel(pid) {
	    var isDragging = false;
	    $("[data-target='zoom-modal-ajax']").off();
	    $("[data-target='zoom-modal-ajax']").mousedown(function () {
	        $(window).mousemove(function () {
	            isDragging = true;
	            $(window).unbind("mousemove");
	        });
	    }).mouseup(function () {
	        var wasDragging = isDragging;
	        isDragging = false;
	        $(window).unbind("mousemove");
	        if (!wasDragging) {
	            var urlFinal;
	            if (pid) {
	                urlFinal = $('#zoom-target').attr('data-url-base-zoom') + pid;
	            } else {
	                urlFinal = $('#zoom-target').attr('data-url-zoom');
	            }
	            $("#zoom-target").css('display', 'block');
	            $.ajax({
	                url: urlFinal,
	                success: function success(result) {
	                    $("#zoom-target").html(result);
	                    $(document).on('gesturestart', function (e) {
	                        e.preventDefault();
	                    });
	                    callPhotoSwipe();
	                    setTimeout(function () {
	                        $('.cc-zoom-target').find('.cc-zoom-label').hide(); //needs hide zoom label after 3 sec
	                    }, 3000);
	                }
	            });
	        }
	    });

	    $('.js-pdp-overlay-main-carousel').on('beforeChange', function () {
	        var images = document.querySelectorAll('.js-pdp-overlay-main-carousel img');

	        images.forEach(function (image) {
	            image.removeAttribute('style');
	        });
	    });
	}

	// Call ajax zoom PDP images

	/**
	 * Dynamically creates Bootstrap carousel from response containing images
	 * @param {Object[]} imgs - Array of large product images,along with related information
	 * @param {jQuery} $productContainer - DOM element for a given product
	 */
	function createCarousel(imgs, videoID, $productContainer, pid, productVariationAtt) {
	    var carousel = $productContainer.find('.pdp-images-carousel');
	    var variantSelected = productVariationAtt && productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }) && productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }).values && productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }).values.find(function (v) {
	        return v.selected;
	    }) ? productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }).values.find(function (v) {
	        return v.selected;
	    }).id : "";

	    $(carousel).carousel('dispose');
	    carousel.slick('unslick');
	    $(carousel).empty();
	    for (var i = 0; i < imgs.length; i++) {
	        // Check if video URL is available and it's the second item
	        if (i === 1 && videoID) {
	            // Add video button
	            $('<button data-toggle="modal" data-target="#pdpImgModal" class="cc-pdp-carousel-item video" data-image-position="' + i + '" data-pid="' + pid + '" data-product-color="' + variantSelected + '">' + '<iframe class="b-lazyload_loading" src="https://player.vimeo.com/video/' + videoID + '?autoplay=1&loop=1&autopause=0&muted=1&background=1" width="100%" frameborder="0" allow="autoplay" allowfullscreen></iframe>' + '</button>').appendTo($(carousel));
	        }

	        // data-image-position meaning: If a video exists and the image index is higher than or equal to 1, increment the index by 1 (to place the video in the second position),
	        // otherwise, use the original index for the image
	        $('<button data-toggle="modal" data-target="#pdpImgModal" class="cc-pdp-carousel-item ' + (i === 0 ? 'active' : '') + '" data-image-position="' + (videoID && i >= 1 ? i + 1 : i) + '" data-pid="' + pid + '" data-product-color="' + variantSelected + '">' + imgs[i].templateResizedDevices + '</button>').appendTo($(carousel));
	    }
	    $($(carousel).find('.cc-pdp-carousel-item')).first().addClass('active');
	    initPdpimagesCarousel();
	    zoomCarousel(pid);
	}

	/**
	 * Dynamically creates thumbnails carousel from response containing images
	 * @param {Object[]} product - Product object
	 * @param {jQuery} $productContainer - DOM element for a given product
	 * @param {Boolean} isRotationAvailableAggr - bool to indicate if the product has the rotation available
	 */
	function createThumbnailsCarousel(product, $productContainer, isRotationAvailableAggr) {
	    var carousel = $productContainer.find('.pdp-carousel-thumbnails'),
	        imgs = product.images.large,
	        template = '';

	    carousel.addClass('invisible');
	    carousel.slick('unslick');

	    for (var i = 0; i < imgs.length; i++) {
	        template += '<li data-slide-to="' + i + '"class="cc-pdp-thumbnails-carousel-item">' + '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" ' + 'data-lazy="' + imgs[i].resizedURL + '" ' + 'alt="' + imgs[i].alt + '"/></li>';

	        //If isRotationAvailable, put only the first image
	        if (isRotationAvailableAggr) {
	            break;
	        }
	    }

	    carousel.html(template);
	    setTimeout(function () {
	        carousel.removeClass('invisible');
	    }, 300);
	}

	function deliveryAccordionAjax() {
	    $(".b-accordion__item #accordion-delivery-instruction").click(function () {
	        var destination = $('.b-accordion__item .b-accordion__content#destination-block');
	        var urlAssetID = destination.attr('data-delivery-asset-id');
	        if (!destination.hasClass('ajax-called')) {
	            destination.addClass('ajax-called');
	            $.ajax({
	                url: urlAssetID,
	                success: function success(result) {
	                    destination.html(result);
	                }
	            });
	        }
	    });
	}

	function sizeGuideModalReplace($sizeModal) {
	    $sizeModal.find('tr:not(.js-dont-split) td').each(function (i, v) {
	        var self = $(v);
	        if (self.text().indexOf('-') >= 0) {
	            var replacedText = self.text().replace('-', '${WrapTextHere}-${WrapTextHere}');
	            self.text(replacedText);
	            var replacedHtml = self.html().replace('${WrapTextHere}-${WrapTextHere}', '<br>-<br>');
	            self.html(replacedHtml);
	        }
	    });
	}

	function sizeGuideModalAjax() {
	    var modal = $('#destination-size-guide-modal');
	    var $sizeModal = $('#size-modal');
	    $("#size-guide-asset").click(function (e) {
	        e.preventDefault();
	        var $sizeAssetButton = $(this),
	            destination = $('#destination-size-guide-modal .content');
	        var urlFinal = $sizeAssetButton.attr('href');
	        if (!destination.hasClass('ajax-called')) {
	            destination.addClass('ajax-called');
	            $.ajax({
	                url: urlFinal,
	                success: function success(result) {
	                    if (result.assetNotFound) {
	                        // no size asset available
	                        $sizeModal.modal("hide");
	                        var $sizeAssetContainer = $sizeAssetButton.closest('.size-guide-asset-container');
	                        // remove the modal from the dom
	                        $sizeAssetContainer.find('#destination-size-guide-modal').remove();
	                        // remove the link from the dom
	                        $sizeAssetButton.remove();
	                        // display the error message
	                        $sizeAssetContainer.find('.js-error-size-guide').removeClass('d-none');
	                    } else {
	                        // success
	                        destination.html(result);
	                        modal.removeClass('d-none');
	                        $sizeModal.modal();
	                        sizeGuideModalReplace($sizeModal);
	                    }
	                }
	            });
	        } else {
	            $sizeModal.modal();
	            sizeGuideModalReplace($sizeModal);
	        }
	    });
	}

	function updateBreadcrumbs(breadcrumbs, $productContainer) {
	    if ($productContainer.find('.b-product-info')) {

	        var template = "";
	        if (breadcrumbs) {
	            breadcrumbs.forEach(function (obj, i) {
	                if (i === breadcrumbs.length - 1) {
	                    template += '<li class="cc-breadcrumb "><a href="' + obj.url + '" class="cc-breadcrumb--last">' + obj.htmlValue + '</a></li>';
	                } else {
	                    template += '<li class="cc-breadcrumb js-parentCategory"><a href="' + obj.url + '">' + obj.htmlValue + '</a><span class="cc-breadcrumb__icon">/</span></li>';
	                }
	            });
	        }

	        var target = $('[data-target="breadcrumbs"]');
	        target.html(template);
	    }
	}

	/**
	 * Updates the product Details DOM elements post Ajax call
	 * @param {Object[]} customAttributes -
	 * @param {jQuery} $productContainer - DOM container for a given product
	 */
	function updateProductInfo(customAttributes, $productContainer) {
	    if ($productContainer.find('.b-product-info')) {

	        var getTemplateMaterialsData = function getTemplateMaterialsData(materialsData) {

	            var outputTemplate = "";
	            materialsData.forEach(function (elem) {
	                outputTemplate += '<li class="b-pdp__material-item cc-pdp-material-item"><div class="b-pdp__material-type cc-pdp__material-type"><img src="' + elem.position['icon'] + '"alt="' + elem.position.description + '" />' + '<span class="b-pdp__text">' + elem.position.description + '</span>' + '</div><span class="b-pdp__material-info cc-pdp__material-info"><img alt="' + elem.material.description + '"src="' + elem.material['icon'] + '" title="' + elem.material.description + '" />' + '<span class="b-pdp__text">' + elem.material.description + '</span>' + '</span></li>';
	            });

	            return outputTemplate;
	        };

	        customAttributes['productMaterialHTML'] = getTemplateMaterialsData(customAttributes['productMaterialsData']);
	        $(".b-product-info span[data-target]").each(function () {
	            var element = $(this);
	            var valueKey = element.attr("data-target");
	            if (!customAttributes[valueKey]) {
	                $(this).parent().addClass('d-none');
	            } else {
	                $(this).parent().removeClass('d-none');
	            }

	            if (valueKey === 'productMaterialHTML') {
	                element.find("ul.b-pdp__material-list").html(customAttributes[valueKey]);
	            } else if (valueKey !== "") {
	                element.html(customAttributes[valueKey]);
	            }
	        });
	    }
	}

	//Modify the wishlist-add button like normal behavior, if the product can be added or not
	function handleWishlistButtonInTile($element, isInWishlist, isAddToCartDisabled) {

	    var $button = $element;
	    var $spanAdd = $button.find('span.wishlist-content-add');
	    var $spanRemove = $button.find('span.wishlist-content-remove');

	    if (!isAddToCartDisabled) {
	        if (isInWishlist) {
	            $button.addClass('to-remove');
	            $button.removeClass('to-add');

	            $spanAdd.addClass('d-none');
	            $spanRemove.removeClass('d-none');
	        } else {
	            $button.addClass('to-add');
	            $button.removeClass('to-remove');

	            $spanRemove.addClass('d-none');
	            $spanAdd.removeClass('d-none');
	        }
	    }
	}

	//This function checks if the pid in argument is included in the array of products' PID in wishlist
	function checkInWishlist(pid, isAddToCartDisabled) {
	    var $wishlistButton = $('button.add-to-wish-list');
	    $wishlistButton.removeClass('to-add to-remove');

	    var productArr = window.ProductsInWishlist;
	    if (!productArr) {
	        return false;
	    }

	    if (productArr.indexOf(pid) > -1) {
	        handleWishlistButtonInTile($wishlistButton, true, isAddToCartDisabled);
	    } else {
	        handleWishlistButtonInTile($wishlistButton, false, isAddToCartDisabled);
	    }
	}

	function updateBadge(badge) {
	    var message = badge.markup || "";
	    if (message === "") {
	        $('.cc-pdp-col-description__wrp .cc-product-label__badge').remove();
	        return;
	    }
	    if ($('.cc-pdp-col-description__wrp .cc-product-label__badge').length === 0) {
	        $('.cc-pdp-col-description__wrp .cc-product-label').append('<span class="cc-product-label__badge ' + badge.cssClass + '"></span>');
	    }
	    var selector = $('.cc-pdp-col-description__wrp .cc-product-label__badge');
	    var template = '<span class="cc-product-label__badge__style">' + message + '</span>';

	    selector.html(template);
	}

	/**
	 * Updates the class list of the `<img>` elemnt of the brand logo based on its aspect ratio
	 * @param {jQuery} imgLogo - `<img>` DOM Element of a brand logo.
	 */
	function updateBrandLogoSize(imgLogo) {
	    var BRAND_LOGO_THRESHOLD = 4.5;
	    if (imgLogo.naturalWidth / imgLogo.naturalHeight >= BRAND_LOGO_THRESHOLD) {
	        imgLogo.classList.remove('short-logo');
	        imgLogo.classList.add('long-logo');
	    } else {
	        imgLogo.classList.remove('long-logo');
	        imgLogo.classList.add('short-logo');
	    }
	}

	/**
	 * Updates the availability status in the Product Detail Page
	 *
	 * @param {Object} response - Ajax response object after an
	 *                            attribute value has been [de]selected
	 * @param {jQuery} $productContainer - DOM element for a given product
	 */
	function updateAvailability(response, $productContainer) {
	    var availabilityValue = '';
	    var availabilityMessages = response.product.availability.messages;
	    var availabilityHurryUp = response.product.availability.levelsResult.hurryUp;
	    var sizeNumbers = response.product.variationAttributes[1].values.length;
	    if (!response.product.readyToOrder || sizeNumbers === 1 && !response.product.variationAttributes[1].values[0].selectable) {
	        var notReadyMessage = response.product.productType === 'master' ? response.resources.info_selectColorSize : response.resources.info_selectforstock;
	        availabilityValue = '<li><div class="b-pdp__availability availability-msg-hint d-none">' + notReadyMessage + '</div></li>';
	    } else {
	        availabilityMessages.forEach(function (message) {
	            availabilityValue += '<li><div class=' + (availabilityHurryUp ? 'b-pdp__availability' : '') + '>' + message + '</div></li>';
	        });
	    }

	    $($productContainer).trigger('product:updateAvailability', {
	        product: response.product,
	        $productContainer: $productContainer,
	        message: availabilityValue,
	        resources: response.resources
	    });
	}

	/**
	 * Generates html for product attributes section
	 *
	 * @param {array} attributes - list of attributes
	 * @return {string} - Compiled HTML
	 */
	function getAttributesHtml(attributes) {
	    if (!attributes) {
	        return '';
	    }

	    var html = '';

	    attributes.forEach(function (attributeGroup) {
	        if (attributeGroup.ID === 'mainAttributes') {
	            attributeGroup.attributes.forEach(function (attribute) {
	                html += '<div class="attribute-values">' + attribute.label + ': ' + attribute.value + '</div>';
	            });
	        }
	    });

	    return html;
	}

	/**
	 * Process the attribute values for an attribute that has image swatches
	 *
	 * @param {Object} attr - Attribute
	 * @param {string} attr.id - Attribute ID
	 * @param {Object[]} attr.values - Array of attribute value objects
	 * @param {string} attr.values.value - Attribute coded value
	 * @param {string} attr.values.url - URL to de/select an attribute value of the product
	 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
	 *     selected.  If there is no variant that corresponds to a specific combination of attribute
	 *     values, an attribute may be disabled in the Product Detail Page
	 * @param {jQuery} $productContainer - DOM container for a given product
	 * @param {Object} msgs - object containing resource messages
	 */
	function processSwatchValues(attr, $productContainer, msgs) {
	    var targetValue = $('.attribute .color-selected .color-value');

	    var $allSwatches = $('.attribute .swatches-container .color-attribute');
	    var urlButtonDefault = $allSwatches.first().attr('data-url');

	    attr.values.forEach(function (attrValue) {
	        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
	        var $swatchButton = $attrValue.parent();

	        if (attrValue.selected) {
	            $swatchButton.addClass('selected');
	            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);

	            //display the color selected in color-value <span>
	            $('.attribute .color-selected .color-value').html(attrValue.displayValue);
	        } else {
	            $attrValue.removeClass('selected');
	            $swatchButton.removeClass('selected');
	            $attrValue.siblings('.selected-assistive-text').empty();
	        }

	        // now is allowed select every color, if there isn't any variant returns a variationGroup link
	        if (attrValue.url) {
	            $swatchButton.attr('data-url', attrValue.url);
	        } else {
	            if (urlButtonDefault && !$swatchButton.hasClass('unselectable')) {
	                //if a variation group is unselectable, use a regex to remove from params the 'size' and put 'color id' of variationGroup
	                // to replace the url of a variant(sku) to a variationGroup
	                var urlToVariationGroup = urlButtonDefault;
	                var baseUrl = urlToVariationGroup.split('?')[0];
	                var paramsArrToSplit = urlToVariationGroup.split('?')[1].split('&');
	                var paramsToString = [];
	                paramsArrToSplit.forEach(function (element) {
	                    var result = element;
	                    var key;
	                    if (element.indexOf('size') > -1) {
	                        key = element.split('=')[0];
	                        result = key + '=';
	                    } else if (element.indexOf('color') > -1) {
	                        key = element.split('=')[0];
	                        var value = attrValue.value;
	                        result = key + '=' + value;
	                    }
	                    paramsToString.push(result);
	                });
	                var finalURL = baseUrl + '?' + paramsToString.join('&');
	                $swatchButton.attr('data-url', finalURL);
	                //the regex below is not good for safari browser
	                // urlToVariationGroup = urlToVariationGroup.replace(/(?<=size=)(.*?)((?=&)|(?=$))/, '');
	                // urlToVariationGroup = urlToVariationGroup.replace(/(?<=color=)(.*?)((?=&)|(?=$))/, attrValue.value);
	                // $swatchButton.attr('data-url', urlToVariationGroup);
	            }
	        }
	    });
	}

	/**
	 * Get size formatted that can be useful for a nice fraction number reprasantation
	 * example: 38 2/3  =>  { base: '38', fraction: '2/3' }
	 *
	 * @param {string} size
	 * @return {Object}
	 */
	function getFractionalizedProductSize(size) {
	    var out = {
	        base: size,
	        fraction: ''
	    };

	    // size is either null or blank
	    if (!(size && size.length > 0)) {
	        out.base = '';
	        return out;
	    }

	    var matches = size.match(/(.*)([0-9]+\/[0-9]+)/);
	    if (matches && matches.length === 3) {
	        out.base = matches[1];
	        out.fraction = matches[2];
	    }

	    // trim both
	    out.base = out.base && out.base.length > 0 ? out.base.trim() : out.base;
	    out.fraction = out.fraction && out.fraction.length > 0 ? out.fraction.trim() : out.fraction;

	    return out;
	}

	/**
	 * Get size formatted for a nice fraction number reprasantation
	 * example: 38 2/3  =>  38<span class="frac">2/3</span>
	 *
	 * @param {string} size
	 * @return {string}
	 */
	function formatProductSizeForFracStyling(size) {
	    var obj = getFractionalizedProductSize(size);
	    var out = obj.base;

	    if (obj && obj.fraction && obj.fraction.length > 0) {
	        out = out + "<span class='frac'>" + obj.fraction + "</span>";
	    }

	    return out;
	}

	/**
	 * Create the tempate with the selectable sizes
	 *
	 * @param {Object} attr - Attribute
	 */
	function createSizesTemplate(attr, backinstockActiveForProduct, backInStockForPdp, productId) {
	    var targetTileSizeList = $("#size-ul-list"),
	        hideOutOfStockSwatches = targetTileSizeList.attr('data-hide-out-of-stock-swatches') === 'true',
	        template = '',
	        lowStockTreshold = targetTileSizeList.attr('data-low-stock-treshold');

	    if (attr.values.length > 1) {
	        attr.values.forEach(function (attrValue) {
	            if (!attrValue.selectable && hideOutOfStockSwatches) {
	                return;
	            }
	            var classToAssign = '';
	            var isModal = false;
	            if (!attrValue.selectable && (!backInStockForPdp || !backinstockActiveForProduct)) {
	                classToAssign = 'unselectable';
	            } else if (!attrValue.selectable && backInStockForPdp && backinstockActiveForProduct) {
	                classToAssign = 'b-backInStock';
	                isModal = true;
	            }

	            //IT - localized sizes
	            var backInStockMessage = $('#back-in-stock-container').data('backinstock-msg');
	            var localizedSize = attrValue.localizedSize ? attrValue.localizedSize : attrValue.displayValue;
	            var localizedSizeFormatted = formatProductSizeForFracStyling(localizedSize);
	            var pid = attrValue.backInStockID ? attrValue.backInStockID : productId;
	            if (!attrValue.selectable) {
	                template += '<li class=\'single-size-tile cc-single-size-tile js-analytics-selectSizePDP ' + (attrValue.selected ? 'selected' : '') + ' ' + classToAssign + '\'\n                data-display-value=\'' + localizedSize + '\'\n                data-attr-value=\'' + attrValue.value + '\'\n                data-toggle=\'' + (!isModal ? '' : 'modal') + '\'\n                data-pid=\'' + pid + '\'\n                data-target=\'' + (!isModal ? '' : '#backInStockModal') + '\'>\n                ' + localizedSizeFormatted + '\n                ' + (isModal ? '<svg class="iconClassCommon cc-backInStock-icon"> <use href="/on/demandware.static/Sites-bata-it-sfra-Site/-/it_IT/v1725549231798/images/sprite/sprite.svg#icon-bell"></use></svg>' : '') + '\n                <div class="cc-back-in-stock__message h-hidden-small h-hidden-medium">\n                <p class="cc-back-in-stock__message__text">' + backInStockMessage + '</p>\n                </div>\n                </li>';
	            } else {
	                template += '<li class=\'single-size-tile cc-single-size-tile js-analytics-selectSizePDP ' + (attrValue.selected ? 'selected' : '') + ' ' + (attrValue.selectable ? 'selectable' : 'unselectable') + ' ' + (parseInt(attrValue.allocation) <= parseInt(lowStockTreshold) ? 'low-stock' : '') + '\'\n                                data-display-value=\'' + localizedSize + '\'\n                                data-pid=\'' + pid + '\'\n                                data-attr-value=\'' + attrValue.value + '\'\n                                value=\'' + attrValue.url + '\'>' + localizedSizeFormatted + '</li>';
	            }
	            if (attrValue.selected) {
	                $('.attribute .size-selected .size-value').html(localizedSize);
	            }
	        });
	    } else if (attr.values.length === 1) {
	        if (!attr.values[0].selectable && hideOutOfStockSwatches) {
	            return;
	        }
	        var classToAssign = '';
	        var isModal = false;
	        if (!attr.values[0].selectable && backInStockForPdp && backinstockActiveForProduct) {
	            classToAssign = 'b-backInStock';
	            isModal = true;
	        }

	        //IT - localized sizes
	        var backInStockMessage = $('#back-in-stock-container').data('backinstock-msg');
	        var localizedSize = attr.values[0].localizedSize ? attr.values[0].localizedSize : attr.values[0].displayValue;
	        var localizedSizeFormatted = formatProductSizeForFracStyling(localizedSize);
	        if (!attr.values[0].selectable && isModal) {
	            template += '<li class=\'single-size-tile cc-single-size-tile js-analytics-selectSizePDP ' + (attr.values[0].selected ? 'selected' : '') + ' ' + classToAssign + '\'\n            data-display-value=\'' + localizedSize + '\'\n            data-attr-value=\'' + attr.values[0].value + '\'\n            data-toggle=\'' + (!isModal ? '' : 'modal') + '\'\n            data-pid=\'' + (attr.values[0].backInStockID ? attr.values[0].backInStockID : productId) + '\'\n            data-target=\'' + (!isModal ? '' : '#backInStockModal') + '\'>\n            ' + localizedSizeFormatted + '\n            ' + (isModal ? '<svg class="iconClassCommon cc-backInStock-icon"> <use href="/on/demandware.static/Sites-bata-it-sfra-Site/-/it_IT/v1725549231798/images/sprite/sprite.svg#icon-bell"></use></svg>' : '') + '\n            <div class="cc-back-in-stock__message h-hidden-small h-hidden-medium">\n                <p class="cc-back-in-stock__message__text">' + backInStockMessage + '</p>\n            </div>\n            </li>';
	        }
	        if (attr.values[0].selected) {
	            $('.attribute .size-selected .size-value').html(localizedSize);
	        }
	    }
	    targetTileSizeList.html(template);
	}

	/**
	 * Process attribute values associated with an attribute that does not have image swatches
	 *
	 * @param {Object} attr - Attribute
	 * @param {string} attr.id - Attribute ID
	 * @param {Object[]} attr.values - Array of attribute value objects
	 * @param {string} attr.values.value - Attribute coded value
	 * @param {string} attr.values.url - URL to de/select an attribute value of the product
	 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
	 *     selected.  If there is no variant that corresponds to a specific combination of attribute
	 *     values, an attribute may be disabled in the Product Detail Page
	 * @param {jQuery} $productContainer - DOM container for a given product
	 */
	function processNonSwatchValues(attr, $productContainer, backinstockActiveForProduct, backInStockForPdp, productId) {
	    var $attr = '[data-attr="' + attr.id + '"]';
	    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
	    $defaultOption.attr('value', attr.resetUrl);

	    var targetValue = $('.attribute .size-selected .size-value');

	    createSizesTemplate(attr, backinstockActiveForProduct, backInStockForPdp, productId);
	}

	/**
	 * Routes the handling of attribute processing depending on whether the attribute has image
	 *     swatches or not
	 *
	 * @param {Object} attrs - Attribute
	 * @param {string} attr.id - Attribute ID
	 * @param {jQuery} $productContainer - DOM element for a given product
	 * @param {Object} msgs - object containing resource messages
	 */
	function updateAttrs(attrs, $productContainer, msgs, backinstockActiveForProduct, backInStockForPdp, productId) {
	    // Currently, the only attribute type that has image swatches is Color.
	    var attrsWithSwatches = ['color'];

	    attrs.forEach(function (attr) {
	        if (attrsWithSwatches.indexOf(attr.id) > -1) {
	            processSwatchValues(attr, $productContainer, msgs);
	        } else {
	            processNonSwatchValues(attr, $productContainer, backinstockActiveForProduct, backInStockForPdp, productId);
	        }
	    });
	}

	/**
	 * Dynamically creates Bootstrap carousel from response containing images
	 * @param {Object[]} imgs - Array of large product images,along with related information
	 * @param {jQuery} $productContainer - DOM element for a given product
	 */
	function createZoomCarousel(imgs, videoID, $productContainer, productId, productVariationAtt) {
	    $productContainer.empty();
	    $productContainer.append('<div class="cc-image-overlay__main-carousel js-pdp-overlay-main-carousel"></div>');
	    $productContainer.append('<div class="cc-image-overlay__thumb js-pdp-overlay-thumb"></div>');
	    var variantSelected = productVariationAtt && productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }) && productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }).values && productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }).values.find(function (v) {
	        return v.selected;
	    }) ? productVariationAtt.find(function (e) {
	        return e.attributeId === "color";
	    }).values.find(function (v) {
	        return v.selected;
	    }).id : "";

	    var carousel = $productContainer.find('.js-pdp-overlay-main-carousel');
	    var thumbCarousel = $productContainer.find('.js-pdp-overlay-thumb');

	    for (var i = 0; i < imgs.length; i++) {
	        try {
	            // Insert video at the second position if available
	            if (i === 1 && videoID) {
	                // Add video to the main carousel
	                $('<div class="cc-pdp-carousel-item" data-image-position="' + (i + 1) + '" data-color-variant=\'' + variantSelected + '\' data-product-id=\'' + productId + '\'>' + '<iframe class="b-lazyload_loading" src="https://player.vimeo.com/video/' + videoID + '?autoplay=1&loop=1&autopause=0&muted=1&background=1" width="100%" frameborder="0" allow="autoplay" allowfullscreen></iframe>' + '</div>').appendTo($(carousel));

	                // Add video to the thumbnail carousel
	                $('<div class="cc-pdp-carousel-item" data-image-position="' + (i + 1) + '" data-color-variant=\'' + variantSelected + '\' data-product-id=\'' + productId + '\'>' + '<iframe class="b-lazyload_loading" src="https://player.vimeo.com/video/' + videoID + '?autoplay=1&loop=1&autopause=0&muted=1&background=1" width="100%" frameborder="0" allow="autoplay" allowfullscreen></iframe>' + '</div>').appendTo($(thumbCarousel));
	            }

	            // Add images to the main carousel
	            $('<div class="cc-pdp-carousel-item" data-image-position="' + (videoID && i >= 1 ? i + 2 : i + 1) + '" data-color-variant=\'' + variantSelected + '\' data-product-id=\'' + productId + '\'>' + '<div class="cc-container-dis-picture">' + '<img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + imgs[i].index + '" title="' + imgs[i].title + '" itemprop="image" />' + '</div>' + '</div>').appendTo($(carousel));

	            // Add images to the thumbnail carousel
	            $('<div class="cc-pdp-carousel-item" data-image-position="' + (videoID && i >= 1 ? i + 2 : i + 1) + '" data-color-variant=\'' + variantSelected + '\' data-product-id=\'' + productId + '\'>' + '<img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + imgs[i].index + '" title="' + imgs[i].title + '" itemprop="image" />' + '</div>').appendTo($(thumbCarousel));
	        } catch (error) {
	            // eslint-disable-next-line no-console
	            console.log('Error processing image or video for index ' + i + ':', error);
	        }
	    }
	}

	/**
	 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
	 * @param {Object} response - response from Ajax call
	 * @param {Object} response.product - Product object
	 * @param {string} response.product.id - Product ID
	 * @param {Object[]} response.product.variationAttributes - Product attributes
	 * @param {Object[]} response.product.images - Product images
	 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
	 *     attributes have been selected.  Used partially to
	 *     determine whether the Add to Cart button can be enabled
	 * @param {} response.resources
	 * @param {} response.breadcrumbs
	 * @param {Boolean} response.product.tryOnAttributes.rotation.isRotationAvailable - Flag that indicates if the rotation feature
	 *      is enabled for the selected variation group
	 * @param {Boolean} response.product.tryOnAttributes.augmentedReality.availableTryOnAR - Flag that indicates if the try on feature
	 *      is enabled for the selected variation group
	 * @param {String} response.product.tryOnAttributes.augmentedReality.linkARView - Link of the Try On AR site.
	 *      Used for the QR code or redirection
	 * @param {Boolean} response.product.tryOnAttributes.augmentedReality.isAREnabled - Flag that indicates if the Try On feature is enabled
	 *      in the specific site
	 * @param {jQuery} $productContainer - DOM element for a given product.
	 */
	// eslint-disable-next-line complexity
	function handleVariantResponse(response, $productContainer) {
	    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
	    var isVaraint;
	    if (response.product.variationAttributes) {
	        updateAttrs(response.product.variationAttributes, $productContainer, response.resources, response.backinstockActiveForProduct, response.backInStockForPdp, response.product.id);
	        isVaraint = response.product.productType === 'variant';
	        if (isChoiceOfBonusProducts && isVaraint) {
	            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);

	            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
	        }
	    }

	    var productVariation = response.product,
	        isRotationAvailable = false,
	        isRotationEnabled = false,
	        tryOnArIframeLink;

	    if (response.product && response.product.tryOnAttributes && response.product.tryOnAttributes.rotation) {
	        isRotationEnabled = response.product.tryOnAttributes.rotation.isRotationEnabled;
	        isRotationAvailable = response.product.tryOnAttributes.rotation.isRotationAvailable;
	        tryOnArIframeLink = response.product.tryOnAttributes.rotation.ARtryonIframeLink;
	    }

	    if (isRotationEnabled) {
	        // Update primary images
	        // If rotation is available, put only the iframe with the rotating image
	        if (isRotationAvailable && tryOnArIframeLink) {
	            $('.js-ar-try-on-iframe-container').removeClass('d-none');
	            $('.js-ar-try-on-iframe-container').empty().html(productVariation.iframeArTryOnHtml);
	            $productContainer.find('.pdp-images-carousel').addClass('d-none');
	            $('.js-zoom-icon').addClass('d-none');
	        } else {
	            $('.js-ar-try-on-iframe-container').addClass('d-none');
	            $('.js-ar-try-on-iframe-container').empty();
	            $productContainer.find('.pdp-images-carousel').removeClass('d-none');
	            $('.js-zoom-icon').removeClass('d-none');
	            createCarousel(productVariation.images.large, productVariation.custom.videoID, $productContainer, response.product.id, response.product.variationAttributes);
	        }
	    } else {
	        createCarousel(productVariation.images.large, productVariation.custom.videoID, $productContainer, response.product.id, response.product.variationAttributes);
	    }

	    var $productZoomContainer = $('.cc-image-overlay__wrp');
	    createZoomCarousel(productVariation.images.large, productVariation.custom.videoID, $productZoomContainer, response.product.id, response.variationAttributes);

	    // Update thumbnails PDP images, if isRotationAvailable put only the first image
	    var isRotationAvailableAggr = isRotationEnabled && isRotationAvailable && tryOnArIframeLink;
	    createThumbnailsCarousel(productVariation, $productContainer, isRotationAvailableAggr);

	    // Update breadcrumbs PDP
	    var breadcrumbs = response.breadcrumbs;
	    updateBreadcrumbs(breadcrumbs, $productContainer);

	    // Update product Details in PDP
	    var customAttributes = response.product.custom;
	    updateProductInfo(customAttributes, $productContainer);

	    //IN-AR TRY ON
	    //Update Try On button (if enabled and available)
	    if (response.product && response.product.tryOnAttributes && response.product.tryOnAttributes.augmentedReality) {
	        if (response.product.tryOnAttributes.augmentedReality.isAREnabled) {
	            tryOnARHelper.updateTryOnButton(response.product.tryOnAttributes.augmentedReality.availableTryOnAR, response.product.tryOnAttributes.augmentedReality.linkARView);
	        }
	    }

	    //Update pid
	    $productContainer.attr('data-pid', response.product.id);

	    //Update findInStore button visibility
	    if (response.product.available) {
	        $("#findInStoreButton").removeClass('d-none');
	    } else {
	        $("#findInStoreButton").addClass('d-none');
	    }

	    var targetAddToCartButton;
	    //update addToCartButton based on variation selected
	    if (response.product.available) {
	        targetAddToCartButton = $("#addToCartButton");
	        targetAddToCartButton[0].disabled = '';
	        targetAddToCartButton[0].innerText = response.buttonText;
	    } else {
	        targetAddToCartButton = $("#addToCartButton");
	        targetAddToCartButton[0].disabled = 'disabled';
	        targetAddToCartButton[0].innerText = response.buttonText;
	    }

	    // Update productPID in document DOM
	    var productPidUpdate = response.product.id;
	    $("#findInStoreButton").attr('data-pid', productPidUpdate);

	    if (response.product.readyToOrder && response.product.available) {
	        $('.add-to-cart').data('is-disabled', 'false');
	        //Update wishlist button
	        checkInWishlist(response.product.id, false);
	    } else {
	        $('.add-to-cart').data('is-disabled', 'true');
	        //Update wishlist button
	        checkInWishlist(response.product.id, true);
	    }

	    // Update productType in document DOM
	    var productType = response.product.productType;
	    $("#findInStoreButton, #searchEstimatedDeliveryDateBtn").attr('data-product-type', productType);

	    //Enable findInStoreButton
	    var $destinationModal = $('#modalFindInStore .modal-body');
	    $destinationModal.removeClass('ajax-called');

	    // Update Badge in PDP
	    updateBadge(response.product.customBadge);
	    $('.cc-label-clubprice').addClass('icon-bata-club-price-cz');

	    // Update pricing
	    if (!isChoiceOfBonusProducts) {
	        var afterPriceMessage = '';
	        if ($('.cc-price-after-message').length > 0) {
	            afterPriceMessage = $('.cc-price-after-message').html();
	        }
	        var $priceSelector = $('.prices .cc-price', $productContainer).length ? $('.prices', $productContainer) : $('.prices');
	        $priceSelector.html(response.product.price.html);

	        if (afterPriceMessage !== '') {
	            $priceSelector.append('<span class="cc-price-after-message">' + afterPriceMessage + '</a>');
	        }
	    }

	    if (response && response.product && response.product.euPrice && response.product.euPriceDiscount) {
	        var $strikeThroughUpdatedPrice = $('.original-price-striked');
	        $strikeThroughUpdatedPrice.text(response.product.euPrice);

	        var $badgeDiscountedPercentage = $('.badge-alignment-near-price');
	        $badgeDiscountedPercentage.text(response.product.euPriceDiscount);
	    }

	    // update the buy now, pay later message, if enabled
	    var buyNoePayLaterMessageEnabled = response.product.buyNowPayLaterMessageEnabled;
	    if (buyNoePayLaterMessageEnabled && $('.js-bnpl-price').length) {
	        $('.js-bnpl-price').html(response.product.pricePerInstallmentMessage);
	    }

	    var $nameSelector;
	    // Update product name
	    if (!isChoiceOfBonusProducts) {
	        $nameSelector = $('.product-name');
	        $nameSelector.text(response.product.productName);
	    }

	    // Update brand logo image
	    if (response.product.brandLogo && !isChoiceOfBonusProducts) {
	        $nameSelector = $('[data-target="brandLogo"]');
	        $nameSelector.attr("src", response.product.brandLogo);
	        updateBrandLogoSize($nameSelector[0]);
	    }

	    // Update promotions
	    $productContainer.find('.pdp-promotions').empty().html(response.product.promotionsHtml);

	    updateAvailability(response, $productContainer);

	    if (isChoiceOfBonusProducts) {
	        var $selectButton = $productContainer.find('.select-bonus-product');
	        $selectButton.trigger('bonusproduct:updateSelectButton', {
	            product: response.product,
	            $productContainer: $productContainer
	        });
	    } else {
	        // Enable "Add to Cart" button if all required attributes have been selected
	        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
	            product: response.product,
	            $productContainer: $productContainer
	        }).trigger('product:statusUpdate', response.product);
	    }

	    // Update attributes
	    $productContainer.find('.main-attributes').empty().html(getAttributesHtml(response.product.attributes));

	    if (response.product.custom && response.product.custom.articleNo && $productContainer.find('[data-target="articleNo"]').length > 0) {
	        $productContainer.find('[data-target="articleNo"]').html(response.product.custom.articleNo);
	    }
	}

	/**
	 * @typedef UpdatedOptionValue
	 * @type Object
	 * @property {string} id - Option value ID for look up
	 * @property {string} url - Updated option value selection URL
	 */

	/**
	 * @typedef OptionSelectionResponse
	 * @type Object
	 * @property {string} priceHtml - Updated price HTML code
	 * @property {Object} options - Updated Options
	 * @property {string} options.id - Option ID
	 * @property {UpdatedOptionValue[]} options.values - Option values
	 */

	/**
	 * Updates DOM using post-option selection Ajax response
	 *
	 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
	 * @param {jQuery} $productContainer - DOM element for current product
	 */
	function updateOptions(optionsHtml, $productContainer) {
	    // Update options
	    $productContainer.find('.product-options').empty().html(optionsHtml);
	}

	/**
	 * Retrieve contextual quantity selector
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {jquery} - quantity selector DOM container
	 */
	function getQuantitySelector($el) {
	    return $el && $('.set-items').length ? $($el).closest('.product-detail').find('.quantity-select') : $('.quantity-select');
	}

	/**
	 * @typespec UpdatedQuantity
	 * @type Object
	 * @property {boolean} selected - Whether the quantity has been selected
	 * @property {string} value - The number of products to purchase
	 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
	 *     etc.
	 */

	/**
	 * Updates the quantity DOM elements post Ajax call
	 * @param {UpdatedQuantity[]} quantities -
	 * @param {jQuery} $productContainer - DOM container for a given product
	 */
	function updateQuantities(quantities, $productContainer) {
	    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
	        var optionsHtml = quantities.map(function (quantity) {
	            var selected = quantity.selected ? ' selected ' : '';
	            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' + selected + '>' + quantity.value + '</option>';
	        }).join('');
	        getQuantitySelector($productContainer).empty().html(optionsHtml);
	    }
	}

	/**
	 * updates the product view when a product attribute is selected or deselected or when
	 *         changing quantity
	 * @param {string} selectedValueUrl - the Url for the selected variation value
	 * @param {jQuery} $productContainer - DOM element for current product
	 */
	function attributeSelect(selectedValueUrl, $productContainer, isStickyAddToCart) {
	    if (selectedValueUrl) {
	        $('body').trigger('product:beforeAttributeSelect', {
	            url: selectedValueUrl,
	            container: $productContainer
	        });
	        $.ajax({
	            url: selectedValueUrl,
	            method: 'GET',
	            success: function success(data) {
	                handleVariantResponse(data, $productContainer);
	                updateOptions(data.product.optionsHtml, $productContainer);
	                updateQuantities(data.product.quantities, $productContainer);

	                $('body').trigger('product:afterAttributeSelect', {
	                    data: data,
	                    container: $productContainer
	                });
	                if (isStickyAddToCart) {
	                    $('#pdpStickyAddToCart').modal('hide');
	                    $('.container button.add-to-cart').trigger('click');
	                }
	                $.spinner().stop();
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    }
	}

	/**
	 * Reset PDP EDD input field
	 */
	function resetEDD() {
	    $('#pdpPinCodeField').removeClass('is-invalid');
	    $('#pdpPinCodeField').val('');
	    $('.pdpDeliveryDateResult').addClass('d-none');
	    $('#pdpPinCode-error').text('');
	    $('.pdpDeliveryDateResultText').html('');
	}

	$(window).resize(function () {
	    initPdpimagesCarousel();
	});

	/**
	 * Enable/disable UI elements
	 * @param {boolean} enableOrDisable - true or false
	 */
	function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
	    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
	}

	'use strict';

	/* ON SCROLL ANIMATION */
	var lastScroll = 0;
	window.addEventListener('scroll', function () {
	    if ($('.cc-minicart-overlay').hasClass('show')) {
	        return;
	    }

	    var $header = $('.js-header');
	    var $body = $('body');
	    var currentScroll = $(this).scrollTop();

	    if (currentScroll > lastScroll && currentScroll > 96) {
	        $header.addClass('cc-header__tag__scrollDown');
	        $body.addClass('cc-header__hide');
	    } else {
	        $header.removeClass('cc-header__tag__scrollDown');
	        $body.removeClass('cc-header__hide');
	    }

	    lastScroll = currentScroll;

	    if (currentScroll > 96) {
	        $header.addClass('cc-header__tag__notOnTop');
	    } else {
	        $header.removeClass('cc-header__tag__notOnTop');
	    }
	}, { passive: true });

	var $stickyBar = $('.cc-pdp__stickyBtn__wrapper');
	function stickyBar() {
	    window.addEventListener('scroll', function () {
	        var currentScroll = $(this).scrollTop();
	        var buttonPosition = $('.cc-pdp-col-description__wrp .add-to-cart.cc-button-type-1').offset().top + $('.cc-pdp-col-description__wrp .add-to-cart.cc-button-type-1').height() + 20;

	        if (currentScroll > buttonPosition) {
	            $stickyBar.removeClass('cc-pdp__stickyBtn__wrapper__scrollDown');
	        } else {
	            $stickyBar.addClass('cc-pdp__stickyBtn__wrapper__scrollDown');
	        }
	    }, { passive: true });
	}

	$(document).ready(function () {
	    stickyBar();

	    var initialScroll = $(this).scrollTop();
	    var buttonPosition = $('.cc-pdp-col-description__wrp .add-to-cart.cc-button-type-1').offset().top + $('.cc-pdp-col-description__wrp .add-to-cart.cc-button-type-1').height() + 20;

	    if (initialScroll > buttonPosition) {
	        $stickyBar.removeClass('cc-pdp__stickyBtn__wrapper__scrollDown');
	    }

	    $('.container').on('click', '.js-stickyAddToCart', function (e) {
	        if ($('.cc-pdp-col-description__wrp .cc-size-ul-list .cc-single-size-tile.selected').length > 0) {
	            e.preventDefault();
	            e.stopPropagation();
	            $('.cc-pdp-col-description__wrp .add-to-cart.cc-button-type-1').trigger('click');
	            return;
	        }

	        $('body').on('shown.bs.modal', '#pdpStickyAddToCart', function () {
	            var sizeList = $(".cc-container-size-list").html();
	            $('.cc-size-selector-container').html(sizeList);
	        });
	    });

	    $('.container').on('click', '.js-stickyAddToCartNoSize', function () {
	        $('.cc-pdp-col-description__wrp .add-to-cart.cc-button-type-1').trigger('click');
	    });

	    $('#pdpStickyAddToCart').on('click', 'li.single-size-tile', function () {
	        var $this = $(this);
	        if ($this.hasClass('selected')) {
	            return;
	        }
	        $('#pdpStickyAddToCart li.single-size-tile.selected').removeClass('selected');
	        $this.addClass('selected');
	        var sizeContainer = $('.attribute .single-size-tile');
	        var sizeSelected = sizeContainer.filter(function () {
	            return $(this).data('display-value') === $this.data('display-value');
	        });
	        if (sizeSelected.length > 0) {
	            sizeSelected.trigger('click', { stickyAddToBag: true });
	        }
	    });
	});

	$(window).resize(function () {
	    stickyBar();
	});
	var colorInfo = $('.color-selected .color-value');
	$('.js-colorAttribute.selectable').hover(function () {
	    colorInfo.data('old-selected', colorInfo.text());
	    colorInfo.text($(this).data('value'));
	}, function () {
	    colorInfo.text(colorInfo.data('old-selected'));
	});

	$('#backInStockModal').on('show.bs.modal', function () {
	    document.querySelector('.backinstock-body').style.display = 'block';
	    document.querySelector('.serviceMessage').style.display = 'none';
	});

	// Size guide modal scroll with arrows

	$('#size-modal').on('click', '.js-scrollLeft', function () {
	    $('.cc-sizeguide__table table').animate({
	        scrollLeft: $('.cc-table-container').scrollLeft() - 150
	    }, 300);
	    $('.js-scrollRight').removeClass('disabled');
	    $('.js-scrollLeft').addClass('disabled');
	});

	$('#size-modal').on('click', '.js-scrollRight', function () {
	    $('.cc-sizeguide__table table').animate({
	        scrollLeft: $('.cc-sizeguide__table table').scrollLeft() + 150
	    }, 300);

	    $('.js-scrollLeft').removeClass('disabled');
	    $('.js-scrollRight').addClass('disabled');
	});

	function updateScrollArrowIcons() {
	    var $table = $('.cc-sizeguide__table table');
	    var scrollLeft = $table.scrollLeft();
	    var visibleTableWidth = $table.outerWidth();
	    var scrollWidth = $table[0].scrollWidth;
	    var tolerance = 2;

	    $('.js-scrollLeft').toggleClass('disabled', scrollLeft <= tolerance);

	    var scrolledToEnd = scrollLeft + visibleTableWidth + tolerance >= scrollWidth;
	    $('.js-scrollRight').toggleClass('disabled', scrolledToEnd);
	}

	$('#size-modal').on('shown.bs.modal', updateScrollArrowIcons);

	$('#size-modal').on('wheel', '.cc-sizeguide__table', updateScrollArrowIcons);

	module.exports = {
	    methods: {
	        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
	    },

	    addToCart: addToCartHelper.addToCart,

	    updateAttributesAndDetails: function updateAttributesAndDetails() {
	        $('body').on('product:statusUpdate', function (e, data) {
	            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

	            $productContainer.find('.description-and-detail .product-attributes').empty().html(data.attributesHtml);

	            if (data.shortDescription) {
	                $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
	                $productContainer.find('.description-and-detail .description .content').empty().html(data.shortDescription);
	            } else {
	                $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
	            }

	            if (data.longDescription) {
	                $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
	                $productContainer.find('.description-and-detail .details .content').empty().html(data.longDescription);
	            } else {
	                $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
	            }

	            if (data.sizeType) {
	                $('.js-size-type').removeClass('d-none');
	                $('.js-size-type').empty().html(data.sizeType);
	            } else {
	                $('.js-size-type').addClass('d-none');
	            }
	        });
	    },

	    showSpinner: function showSpinner() {
	        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
	            $.spinner().start();
	        });
	    },
	    updateAttribute: function updateAttribute() {
	        $('body').on('product:afterAttributeSelect', function (e, response) {
	            if ($('.product-detail>.bundle-items').length) {
	                response.container.data('pid', response.data.product.id);
	                response.container.find('.product-id').text(response.data.product.id);
	            } else if ($('.product-set-detail').eq(0)) {
	                response.container.data('pid', response.data.product.id);
	                response.container.find('.product-id').text(response.data.product.id);
	            } else {
	                $('.product-id').text(response.data.product.id);
	                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
	            }

	            //keep the pin code in the input field
	            if (lastPincodeInsered) {
	                $('#pdpPinCodeField').val(lastPincodeInsered);
	            }
	            //reset the last validated pincode
	            lastValidatedPincode = '';
	        });
	    },

	    saveInsertedPincode: function saveInsertedPincode() {
	        $('#pdpPinCodeField').on('blur', function () {
	            lastPincodeInsered = $('#pdpPinCodeField').val().trim();
	        });
	    },

	    updateAddToCart: function updateAddToCart() {
	        $('body').on('product:updateAddToCart', function (e, response) {
	            // update local add to cart (for sets)
	            $('button.add-to-cart', response.$productContainer).attr('data-is-disabled', !response.product.readyToOrder || !response.product.available);

	            var enable = $('.product-availability').toArray().every(function (item) {
	                return $(item).data('available') && $(item).data('ready-to-order');
	            });
	            $('button.add-to-cart-global').attr('data-is-disabled', !enable);
	            $('button.add-to-cart-global').attr('disabled', !enable);
	        });
	    },
	    updateAvailability: function updateAvailability() {
	        $('body').on('product:updateAvailability', function (e, response) {
	            $('div.availability', response.$productContainer).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available);

	            $('.availability-msg', response.$productContainer).empty().html(response.message);

	            if ($('.global-availability').length) {
	                var allAvailable = $('.product-availability').toArray().every(function (item) {
	                    return $(item).data('available');
	                });

	                var allReady = $('.product-availability').toArray().every(function (item) {
	                    return $(item).data('ready-to-order');
	                });

	                $('.global-availability').data('ready-to-order', allReady).data('available', allAvailable);

	                $('.global-availability .availability-msg').empty().html(allReady ? response.message : response.resources.info_selectforstock);
	            }
	        });
	    },
	    sizeChart: function sizeChart() {
	        $('.size-chart a').on('click', function (e) {
	            e.preventDefault();
	            var url = $(this).attr('href');
	            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
	            if ($prodSizeChart.is(':empty')) {
	                $.ajax({
	                    url: url,
	                    type: 'get',
	                    dataType: 'json',
	                    success: function success(data) {
	                        $prodSizeChart.append(data.content);
	                    }
	                });
	            }
	            $prodSizeChart.toggleClass('active');
	        });

	        var $sizeChart = $('.size-chart-collapsible');
	        $('body').on('click touchstart', function (e) {
	            if ($('.size-chart').has(e.target).length <= 0) {
	                $sizeChart.removeClass('active');
	            }
	        });
	    },
	    searchEstimatedDeliveryDate: function searchEstimatedDeliveryDate() {
	        $(document).on('click', '#searchEstimatedDeliveryDateBtn', function (e) {
	            e.preventDefault();
	            var pincodeInsered = $('#pdpPinCodeField').val();

	            if (pincodeInsered.length > 0 && pincodeInsered !== '' && pincodeInsered !== lastValidatedPincode) {
	                var productTypeVal = $("#searchEstimatedDeliveryDateBtn").attr('data-product-type');
	                var url = $('#PDPEstimatedDeliveryDateForm').attr('action');
	                var data = {
	                    dwfrm_eddForm_zipCodeSelected: pincodeInsered,
	                    sku: $('.product-detail').data('pid')
	                };

	                $('#pdpPinCodeField').removeClass('is-invalid');
	                $('.pdpDeliveryDateResult').addClass('d-none');
	                $('#pdpPinCode-error').text('');
	                $('.pdpDeliveryDateResultText').html('');

	                if (productTypeVal === 'variant') {
	                    $.spinner().start();
	                    $.ajax({
	                        url: url,
	                        type: 'POST',
	                        dataType: 'json',
	                        data: data,
	                        success: function success(data) {
	                            if (data.success) {
	                                $.spinner().stop();
	                                lastValidatedPincode = pincodeInsered;
	                                $('#pdpPinCodeField').val(pincodeInsered);
	                                $('.pdpDeliveryDateResult').removeClass('d-none');
	                                var deliveryMessage = $('.pdpDeliveryDateResultText').data('expected-by').replace('{0}', data.estimatedDeliveryDate);
	                                $('.pdpDeliveryDateResultText').html(deliveryMessage);
	                            } else {
	                                $('#pdpPinCodeField').closest('.cc-form-group').find('.cc-text-message').text(data.error);
	                                $('#pdpPinCodeField').addClass('is-invalid');
	                                $.spinner().stop();
	                            }
	                        },
	                        error: function error() {
	                            $('#pdpPinCodeField').parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                            $('#pdpPinCodeField').addClass('is-invalid');
	                            $.spinner().stop();
	                        }
	                    });
	                } else {
	                    $('.pdp-col-description .availability-msg .availability-msg-hint').removeClass('d-none');
	                }
	            }
	        });

	        $(document).on('keydown', '#pdpPinCodeField', function (e) {
	            if (e.which === 13) {
	                e.preventDefault();
	            }
	        });
	    },
	    customizeScalapayWidget: function customizeScalapayWidget() {
	        var customLabel = $('.js-scalapay-widget').data('scalapay-custom-label');
	        var $scalapayWidget = $('.scalapay-widget-product');

	        if ($scalapayWidget.length > 0) {
	            $($scalapayWidget[0].shadowRoot).find('.sp--nowrap')[2].outerText = customLabel;
	            $($scalapayWidget[0].shadowRoot).find('#sp-icon').css("color", "rgba(230, 0, 0, 0.85)");

	            var checkExist = setInterval(function () {
	                var $modalLogo = $('#sp_modal__logo');
	                var $modalClose = $('.sp_modal__close');
	                var isClearInterval1 = false;
	                var isClearInterval2 = false;

	                if ($modalLogo.length) {
	                    $('.sp_modal__logo_image').remove();
	                    $('.sp_modal__heading').append($modalLogo);
	                    isClearInterval1 = true;
	                }
	                if ($modalClose.length) {
	                    $modalClose.html('<span aria-hidden="true" class="icon-close-remove"></span>');
	                    isClearInterval2 = true;
	                }
	                if (isClearInterval1 && isClearInterval2) {
	                    clearInterval(checkExist);
	                }
	            }, 500);
	        }
	    },

	    focusChooseBonusProductModal: bonusProductHelpers.focusChooseBonusProductModal(),

	    //Creates in window object an array of PID of the wishlist products
	    updateIsInWishlist: function updateIsInWishlist() {
	        window.ProductsInWishlist = [];

	        var productArrString = $('.wishlist-list.products-in-wishlist').attr('data-products-in-wishlist');

	        if (!productArrString) {
	            return false;
	        }

	        var productObj = JSON.parse(productArrString);
	        var productArr = productObj.result;

	        if (!productArr) {
	            return false;
	        }

	        window.ProductsInWishlist = productArr;

	        var pid = $('.add-to-wish-list').closest('.product-detail').attr('data-pid');
	        var isAddToCartDisabled = $('button.add-to-cart').data('is-disabled');
	        var isDisabled = isAddToCartDisabled === true || isAddToCartDisabled === 'true';
	        checkInWishlist(pid, isDisabled);
	    },

	    colorAttribute: function colorAttribute() {
	        $(document).on('click', '[data-attr="color"] button', function (e) {
	            e.preventDefault();

	            if ($(this).attr('disabled')) {
	                return;
	            }
	            var $productContainer = $(this).closest('.set-item');
	            if (!$productContainer.length) {
	                $productContainer = $(this).closest('.product-detail');
	            }

	            if ($(this).hasClass("selectable") && !$(this).hasClass("selected")) {
	                attributeSelect($(this).attr('data-url'), $productContainer);
	            }

	            $('html, body').animate({
	                scrollTop: 0
	            }, 500);

	            //Reset PDP EDD input field
	            resetEDD();
	        });
	    },

	    selectAttribute: function selectAttribute(data) {
	        $(document).on('click', 'div[class*="select-"], .attribute li.single-size-tile', function (e, data) {
	            e.preventDefault();
	            var isStickyAddToCart = false;
	            if (!!data && data.stickyAddToBag) {
	                isStickyAddToCart = data.stickyAddToBag;
	            }
	            var $productContainer = $(this).closest('.set-item');
	            if (!$productContainer.length) {
	                $productContainer = $(this).closest('.product-detail');
	            }
	            if ($(this).hasClass("selectable") && !$(this).hasClass("selected")) {

	                //visual feedback making yellow background to tile selected --- to delete
	                // $('div[class*="select-"] .single-size-tile').css('background-color','#dcdcdc');
	                // $(this).css('background-color','yellow');
	                attributeSelect($(this).attr('value'), $productContainer, isStickyAddToCart);
	            }

	            //Reset PDP EDD input field
	            resetEDD();
	        });
	    },

	    availability: function availability() {
	        $(document).on('change', '.quantity-select', function (e) {
	            e.preventDefault();

	            var $productContainer = $(this).closest('.product-detail');
	            if (!$productContainer.length) {
	                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
	            }

	            if ($('.bundle-items', $productContainer).length === 0) {
	                attributeSelect($(e.currentTarget).find('option:selected').data('url'), $productContainer);
	            }
	        });
	    },

	    backInStock: function backInStock() {
	        $('.backinstock-form').submit(function (e) {
	            var form = $(this);
	            e.preventDefault();
	            var url = form.attr('action');
	            form.spinner().start();
	            var button = $('#submitEmailButton');

	            if (button.length && button.data('id') && button.data('message')) {
	                var buttonData = {
	                    id: button.data('id'),
	                    message: button.data('message')
	                };
	                $('body').trigger('analytics:clickBackInStock', buttonData);
	            }

	            $.ajax({
	                url: url,
	                type: 'post',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    form.spinner().stop();
	                    if (data.success) {
	                        document.querySelector('.backinstock-body').style.display = 'none';
	                        $('.serviceMessage').empty().append('<p class="cc-service-message--text">' + data.receivedMsgBody + '</p><div class="cc-content-button-back" data-dismiss="modal" aria-label="Close"><a href="" class="cc-link-type-2" id="submitEmailButton">' + data.buttonText + '</a></div>');
	                        document.querySelector('.serviceMessage').style.display = 'block';
	                        form[0].reset();
	                    } else if (!data.success) {
	                        document.querySelector('.backinstock-body').style.display = 'none';
	                        $('.serviceMessage').empty().append('<p class="cc-service-message--text">' + data.receivedMsgBody + '</p><div class="cc-content-button-back" data-dismiss="modal" aria-label="Close"><a href="" class="cc-link-type-2" id="submitEmailButton">' + data.buttonText + '</a></div>');
	                        document.querySelector('.serviceMessage').style.display = 'block';
	                        form[0].reset();
	                    }
	                },
	                error: function error() {
	                    form.spinner().stop();
	                }
	            });
	            return false;
	        });
	    },
	    accordionOnOpening: function accordionOnOpening() {
	        $('.container').on('click', '.js-accordionPDP', function () {
	            var _this = this;

	            setTimeout(function () {
	                $('html, body').animate({
	                    scrollTop: $(_this).offset().top - 120
	                }, 600);
	            }, 200);
	        });
	    },

	    closeSizeModal: function closeSizeModal() {
	        $(document).on('click', '.js-close-size', function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            $(this).closest('.cc-tile-sizes').removeClass('cc-active');
	            $('body').removeClass('modal-open');
	        });

	        $(document).on('click', '.cc-tile-sizes.cc-active', function (e) {
	            e.stopPropagation();
	            e.preventDefault();

	            if (e.target !== e.currentTarget) {
	                return;
	            }

	            $(this).closest('.cc-tile-sizes').removeClass('cc-active');
	            $('body').removeClass('modal-open');
	        });
	    },

	    deliveryAccordionAjax: deliveryAccordionAjax,

	    sizeGuideModalAjax: sizeGuideModalAjax,

	    initPdpimagesCarousel: initPdpimagesCarousel,

	    zoomCarousel: zoomCarousel

	};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/*! PhotoSwipe - v4.1.2 - 2017-04-05
	* http://photoswipe.com
	* Copyright (c) 2017 Dmitry Semenov; */
	(function (root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
			module.exports = factory();
		} else {
			root.PhotoSwipe = factory();
		}
	})(undefined, function () {

		'use strict';

		var PhotoSwipe = function PhotoSwipe(template, UiClass, items, options) {

			/*>>framework-bridge*/
			/**
	   *
	   * Set of generic functions used by gallery.
	   * 
	   * You're free to modify anything here as long as functionality is kept.
	   * 
	   */
			var framework = {
				features: null,
				bind: function bind(target, type, listener, unbind) {
					var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
					type = type.split(' ');
					for (var i = 0; i < type.length; i++) {
						if (type[i]) {
							target[methodName](type[i], listener, false);
						}
					}
				},
				isArray: function isArray(obj) {
					return obj instanceof Array;
				},
				createEl: function createEl(classes, tag) {
					var el = document.createElement(tag || 'div');
					if (classes) {
						el.className = classes;
					}
					return el;
				},
				getScrollY: function getScrollY() {
					var yOffset = window.pageYOffset;
					return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
				},
				unbind: function unbind(target, type, listener) {
					framework.bind(target, type, listener, true);
				},
				removeClass: function removeClass(el, className) {
					var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
					el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
				},
				addClass: function addClass(el, className) {
					if (!framework.hasClass(el, className)) {
						el.className += (el.className ? ' ' : '') + className;
					}
				},
				hasClass: function hasClass(el, className) {
					return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
				},
				getChildByClass: function getChildByClass(parentEl, childClassName) {
					var node = parentEl.firstChild;
					while (node) {
						if (framework.hasClass(node, childClassName)) {
							return node;
						}
						node = node.nextSibling;
					}
				},
				arraySearch: function arraySearch(array, value, key) {
					var i = array.length;
					while (i--) {
						if (array[i][key] === value) {
							return i;
						}
					}
					return -1;
				},
				extend: function extend(o1, o2, preventOverwrite) {
					for (var prop in o2) {
						if (o2.hasOwnProperty(prop)) {
							if (preventOverwrite && o1.hasOwnProperty(prop)) {
								continue;
							}
							o1[prop] = o2[prop];
						}
					}
				},
				easing: {
					sine: {
						out: function out(k) {
							return Math.sin(k * (Math.PI / 2));
						},
						inOut: function inOut(k) {
							return -(Math.cos(Math.PI * k) - 1) / 2;
						}
					},
					cubic: {
						out: function out(k) {
							return --k * k * k + 1;
						}
						/*
	     	elastic: {
	     		out: function ( k ) {
	     				var s, a = 0.1, p = 0.4;
	     			if ( k === 0 ) return 0;
	     			if ( k === 1 ) return 1;
	     			if ( !a || a < 1 ) { a = 1; s = p / 4; }
	     			else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
	     			return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
	     			},
	     	},
	     	back: {
	     		out: function ( k ) {
	     			var s = 1.70158;
	     			return --k * k * ( ( s + 1 ) * k + s ) + 1;
	     		}
	     	}
	     */
					} },

				/**
	    * 
	    * @return {object}
	    * 
	    * {
	    *  raf : request animation frame function
	    *  caf : cancel animation frame function
	    *  transfrom : transform property key (with vendor), or null if not supported
	    *  oldIE : IE8 or below
	    * }
	    * 
	    */
				detectFeatures: function detectFeatures() {
					if (framework.features) {
						return framework.features;
					}
					var helperEl = framework.createEl(),
					    helperStyle = helperEl.style,
					    vendor = '',
					    features = {};

					// IE8 and below
					features.oldIE = document.all && !document.addEventListener;

					features.touch = 'ontouchstart' in window;

					if (window.requestAnimationFrame) {
						features.raf = window.requestAnimationFrame;
						features.caf = window.cancelAnimationFrame;
					}

					features.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled;

					// fix false-positive detection of old Android in new IE
					// (IE11 ua string contains "Android 4.0")

					if (!features.pointerEvent) {

						var ua = navigator.userAgent;

						// Detect if device is iPhone or iPod and if it's older than iOS 8
						// http://stackoverflow.com/a/14223920
						// 
						// This detection is made because of buggy top/bottom toolbars
						// that don't trigger window.resize event.
						// For more info refer to _isFixedPosition variable in core.js

						if (/iP(hone|od)/.test(navigator.platform)) {
							var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
							if (v && v.length > 0) {
								v = parseInt(v[1], 10);
								if (v >= 1 && v < 8) {
									features.isOldIOSPhone = true;
								}
							}
						}

						// Detect old Android (before KitKat)
						// due to bugs related to position:fixed
						// http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript

						var match = ua.match(/Android\s([0-9\.]*)/);
						var androidversion = match ? match[1] : 0;
						androidversion = parseFloat(androidversion);
						if (androidversion >= 1) {
							if (androidversion < 4.4) {
								features.isOldAndroid = true; // for fixed position bug & performance
							}
							features.androidVersion = androidversion; // for touchend bug
						}
						features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

						// p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
					}

					var styleChecks = ['transform', 'perspective', 'animationName'],
					    vendors = ['', 'webkit', 'Moz', 'ms', 'O'],
					    styleCheckItem,
					    styleName;

					for (var i = 0; i < 4; i++) {
						vendor = vendors[i];

						for (var a = 0; a < 3; a++) {
							styleCheckItem = styleChecks[a];

							// uppercase first letter of property name, if vendor is present
							styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);

							if (!features[styleCheckItem] && styleName in helperStyle) {
								features[styleCheckItem] = styleName;
							}
						}

						if (vendor && !features.raf) {
							vendor = vendor.toLowerCase();
							features.raf = window[vendor + 'RequestAnimationFrame'];
							if (features.raf) {
								features.caf = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
							}
						}
					}

					if (!features.raf) {
						var lastTime = 0;
						features.raf = function (fn) {
							var currTime = new Date().getTime();
							var timeToCall = Math.max(0, 16 - (currTime - lastTime));
							var id = window.setTimeout(function () {
								fn(currTime + timeToCall);
							}, timeToCall);
							lastTime = currTime + timeToCall;
							return id;
						};
						features.caf = function (id) {
							clearTimeout(id);
						};
					}

					// Detect SVG support
					features.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;

					framework.features = features;

					return features;
				}
			};

			framework.detectFeatures();

			// Override addEventListener for old versions of IE
			if (framework.features.oldIE) {

				framework.bind = function (target, type, listener, unbind) {

					type = type.split(' ');

					var methodName = (unbind ? 'detach' : 'attach') + 'Event',
					    evName,
					    _handleEv = function _handleEv() {
						listener.handleEvent.call(listener);
					};

					for (var i = 0; i < type.length; i++) {
						evName = type[i];
						if (evName) {

							if ((typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) === 'object' && listener.handleEvent) {
								if (!unbind) {
									listener['oldIE' + evName] = _handleEv;
								} else {
									if (!listener['oldIE' + evName]) {
										return false;
									}
								}

								target[methodName]('on' + evName, listener['oldIE' + evName]);
							} else {
								target[methodName]('on' + evName, listener);
							}
						}
					}
				};
			}

			/*>>framework-bridge*/

			/*>>core*/
			//function(template, UiClass, items, options)

			var self = this;

			/**
	   * Static vars, don't change unless you know what you're doing.
	   */
			var DOUBLE_TAP_RADIUS = 25,
			    NUM_HOLDERS = 3;

			/**
	   * Options
	   */
			var _options = {
				allowPanToNext: true,
				spacing: 0.12,
				bgOpacity: 1,
				mouseUsed: false,
				loop: true,
				pinchToClose: true,
				closeOnScroll: true,
				closeOnVerticalDrag: true,
				verticalDragRange: 0.75,
				hideAnimationDuration: 333,
				showAnimationDuration: 333,
				showHideOpacity: false,
				focus: true,
				escKey: true,
				arrowKeys: true,
				mainScrollEndFriction: 0.35,
				panEndFriction: 0.35,
				isClickableElement: function isClickableElement(el) {
					return el.tagName === 'A';
				},
				getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
					if (isMouseClick) {
						return 1;
					} else {
						return item.initialZoomLevel < 0.7 ? 1 : 1.33;
					}
				},
				maxSpreadZoom: 1.33,
				modal: true,

				// not fully implemented yet
				scaleMode: 'fit' // TODO
			};
			framework.extend(_options, options);

			/**
	   * Private helper variables & functions
	   */

			var _getEmptyPoint = function _getEmptyPoint() {
				return { x: 0, y: 0 };
			};

			var _isOpen,
			    _isDestroying,
			    _closedByScroll,
			    _currentItemIndex,
			    _containerStyle,
			    _containerShiftIndex,
			    _currPanDist = _getEmptyPoint(),
			    _startPanOffset = _getEmptyPoint(),
			    _panOffset = _getEmptyPoint(),
			    _upMoveEvents,
			    // drag move, drag end & drag cancel events array
			_downEvents,
			    // drag start events array
			_globalEventHandlers,
			    _viewportSize = {},
			    _currZoomLevel,
			    _startZoomLevel,
			    _translatePrefix,
			    _translateSufix,
			    _updateSizeInterval,
			    _itemsNeedUpdate,
			    _currPositionIndex = 0,
			    _offset = {},
			    _slideSize = _getEmptyPoint(),
			    // size of slide area, including spacing
			_itemHolders,
			    _prevItemIndex,
			    _indexDiff = 0,
			    // difference of indexes since last content update
			_dragStartEvent,
			    _dragMoveEvent,
			    _dragEndEvent,
			    _dragCancelEvent,
			    _transformKey,
			    _pointerEventEnabled,
			    _isFixedPosition = true,
			    _likelyTouchDevice,
			    _modules = [],
			    _requestAF,
			    _cancelAF,
			    _initalClassName,
			    _initalWindowScrollY,
			    _oldIE,
			    _currentWindowScrollY,
			    _features,
			    _windowVisibleSize = {},
			    _renderMaxResolution = false,
			    _orientationChangeTimeout,


			// Registers PhotoSWipe module (History, Controller ...)
			_registerModule = function _registerModule(name, module) {
				framework.extend(self, module.publicMethods);
				_modules.push(name);
			},
			    _getLoopedId = function _getLoopedId(index) {
				var numSlides = _getNumItems();
				if (index > numSlides - 1) {
					return index - numSlides;
				} else if (index < 0) {
					return numSlides + index;
				}
				return index;
			},


			// Micro bind/trigger
			_listeners = {},
			    _listen = function _listen(name, fn) {
				if (!_listeners[name]) {
					_listeners[name] = [];
				}
				return _listeners[name].push(fn);
			},
			    _shout = function _shout(name) {
				var listeners = _listeners[name];

				if (listeners) {
					var args = Array.prototype.slice.call(arguments);
					args.shift();

					for (var i = 0; i < listeners.length; i++) {
						listeners[i].apply(self, args);
					}
				}
			},
			    _getCurrentTime = function _getCurrentTime() {
				return new Date().getTime();
			},
			    _applyBgOpacity = function _applyBgOpacity(opacity) {
				_bgOpacity = opacity;
				self.bg.style.opacity = opacity * _options.bgOpacity;
			},
			    _applyZoomTransform = function _applyZoomTransform(styleObj, x, y, zoom, item) {
				if (!_renderMaxResolution || item && item !== self.currItem) {
					zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
				}

				styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
			},
			    _applyCurrentZoomPan = function _applyCurrentZoomPan(allowRenderResolution) {
				if (_currZoomElementStyle) {

					if (allowRenderResolution) {
						if (_currZoomLevel > self.currItem.fitRatio) {
							if (!_renderMaxResolution) {
								_setImageSize(self.currItem, false, true);
								_renderMaxResolution = true;
							}
						} else {
							if (_renderMaxResolution) {
								_setImageSize(self.currItem);
								_renderMaxResolution = false;
							}
						}
					}

					_applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
				}
			},
			    _applyZoomPanToItem = function _applyZoomPanToItem(item) {
				if (item.container) {

					_applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item);
				}
			},
			    _setTranslateX = function _setTranslateX(x, elStyle) {
				elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
			},
			    _moveMainScroll = function _moveMainScroll(x, dragging) {

				if (!_options.loop && dragging) {
					var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
					    delta = Math.round(x - _mainScrollPos.x);

					if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) {
						x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
					}
				}

				_mainScrollPos.x = x;
				_setTranslateX(x, _containerStyle);
			},
			    _calculatePanOffset = function _calculatePanOffset(axis, zoomLevel) {
				var m = _midZoomPoint[axis] - _offset[axis];
				return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel);
			},
			    _equalizePoints = function _equalizePoints(p1, p2) {
				p1.x = p2.x;
				p1.y = p2.y;
				if (p2.id) {
					p1.id = p2.id;
				}
			},
			    _roundPoint = function _roundPoint(p) {
				p.x = Math.round(p.x);
				p.y = Math.round(p.y);
			},
			    _mouseMoveTimeout = null,
			    _onFirstMouseMove = function _onFirstMouseMove() {
				// Wait until mouse move event is fired at least twice during 100ms
				// We do this, because some mobile browsers trigger it on touchstart
				if (_mouseMoveTimeout) {
					framework.unbind(document, 'mousemove', _onFirstMouseMove);
					framework.addClass(template, 'pswp--has_mouse');
					_options.mouseUsed = true;
					_shout('mouseUsed');
				}
				_mouseMoveTimeout = setTimeout(function () {
					_mouseMoveTimeout = null;
				}, 100);
			},
			    _bindEvents = function _bindEvents() {
				framework.bind(document, 'keydown', self);

				if (_features.transform) {
					// don't bind click event in browsers that don't support transform (mostly IE8)
					framework.bind(self.scrollWrap, 'click', self);
				}

				if (!_options.mouseUsed) {
					framework.bind(document, 'mousemove', _onFirstMouseMove);
				}

				framework.bind(window, 'resize scroll orientationchange', self);

				_shout('bindEvents');
			},
			    _unbindEvents = function _unbindEvents() {
				framework.unbind(window, 'resize scroll orientationchange', self);
				framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
				framework.unbind(document, 'keydown', self);
				framework.unbind(document, 'mousemove', _onFirstMouseMove);

				if (_features.transform) {
					framework.unbind(self.scrollWrap, 'click', self);
				}

				if (_isDragging) {
					framework.unbind(window, _upMoveEvents, self);
				}

				clearTimeout(_orientationChangeTimeout);

				_shout('unbindEvents');
			},
			    _calculatePanBounds = function _calculatePanBounds(zoomLevel, update) {
				var bounds = _calculateItemSize(self.currItem, _viewportSize, zoomLevel);
				if (update) {
					_currPanBounds = bounds;
				}
				return bounds;
			},
			    _getMinZoomLevel = function _getMinZoomLevel(item) {
				if (!item) {
					item = self.currItem;
				}
				return item.initialZoomLevel;
			},
			    _getMaxZoomLevel = function _getMaxZoomLevel(item) {
				if (!item) {
					item = self.currItem;
				}
				return item.w > 0 ? _options.maxSpreadZoom : 1;
			},


			// Return true if offset is out of the bounds
			_modifyDestPanOffset = function _modifyDestPanOffset(axis, destPanBounds, destPanOffset, destZoomLevel) {
				if (destZoomLevel === self.currItem.initialZoomLevel) {
					destPanOffset[axis] = self.currItem.initialPosition[axis];
					return true;
				} else {
					destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);

					if (destPanOffset[axis] > destPanBounds.min[axis]) {
						destPanOffset[axis] = destPanBounds.min[axis];
						return true;
					} else if (destPanOffset[axis] < destPanBounds.max[axis]) {
						destPanOffset[axis] = destPanBounds.max[axis];
						return true;
					}
				}
				return false;
			},
			    _setupTransforms = function _setupTransforms() {

				if (_transformKey) {
					// setup 3d transforms
					var allow3dTransform = _features.perspective && !_likelyTouchDevice;
					_translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
					_translateSufix = _features.perspective ? ', 0px)' : ')';
					return;
				}

				// Override zoom/pan/move functions in case old browser is used (most likely IE)
				// (so they use left/top/width/height, instead of CSS transform)

				_transformKey = 'left';
				framework.addClass(template, 'pswp--ie');

				_setTranslateX = function _setTranslateX(x, elStyle) {
					elStyle.left = x + 'px';
				};
				_applyZoomPanToItem = function _applyZoomPanToItem(item) {

					var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
					    s = item.container.style,
					    w = zoomRatio * item.w,
					    h = zoomRatio * item.h;

					s.width = w + 'px';
					s.height = h + 'px';
					s.left = item.initialPosition.x + 'px';
					s.top = item.initialPosition.y + 'px';
				};
				_applyCurrentZoomPan = function _applyCurrentZoomPan() {
					if (_currZoomElementStyle) {

						var s = _currZoomElementStyle,
						    item = self.currItem,
						    zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
						    w = zoomRatio * item.w,
						    h = zoomRatio * item.h;

						s.width = w + 'px';
						s.height = h + 'px';

						s.left = _panOffset.x + 'px';
						s.top = _panOffset.y + 'px';
					}
				};
			},
			    _onKeyDown = function _onKeyDown(e) {
				var keydownAction = '';
				if (_options.escKey && e.keyCode === 27) {
					keydownAction = 'close';
				} else if (_options.arrowKeys) {
					if (e.keyCode === 37) {
						keydownAction = 'prev';
					} else if (e.keyCode === 39) {
						keydownAction = 'next';
					}
				}

				if (keydownAction) {
					// don't do anything if special key pressed to prevent from overriding default browser actions
					// e.g. in Chrome on Mac cmd+arrow-left returns to previous page
					if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
						if (e.preventDefault) {
							e.preventDefault();
						} else {
							e.returnValue = false;
						}
						self[keydownAction]();
					}
				}
			},
			    _onGlobalClick = function _onGlobalClick(e) {
				if (!e) {
					return;
				}

				// don't allow click event to pass through when triggering after drag or some other gesture
				if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
					e.preventDefault();
					e.stopPropagation();
				}
			},
			    _updatePageScrollOffset = function _updatePageScrollOffset() {
				self.setScrollOffset(0, framework.getScrollY());
			};

			// Micro animation engine
			var _animations = {},
			    _numAnimations = 0,
			    _stopAnimation = function _stopAnimation(name) {
				if (_animations[name]) {
					if (_animations[name].raf) {
						_cancelAF(_animations[name].raf);
					}
					_numAnimations--;
					delete _animations[name];
				}
			},
			    _registerStartAnimation = function _registerStartAnimation(name) {
				if (_animations[name]) {
					_stopAnimation(name);
				}
				if (!_animations[name]) {
					_numAnimations++;
					_animations[name] = {};
				}
			},
			    _stopAllAnimations = function _stopAllAnimations() {
				for (var prop in _animations) {

					if (_animations.hasOwnProperty(prop)) {
						_stopAnimation(prop);
					}
				}
			},
			    _animateProp = function _animateProp(name, b, endProp, d, easingFn, onUpdate, onComplete) {
				var startAnimTime = _getCurrentTime(),
				    t;
				_registerStartAnimation(name);

				var animloop = function animloop() {
					if (_animations[name]) {

						t = _getCurrentTime() - startAnimTime; // time diff
						//b - beginning (start prop)
						//d - anim duration

						if (t >= d) {
							_stopAnimation(name);
							onUpdate(endProp);
							if (onComplete) {
								onComplete();
							}
							return;
						}
						onUpdate((endProp - b) * easingFn(t / d) + b);

						_animations[name].raf = _requestAF(animloop);
					}
				};
				animloop();
			};

			var publicMethods = {

				// make a few local variables and functions public
				shout: _shout,
				listen: _listen,
				viewportSize: _viewportSize,
				options: _options,

				isMainScrollAnimating: function isMainScrollAnimating() {
					return _mainScrollAnimating;
				},
				getZoomLevel: function getZoomLevel() {
					return _currZoomLevel;
				},
				getCurrentIndex: function getCurrentIndex() {
					return _currentItemIndex;
				},
				isDragging: function isDragging() {
					return _isDragging;
				},
				isZooming: function isZooming() {
					return _isZooming;
				},
				setScrollOffset: function setScrollOffset(x, y) {
					_offset.x = x;
					_currentWindowScrollY = _offset.y = y;
					_shout('updateScrollOffset', _offset);
				},
				applyZoomPan: function applyZoomPan(zoomLevel, panX, panY, allowRenderResolution) {
					_panOffset.x = panX;
					_panOffset.y = panY;
					_currZoomLevel = zoomLevel;
					_applyCurrentZoomPan(allowRenderResolution);
				},

				init: function init() {

					if (_isOpen || _isDestroying) {
						return;
					}

					var i;

					self.framework = framework; // basic functionality
					self.template = template; // root DOM element of PhotoSwipe
					self.bg = framework.getChildByClass(template, 'pswp__bg');

					_initalClassName = template.className;
					_isOpen = true;

					_features = framework.detectFeatures();
					_requestAF = _features.raf;
					_cancelAF = _features.caf;
					_transformKey = _features.transform;
					_oldIE = _features.oldIE;

					self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
					self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');

					_containerStyle = self.container.style; // for fast access

					// Objects that hold slides (there are only 3 in DOM)
					self.itemHolders = _itemHolders = [{ el: self.container.children[0], wrap: 0, index: -1 }, { el: self.container.children[1], wrap: 0, index: -1 }, { el: self.container.children[2], wrap: 0, index: -1 }];

					// hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
					_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';

					_setupTransforms();

					// Setup global events
					_globalEventHandlers = {
						resize: self.updateSize,

						// Fixes: iOS 10.3 resize event
						// does not update scrollWrap.clientWidth instantly after resize
						// https://github.com/dimsemenov/PhotoSwipe/issues/1315
						orientationchange: function orientationchange() {
							clearTimeout(_orientationChangeTimeout);
							_orientationChangeTimeout = setTimeout(function () {
								if (_viewportSize.x !== self.scrollWrap.clientWidth) {
									self.updateSize();
								}
							}, 500);
						},
						scroll: _updatePageScrollOffset,
						keydown: _onKeyDown,
						click: _onGlobalClick
					};

					// disable show/hide effects on old browsers that don't support CSS animations or transforms, 
					// old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
					var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
					if (!_features.animationName || !_features.transform || oldPhone) {
						_options.showAnimationDuration = _options.hideAnimationDuration = 0;
					}

					// init modules
					for (i = 0; i < _modules.length; i++) {
						self['init' + _modules[i]]();
					}

					// init
					if (UiClass) {
						var ui = self.ui = new UiClass(self, framework);
						ui.init();
					}

					_shout('firstUpdate');
					_currentItemIndex = _currentItemIndex || _options.index || 0;
					// validate index
					if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) {
						_currentItemIndex = 0;
					}
					self.currItem = _getItemAt(_currentItemIndex);

					if (_features.isOldIOSPhone || _features.isOldAndroid) {
						_isFixedPosition = false;
					}

					template.setAttribute('aria-hidden', 'false');
					if (_options.modal) {
						if (!_isFixedPosition) {
							template.style.position = 'absolute';
							template.style.top = framework.getScrollY() + 'px';
						} else {
							template.style.position = 'fixed';
						}
					}

					if (_currentWindowScrollY === undefined) {
						_shout('initialLayout');
						_currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
					}

					// add classes to root element of PhotoSwipe
					var rootClasses = 'pswp--open ';
					if (_options.mainClass) {
						rootClasses += _options.mainClass + ' ';
					}
					if (_options.showHideOpacity) {
						rootClasses += 'pswp--animate_opacity ';
					}
					rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
					rootClasses += _features.animationName ? ' pswp--css_animation' : '';
					rootClasses += _features.svg ? ' pswp--svg' : '';
					framework.addClass(template, rootClasses);

					self.updateSize();

					// initial update
					_containerShiftIndex = -1;
					_indexDiff = null;
					for (i = 0; i < NUM_HOLDERS; i++) {
						_setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
					}

					if (!_oldIE) {
						framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
					}

					_listen('initialZoomInEnd', function () {
						self.setContent(_itemHolders[0], _currentItemIndex - 1);
						self.setContent(_itemHolders[2], _currentItemIndex + 1);

						_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';

						if (_options.focus) {
							// focus causes layout, 
							// which causes lag during the animation, 
							// that's why we delay it untill the initial zoom transition ends
							template.focus();
						}

						_bindEvents();
					});

					// set content for center slide (first time)
					self.setContent(_itemHolders[1], _currentItemIndex);

					self.updateCurrItem();

					_shout('afterInit');

					if (!_isFixedPosition) {

						// On all versions of iOS lower than 8.0, we check size of viewport every second.
						// 
						// This is done to detect when Safari top & bottom bars appear, 
						// as this action doesn't trigger any events (like resize). 
						// 
						// On iOS8 they fixed this.
						// 
						// 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.

						_updateSizeInterval = setInterval(function () {
							if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self.currItem.initialZoomLevel) {
								self.updateSize();
							}
						}, 1000);
					}

					framework.addClass(template, 'pswp--visible');
				},

				// Close the gallery, then destroy it
				close: function close() {
					if (!_isOpen) {
						return;
					}

					_isOpen = false;
					_isDestroying = true;
					_shout('close');
					_unbindEvents();

					_showOrHide(self.currItem, null, true, self.destroy);
				},

				// destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
				destroy: function destroy() {
					_shout('destroy');

					if (_showOrHideTimeout) {
						clearTimeout(_showOrHideTimeout);
					}

					template.setAttribute('aria-hidden', 'true');
					template.className = _initalClassName;

					if (_updateSizeInterval) {
						clearInterval(_updateSizeInterval);
					}

					framework.unbind(self.scrollWrap, _downEvents, self);

					// we unbind scroll event at the end, as closing animation may depend on it
					framework.unbind(window, 'scroll', self);

					_stopDragUpdateLoop();

					_stopAllAnimations();

					_listeners = null;
				},

				/**
	    * Pan image to position
	    * @param {Number} x     
	    * @param {Number} y     
	    * @param {Boolean} force Will ignore bounds if set to true.
	    */
				panTo: function panTo(x, y, force) {
					if (!force) {
						if (x > _currPanBounds.min.x) {
							x = _currPanBounds.min.x;
						} else if (x < _currPanBounds.max.x) {
							x = _currPanBounds.max.x;
						}

						if (y > _currPanBounds.min.y) {
							y = _currPanBounds.min.y;
						} else if (y < _currPanBounds.max.y) {
							y = _currPanBounds.max.y;
						}
					}

					_panOffset.x = x;
					_panOffset.y = y;
					_applyCurrentZoomPan();
				},

				handleEvent: function handleEvent(e) {
					e = e || window.event;
					if (_globalEventHandlers[e.type]) {
						_globalEventHandlers[e.type](e);
					}
				},

				goTo: function goTo(index) {

					index = _getLoopedId(index);

					var diff = index - _currentItemIndex;
					_indexDiff = diff;

					_currentItemIndex = index;
					self.currItem = _getItemAt(_currentItemIndex);
					_currPositionIndex -= diff;

					_moveMainScroll(_slideSize.x * _currPositionIndex);

					_stopAllAnimations();
					_mainScrollAnimating = false;

					self.updateCurrItem();
				},
				next: function next() {
					self.goTo(_currentItemIndex + 1);
				},
				prev: function prev() {
					self.goTo(_currentItemIndex - 1);
				},

				// update current zoom/pan objects
				updateCurrZoomItem: function updateCurrZoomItem(emulateSetContent) {
					if (emulateSetContent) {
						_shout('beforeChange', 0);
					}

					// itemHolder[1] is middle (current) item
					if (_itemHolders[1].el.children.length) {
						var zoomElement = _itemHolders[1].el.children[0];
						if (framework.hasClass(zoomElement, 'pswp__zoom-wrap')) {
							_currZoomElementStyle = zoomElement.style;
						} else {
							_currZoomElementStyle = null;
						}
					} else {
						_currZoomElementStyle = null;
					}

					_currPanBounds = self.currItem.bounds;
					_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;

					_panOffset.x = _currPanBounds.center.x;
					_panOffset.y = _currPanBounds.center.y;

					if (emulateSetContent) {
						_shout('afterChange');
					}
				},

				invalidateCurrItems: function invalidateCurrItems() {
					_itemsNeedUpdate = true;
					for (var i = 0; i < NUM_HOLDERS; i++) {
						if (_itemHolders[i].item) {
							_itemHolders[i].item.needsUpdate = true;
						}
					}
				},

				updateCurrItem: function updateCurrItem(beforeAnimation) {

					if (_indexDiff === 0) {
						return;
					}

					var diffAbs = Math.abs(_indexDiff),
					    tempHolder;

					if (beforeAnimation && diffAbs < 2) {
						return;
					}

					self.currItem = _getItemAt(_currentItemIndex);
					_renderMaxResolution = false;

					_shout('beforeChange', _indexDiff);

					if (diffAbs >= NUM_HOLDERS) {
						_containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
						diffAbs = NUM_HOLDERS;
					}
					for (var i = 0; i < diffAbs; i++) {
						if (_indexDiff > 0) {
							tempHolder = _itemHolders.shift();
							_itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last

							_containerShiftIndex++;
							_setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
							self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
						} else {
							tempHolder = _itemHolders.pop();
							_itemHolders.unshift(tempHolder); // move last to first

							_containerShiftIndex--;
							_setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
							self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
						}
					}

					// reset zoom/pan on previous item
					if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {

						var prevItem = _getItemAt(_prevItemIndex);
						if (prevItem.initialZoomLevel !== _currZoomLevel) {
							_calculateItemSize(prevItem, _viewportSize);
							_setImageSize(prevItem);
							_applyZoomPanToItem(prevItem);
						}
					}

					// reset diff after update
					_indexDiff = 0;

					self.updateCurrZoomItem();

					_prevItemIndex = _currentItemIndex;

					_shout('afterChange');
				},

				updateSize: function updateSize(force) {

					if (!_isFixedPosition && _options.modal) {
						var windowScrollY = framework.getScrollY();
						if (_currentWindowScrollY !== windowScrollY) {
							template.style.top = windowScrollY + 'px';
							_currentWindowScrollY = windowScrollY;
						}
						if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
							return;
						}
						_windowVisibleSize.x = window.innerWidth;
						_windowVisibleSize.y = window.innerHeight;

						//template.style.width = _windowVisibleSize.x + 'px';
						template.style.height = _windowVisibleSize.y + 'px';
					}

					_viewportSize.x = self.scrollWrap.clientWidth;
					_viewportSize.y = self.scrollWrap.clientHeight;

					_updatePageScrollOffset();

					_slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
					_slideSize.y = _viewportSize.y;

					_moveMainScroll(_slideSize.x * _currPositionIndex);

					_shout('beforeResize'); // even may be used for example to switch image sources


					// don't re-calculate size on inital size update
					if (_containerShiftIndex !== undefined) {

						var holder, item, hIndex;

						for (var i = 0; i < NUM_HOLDERS; i++) {
							holder = _itemHolders[i];
							_setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style);

							hIndex = _currentItemIndex + i - 1;

							if (_options.loop && _getNumItems() > 2) {
								hIndex = _getLoopedId(hIndex);
							}

							// update zoom level on items and refresh source (if needsUpdate)
							item = _getItemAt(hIndex);

							// re-render gallery item if `needsUpdate`,
							// or doesn't have `bounds` (entirely new slide object)
							if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {

								self.cleanSlide(item);

								self.setContent(holder, hIndex);

								// if "center" slide
								if (i === 1) {
									self.currItem = item;
									self.updateCurrZoomItem(true);
								}

								item.needsUpdate = false;
							} else if (holder.index === -1 && hIndex >= 0) {
								// add content first time
								self.setContent(holder, hIndex);
							}
							if (item && item.container) {
								_calculateItemSize(item, _viewportSize);
								_setImageSize(item);
								_applyZoomPanToItem(item);
							}
						}
						_itemsNeedUpdate = false;
					}

					_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
					_currPanBounds = self.currItem.bounds;

					if (_currPanBounds) {
						_panOffset.x = _currPanBounds.center.x;
						_panOffset.y = _currPanBounds.center.y;
						_applyCurrentZoomPan(true);
					}

					_shout('resize');
				},

				// Zoom current item to
				zoomTo: function zoomTo(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
					/*
	    	if(destZoomLevel === 'fit') {
	    		destZoomLevel = self.currItem.fitRatio;
	    	} else if(destZoomLevel === 'fill') {
	    		destZoomLevel = self.currItem.fillRatio;
	    	}
	    */

					if (centerPoint) {
						_startZoomLevel = _currZoomLevel;
						_midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
						_midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
						_equalizePoints(_startPanOffset, _panOffset);
					}

					var destPanBounds = _calculatePanBounds(destZoomLevel, false),
					    destPanOffset = {};

					_modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
					_modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);

					var initialZoomLevel = _currZoomLevel;
					var initialPanOffset = {
						x: _panOffset.x,
						y: _panOffset.y
					};

					_roundPoint(destPanOffset);

					var onUpdate = function onUpdate(now) {
						if (now === 1) {
							_currZoomLevel = destZoomLevel;
							_panOffset.x = destPanOffset.x;
							_panOffset.y = destPanOffset.y;
						} else {
							_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
							_panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
							_panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
						}

						if (updateFn) {
							updateFn(now);
						}

						_applyCurrentZoomPan(now === 1);
					};

					if (speed) {
						_animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
					} else {
						onUpdate(1);
					}
				}

			};

			/*>>core*/

			/*>>gestures*/
			/**
	   * Mouse/touch/pointer event handlers.
	   * 
	   * separated from @core.js for readability
	   */

			var MIN_SWIPE_DISTANCE = 30,
			    DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe

			var _gestureStartTime,
			    _gestureCheckSpeedTime,


			// pool of objects that are used during dragging of zooming
			p = {},
			    // first point
			p2 = {},
			    // second point (for zoom gesture)
			delta = {},
			    _currPoint = {},
			    _startPoint = {},
			    _currPointers = [],
			    _startMainScrollPos = {},
			    _releaseAnimData,
			    _posPoints = [],
			    // array of points during dragging, used to determine type of gesture
			_tempPoint = {},
			    _isZoomingIn,
			    _verticalDragInitiated,
			    _oldAndroidTouchEndTimeout,
			    _currZoomedItemIndex = 0,
			    _centerPoint = _getEmptyPoint(),
			    _lastReleaseTime = 0,
			    _isDragging,
			    // at least one pointer is down
			_isMultitouch,
			    // at least two _pointers are down
			_zoomStarted,
			    // zoom level changed during zoom gesture
			_moved,
			    _dragAnimFrame,
			    _mainScrollShifted,
			    _currentPoints,
			    // array of current touch points
			_isZooming,
			    _currPointsDistance,
			    _startPointsDistance,
			    _currPanBounds,
			    _mainScrollPos = _getEmptyPoint(),
			    _currZoomElementStyle,
			    _mainScrollAnimating,
			    // true, if animation after swipe gesture is running
			_midZoomPoint = _getEmptyPoint(),
			    _currCenterPoint = _getEmptyPoint(),
			    _direction,
			    _isFirstMove,
			    _opacityChanged,
			    _bgOpacity,
			    _wasOverInitialZoom,
			    _isEqualPoints = function _isEqualPoints(p1, p2) {
				return p1.x === p2.x && p1.y === p2.y;
			},
			    _isNearbyPoints = function _isNearbyPoints(touch0, touch1) {
				return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
			},
			    _calculatePointsDistance = function _calculatePointsDistance(p1, p2) {
				_tempPoint.x = Math.abs(p1.x - p2.x);
				_tempPoint.y = Math.abs(p1.y - p2.y);
				return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
			},
			    _stopDragUpdateLoop = function _stopDragUpdateLoop() {
				if (_dragAnimFrame) {
					_cancelAF(_dragAnimFrame);
					_dragAnimFrame = null;
				}
			},
			    _dragUpdateLoop = function _dragUpdateLoop() {
				if (_isDragging) {
					_dragAnimFrame = _requestAF(_dragUpdateLoop);
					_renderMovement();
				}
			},
			    _canPan = function _canPan() {
				return !(_options.scaleMode === 'fit' && _currZoomLevel === self.currItem.initialZoomLevel);
			},


			// find the closest parent DOM element
			_closestElement = function _closestElement(el, fn) {
				if (!el || el === document) {
					return false;
				}

				// don't search elements above pswp__scroll-wrap
				if (el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1) {
					return false;
				}

				if (fn(el)) {
					return el;
				}

				return _closestElement(el.parentNode, fn);
			},
			    _preventObj = {},
			    _preventDefaultEventBehaviour = function _preventDefaultEventBehaviour(e, isDown) {
				_preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);

				_shout('preventDragEvent', e, isDown, _preventObj);
				return _preventObj.prevent;
			},
			    _convertTouchToPoint = function _convertTouchToPoint(touch, p) {
				p.x = touch.pageX;
				p.y = touch.pageY;
				p.id = touch.identifier;
				return p;
			},
			    _findCenterOfPoints = function _findCenterOfPoints(p1, p2, pCenter) {
				pCenter.x = (p1.x + p2.x) * 0.5;
				pCenter.y = (p1.y + p2.y) * 0.5;
			},
			    _pushPosPoint = function _pushPosPoint(time, x, y) {
				if (time - _gestureCheckSpeedTime > 50) {
					var o = _posPoints.length > 2 ? _posPoints.shift() : {};
					o.x = x;
					o.y = y;
					_posPoints.push(o);
					_gestureCheckSpeedTime = time;
				}
			},
			    _calculateVerticalDragOpacityRatio = function _calculateVerticalDragOpacityRatio() {
				var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
				return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
			},


			// points pool, reused during touch events
			_ePoint1 = {},
			    _ePoint2 = {},
			    _tempPointsArr = [],
			    _tempCounter,
			    _getTouchPoints = function _getTouchPoints(e) {
				// clean up previous points, without recreating array
				while (_tempPointsArr.length > 0) {
					_tempPointsArr.pop();
				}

				if (!_pointerEventEnabled) {
					if (e.type.indexOf('touch') > -1) {

						if (e.touches && e.touches.length > 0) {
							_tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
							if (e.touches.length > 1) {
								_tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
							}
						}
					} else {
						_ePoint1.x = e.pageX;
						_ePoint1.y = e.pageY;
						_ePoint1.id = '';
						_tempPointsArr[0] = _ePoint1; //_ePoint1;
					}
				} else {
					_tempCounter = 0;
					// we can use forEach, as pointer events are supported only in modern browsers
					_currPointers.forEach(function (p) {
						if (_tempCounter === 0) {
							_tempPointsArr[0] = p;
						} else if (_tempCounter === 1) {
							_tempPointsArr[1] = p;
						}
						_tempCounter++;
					});
				}
				return _tempPointsArr;
			},
			    _panOrMoveMainScroll = function _panOrMoveMainScroll(axis, delta) {

				var panFriction,
				    overDiff = 0,
				    newOffset = _panOffset[axis] + delta[axis],
				    startOverDiff,
				    dir = delta[axis] > 0,
				    newMainScrollPosition = _mainScrollPos.x + delta.x,
				    mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
				    newPanPos,
				    newMainScrollPos;

				// calculate fdistance over the bounds and friction
				if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
					panFriction = _options.panEndFriction;
					// Linear increasing of friction, so at 1/4 of viewport it's at max value. 
					// Looks not as nice as was expected. Left for history.
					// panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
				} else {
					panFriction = 1;
				}

				newOffset = _panOffset[axis] + delta[axis] * panFriction;

				// move main scroll or start panning
				if (_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {

					if (!_currZoomElementStyle) {

						newMainScrollPos = newMainScrollPosition;
					} else if (_direction === 'h' && axis === 'x' && !_zoomStarted) {

						if (dir) {
							if (newOffset > _currPanBounds.min[axis]) {
								panFriction = _options.panEndFriction;
								overDiff = _currPanBounds.min[axis] - newOffset;
								startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
							}

							// drag right
							if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
								newMainScrollPos = newMainScrollPosition;
								if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
									newMainScrollPos = _startMainScrollPos.x;
								}
							} else {
								if (_currPanBounds.min.x !== _currPanBounds.max.x) {
									newPanPos = newOffset;
								}
							}
						} else {

							if (newOffset < _currPanBounds.max[axis]) {
								panFriction = _options.panEndFriction;
								overDiff = newOffset - _currPanBounds.max[axis];
								startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
							}

							if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
								newMainScrollPos = newMainScrollPosition;

								if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
									newMainScrollPos = _startMainScrollPos.x;
								}
							} else {
								if (_currPanBounds.min.x !== _currPanBounds.max.x) {
									newPanPos = newOffset;
								}
							}
						}

						//
					}

					if (axis === 'x') {

						if (newMainScrollPos !== undefined) {
							_moveMainScroll(newMainScrollPos, true);
							if (newMainScrollPos === _startMainScrollPos.x) {
								_mainScrollShifted = false;
							} else {
								_mainScrollShifted = true;
							}
						}

						if (_currPanBounds.min.x !== _currPanBounds.max.x) {
							if (newPanPos !== undefined) {
								_panOffset.x = newPanPos;
							} else if (!_mainScrollShifted) {
								_panOffset.x += delta.x * panFriction;
							}
						}

						return newMainScrollPos !== undefined;
					}
				}

				if (!_mainScrollAnimating) {

					if (!_mainScrollShifted) {
						if (_currZoomLevel > self.currItem.fitRatio) {
							_panOffset[axis] += delta[axis] * panFriction;
						}
					}
				}
			},


			// Pointerdown/touchstart/mousedown handler
			_onDragStart = function _onDragStart(e) {

				// Allow dragging only via left mouse button.
				// As this handler is not added in IE8 - we ignore e.which
				// 
				// http://www.quirksmode.org/js/events_properties.html
				// https://developer.mozilla.org/en-US/docs/Web/API/event.button
				if (e.type === 'mousedown' && e.button > 0) {
					return;
				}

				if (_initialZoomRunning) {
					e.preventDefault();
					return;
				}

				if (_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
					return;
				}

				if (_preventDefaultEventBehaviour(e, true)) {
					e.preventDefault();
				}

				_shout('pointerDown');

				if (_pointerEventEnabled) {
					var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
					if (pointerIndex < 0) {
						pointerIndex = _currPointers.length;
					}
					_currPointers[pointerIndex] = { x: e.pageX, y: e.pageY, id: e.pointerId };
				}

				var startPointsList = _getTouchPoints(e),
				    numPoints = startPointsList.length;

				_currentPoints = null;

				_stopAllAnimations();

				// init drag
				if (!_isDragging || numPoints === 1) {

					_isDragging = _isFirstMove = true;
					framework.bind(window, _upMoveEvents, self);

					_isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;

					_direction = null;

					_shout('firstTouchStart', startPointsList);

					_equalizePoints(_startPanOffset, _panOffset);

					_currPanDist.x = _currPanDist.y = 0;
					_equalizePoints(_currPoint, startPointsList[0]);
					_equalizePoints(_startPoint, _currPoint);

					//_equalizePoints(_startMainScrollPos, _mainScrollPos);
					_startMainScrollPos.x = _slideSize.x * _currPositionIndex;

					_posPoints = [{
						x: _currPoint.x,
						y: _currPoint.y
					}];

					_gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();

					//_mainScrollAnimationEnd(true);
					_calculatePanBounds(_currZoomLevel, true);

					// Start rendering
					_stopDragUpdateLoop();
					_dragUpdateLoop();
				}

				// init zoom
				if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
					_startZoomLevel = _currZoomLevel;
					_zoomStarted = false; // true if zoom changed at least once

					_isZooming = _isMultitouch = true;
					_currPanDist.y = _currPanDist.x = 0;

					_equalizePoints(_startPanOffset, _panOffset);

					_equalizePoints(p, startPointsList[0]);
					_equalizePoints(p2, startPointsList[1]);

					_findCenterOfPoints(p, p2, _currCenterPoint);

					_midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
					_midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
					_currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
				}
			},


			// Pointermove/touchmove/mousemove handler
			_onDragMove = function _onDragMove(e) {

				e.preventDefault();

				if (_pointerEventEnabled) {
					var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
					if (pointerIndex > -1) {
						var p = _currPointers[pointerIndex];
						p.x = e.pageX;
						p.y = e.pageY;
					}
				}

				if (_isDragging) {
					var touchesList = _getTouchPoints(e);
					if (!_direction && !_moved && !_isZooming) {

						if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
							// if main scroll position is shifted – direction is always horizontal
							_direction = 'h';
						} else {
							var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
							// check the direction of movement
							if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
								_direction = diff > 0 ? 'h' : 'v';
								_currentPoints = touchesList;
							}
						}
					} else {
						_currentPoints = touchesList;
					}
				}
			},

			// 
			_renderMovement = function _renderMovement() {

				if (!_currentPoints) {
					return;
				}

				var numPoints = _currentPoints.length;

				if (numPoints === 0) {
					return;
				}

				_equalizePoints(p, _currentPoints[0]);

				delta.x = p.x - _currPoint.x;
				delta.y = p.y - _currPoint.y;

				if (_isZooming && numPoints > 1) {
					// Handle behaviour for more than 1 point

					_currPoint.x = p.x;
					_currPoint.y = p.y;

					// check if one of two points changed
					if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) {
						return;
					}

					_equalizePoints(p2, _currentPoints[1]);

					if (!_zoomStarted) {
						_zoomStarted = true;
						_shout('zoomGestureStarted');
					}

					// Distance between two points
					var pointsDistance = _calculatePointsDistance(p, p2);

					var zoomLevel = _calculateZoomLevel(pointsDistance);

					// slightly over the of initial zoom level
					if (zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
						_wasOverInitialZoom = true;
					}

					// Apply the friction if zoom level is out of the bounds
					var zoomFriction = 1,
					    minZoomLevel = _getMinZoomLevel(),
					    maxZoomLevel = _getMaxZoomLevel();

					if (zoomLevel < minZoomLevel) {

						if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
							// fade out background if zooming out
							var minusDiff = minZoomLevel - zoomLevel;
							var percent = 1 - minusDiff / (minZoomLevel / 1.2);

							_applyBgOpacity(percent);
							_shout('onPinchClose', percent);
							_opacityChanged = true;
						} else {
							zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
							if (zoomFriction > 1) {
								zoomFriction = 1;
							}
							zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
						}
					} else if (zoomLevel > maxZoomLevel) {
						// 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
						zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
						if (zoomFriction > 1) {
							zoomFriction = 1;
						}
						zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
					}

					if (zoomFriction < 0) {
						zoomFriction = 0;
					}

					// distance between touch points after friction is applied
					_currPointsDistance = pointsDistance;

					// _centerPoint - The point in the middle of two pointers
					_findCenterOfPoints(p, p2, _centerPoint);

					// paning with two pointers pressed
					_currPanDist.x += _centerPoint.x - _currCenterPoint.x;
					_currPanDist.y += _centerPoint.y - _currCenterPoint.y;
					_equalizePoints(_currCenterPoint, _centerPoint);

					_panOffset.x = _calculatePanOffset('x', zoomLevel);
					_panOffset.y = _calculatePanOffset('y', zoomLevel);

					_isZoomingIn = zoomLevel > _currZoomLevel;
					_currZoomLevel = zoomLevel;
					_applyCurrentZoomPan();
				} else {

					// handle behaviour for one point (dragging or panning)

					if (!_direction) {
						return;
					}

					if (_isFirstMove) {
						_isFirstMove = false;

						// subtract drag distance that was used during the detection direction  

						if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
							delta.x -= _currentPoints[0].x - _startPoint.x;
						}

						if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
							delta.y -= _currentPoints[0].y - _startPoint.y;
						}
					}

					_currPoint.x = p.x;
					_currPoint.y = p.y;

					// do nothing if pointers position hasn't changed
					if (delta.x === 0 && delta.y === 0) {
						return;
					}

					if (_direction === 'v' && _options.closeOnVerticalDrag) {
						if (!_canPan()) {
							_currPanDist.y += delta.y;
							_panOffset.y += delta.y;

							var opacityRatio = _calculateVerticalDragOpacityRatio();

							_verticalDragInitiated = true;
							_shout('onVerticalDrag', opacityRatio);

							_applyBgOpacity(opacityRatio);
							_applyCurrentZoomPan();
							return;
						}
					}

					_pushPosPoint(_getCurrentTime(), p.x, p.y);

					_moved = true;
					_currPanBounds = self.currItem.bounds;

					var mainScrollChanged = _panOrMoveMainScroll('x', delta);
					if (!mainScrollChanged) {
						_panOrMoveMainScroll('y', delta);

						_roundPoint(_panOffset);
						_applyCurrentZoomPan();
					}
				}
			},


			// Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
			_onDragRelease = function _onDragRelease(e) {

				if (_features.isOldAndroid) {

					if (_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
						return;
					}

					// on Android (v4.1, 4.2, 4.3 & possibly older) 
					// ghost mousedown/up event isn't preventable via e.preventDefault,
					// which causes fake mousedown event
					// so we block mousedown/up for 600ms
					if (e.type.indexOf('touch') > -1) {
						clearTimeout(_oldAndroidTouchEndTimeout);
						_oldAndroidTouchEndTimeout = setTimeout(function () {
							_oldAndroidTouchEndTimeout = 0;
						}, 600);
					}
				}

				_shout('pointerUp');

				if (_preventDefaultEventBehaviour(e, false)) {
					e.preventDefault();
				}

				var releasePoint;

				if (_pointerEventEnabled) {
					var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');

					if (pointerIndex > -1) {
						releasePoint = _currPointers.splice(pointerIndex, 1)[0];

						if (navigator.pointerEnabled) {
							releasePoint.type = e.pointerType || 'mouse';
						} else {
							var MSPOINTER_TYPES = {
								4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
								2: 'touch', // event.MSPOINTER_TYPE_TOUCH 
								3: 'pen' // event.MSPOINTER_TYPE_PEN
							};
							releasePoint.type = MSPOINTER_TYPES[e.pointerType];

							if (!releasePoint.type) {
								releasePoint.type = e.pointerType || 'mouse';
							}
						}
					}
				}

				var touchList = _getTouchPoints(e),
				    gestureType,
				    numPoints = touchList.length;

				if (e.type === 'mouseup') {
					numPoints = 0;
				}

				// Do nothing if there were 3 touch points or more
				if (numPoints === 2) {
					_currentPoints = null;
					return true;
				}

				// if second pointer released
				if (numPoints === 1) {
					_equalizePoints(_startPoint, touchList[0]);
				}

				// pointer hasn't moved, send "tap release" point
				if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
					if (!releasePoint) {
						if (e.type === 'mouseup') {
							releasePoint = { x: e.pageX, y: e.pageY, type: 'mouse' };
						} else if (e.changedTouches && e.changedTouches[0]) {
							releasePoint = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: 'touch' };
						}
					}

					_shout('touchRelease', e, releasePoint);
				}

				// Difference in time between releasing of two last touch points (zoom gesture)
				var releaseTimeDiff = -1;

				// Gesture completed, no pointers left
				if (numPoints === 0) {
					_isDragging = false;
					framework.unbind(window, _upMoveEvents, self);

					_stopDragUpdateLoop();

					if (_isZooming) {
						// Two points released at the same time
						releaseTimeDiff = 0;
					} else if (_lastReleaseTime !== -1) {
						releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
					}
				}
				_lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;

				if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
					gestureType = 'zoom';
				} else {
					gestureType = 'swipe';
				}

				if (_isZooming && numPoints < 2) {
					_isZooming = false;

					// Only second point released
					if (numPoints === 1) {
						gestureType = 'zoomPointerUp';
					}
					_shout('zoomGestureEnded');
				}

				_currentPoints = null;
				if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
					// nothing to animate
					return;
				}

				_stopAllAnimations();

				if (!_releaseAnimData) {
					_releaseAnimData = _initDragReleaseAnimationData();
				}

				_releaseAnimData.calculateSwipeSpeed('x');

				if (_verticalDragInitiated) {

					var opacityRatio = _calculateVerticalDragOpacityRatio();

					if (opacityRatio < _options.verticalDragRange) {
						self.close();
					} else {
						var initalPanY = _panOffset.y,
						    initialBgOpacity = _bgOpacity;

						_animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function (now) {

							_panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;

							_applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity);
							_applyCurrentZoomPan();
						});

						_shout('onVerticalDrag', 1);
					}

					return;
				}

				// main scroll 
				if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
					var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
					if (itemChanged) {
						return;
					}
					gestureType = 'zoomPointerUp';
				}

				// prevent zoom/pan animation when main scroll animation runs
				if (_mainScrollAnimating) {
					return;
				}

				// Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
				if (gestureType !== 'swipe') {
					_completeZoomGesture();
					return;
				}

				// Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
				if (!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
					_completePanGesture(_releaseAnimData);
				}
			},


			// Returns object with data about gesture
			// It's created only once and then reused
			_initDragReleaseAnimationData = function _initDragReleaseAnimationData() {
				// temp local vars
				var lastFlickDuration, tempReleasePos;

				// s = this
				var s = {
					lastFlickOffset: {},
					lastFlickDist: {},
					lastFlickSpeed: {},
					slowDownRatio: {},
					slowDownRatioReverse: {},
					speedDecelerationRatio: {},
					speedDecelerationRatioAbs: {},
					distanceOffset: {},
					backAnimDestination: {},
					backAnimStarted: {},
					calculateSwipeSpeed: function calculateSwipeSpeed(axis) {

						if (_posPoints.length > 1) {
							lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
							tempReleasePos = _posPoints[_posPoints.length - 2][axis];
						} else {
							lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
							tempReleasePos = _startPoint[axis];
						}
						s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
						s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
						if (s.lastFlickDist[axis] > 20) {
							s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
						} else {
							s.lastFlickSpeed[axis] = 0;
						}
						if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) {
							s.lastFlickSpeed[axis] = 0;
						}

						s.slowDownRatio[axis] = 0.95;
						s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
						s.speedDecelerationRatio[axis] = 1;
					},

					calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(axis, speed) {
						if (!s.backAnimStarted[axis]) {

							if (_panOffset[axis] > _currPanBounds.min[axis]) {
								s.backAnimDestination[axis] = _currPanBounds.min[axis];
							} else if (_panOffset[axis] < _currPanBounds.max[axis]) {
								s.backAnimDestination[axis] = _currPanBounds.max[axis];
							}

							if (s.backAnimDestination[axis] !== undefined) {
								s.slowDownRatio[axis] = 0.7;
								s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
								if (s.speedDecelerationRatioAbs[axis] < 0.05) {

									s.lastFlickSpeed[axis] = 0;
									s.backAnimStarted[axis] = true;

									_animateProp('bounceZoomPan' + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function (pos) {
										_panOffset[axis] = pos;
										_applyCurrentZoomPan();
									});
								}
							}
						}
					},

					// Reduces the speed by slowDownRatio (per 10ms)
					calculateAnimOffset: function calculateAnimOffset(axis) {
						if (!s.backAnimStarted[axis]) {
							s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10);

							s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
							s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
							_panOffset[axis] += s.distanceOffset[axis];
						}
					},

					panAnimLoop: function panAnimLoop() {
						if (_animations.zoomPan) {
							_animations.zoomPan.raf = _requestAF(s.panAnimLoop);

							s.now = _getCurrentTime();
							s.timeDiff = s.now - s.lastNow;
							s.lastNow = s.now;

							s.calculateAnimOffset('x');
							s.calculateAnimOffset('y');

							_applyCurrentZoomPan();

							s.calculateOverBoundsAnimOffset('x');
							s.calculateOverBoundsAnimOffset('y');

							if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {

								// round pan position
								_panOffset.x = Math.round(_panOffset.x);
								_panOffset.y = Math.round(_panOffset.y);
								_applyCurrentZoomPan();

								_stopAnimation('zoomPan');
								return;
							}
						}
					}
				};
				return s;
			},
			    _completePanGesture = function _completePanGesture(animData) {
				// calculate swipe speed for Y axis (paanning)
				animData.calculateSwipeSpeed('y');

				_currPanBounds = self.currItem.bounds;

				animData.backAnimDestination = {};
				animData.backAnimStarted = {};

				// Avoid acceleration animation if speed is too low
				if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
					animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;

					// Run pan drag release animation. E.g. if you drag image and release finger without momentum.
					animData.calculateOverBoundsAnimOffset('x');
					animData.calculateOverBoundsAnimOffset('y');
					return true;
				}

				// Animation loop that controls the acceleration after pan gesture ends
				_registerStartAnimation('zoomPan');
				animData.lastNow = _getCurrentTime();
				animData.panAnimLoop();
			},
			    _finishSwipeMainScrollGesture = function _finishSwipeMainScrollGesture(gestureType, _releaseAnimData) {
				var itemChanged;
				if (!_mainScrollAnimating) {
					_currZoomedItemIndex = _currentItemIndex;
				}

				var itemsDiff;

				if (gestureType === 'swipe') {
					var totalShiftDist = _currPoint.x - _startPoint.x,
					    isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;

					// if container is shifted for more than MIN_SWIPE_DISTANCE, 
					// and last flick gesture was in right direction
					if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)) {
						// go to prev item
						itemsDiff = -1;
					} else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)) {
						// go to next item
						itemsDiff = 1;
					}
				}

				var nextCircle;

				if (itemsDiff) {

					_currentItemIndex += itemsDiff;

					if (_currentItemIndex < 0) {
						_currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
						nextCircle = true;
					} else if (_currentItemIndex >= _getNumItems()) {
						_currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
						nextCircle = true;
					}

					if (!nextCircle || _options.loop) {
						_indexDiff += itemsDiff;
						_currPositionIndex -= itemsDiff;
						itemChanged = true;
					}
				}

				var animateToX = _slideSize.x * _currPositionIndex;
				var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
				var finishAnimDuration;

				if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
					// "return to current" duration, e.g. when dragging from slide 0 to -1
					finishAnimDuration = 333;
				} else {
					finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 333;

					finishAnimDuration = Math.min(finishAnimDuration, 400);
					finishAnimDuration = Math.max(finishAnimDuration, 250);
				}

				if (_currZoomedItemIndex === _currentItemIndex) {
					itemChanged = false;
				}

				_mainScrollAnimating = true;

				_shout('mainScrollAnimStart');

				_animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function () {
					_stopAllAnimations();
					_mainScrollAnimating = false;
					_currZoomedItemIndex = -1;

					if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
						self.updateCurrItem();
					}

					_shout('mainScrollAnimComplete');
				});

				if (itemChanged) {
					self.updateCurrItem(true);
				}

				return itemChanged;
			},
			    _calculateZoomLevel = function _calculateZoomLevel(touchesDistance) {
				return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
			},


			// Resets zoom if it's out of bounds
			_completeZoomGesture = function _completeZoomGesture() {
				var destZoomLevel = _currZoomLevel,
				    minZoomLevel = _getMinZoomLevel(),
				    maxZoomLevel = _getMaxZoomLevel();

				if (_currZoomLevel < minZoomLevel) {
					destZoomLevel = minZoomLevel;
				} else if (_currZoomLevel > maxZoomLevel) {
					destZoomLevel = maxZoomLevel;
				}

				var destOpacity = 1,
				    onUpdate,
				    initialOpacity = _bgOpacity;

				if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
					//_closedByScroll = true;
					self.close();
					return true;
				}

				if (_opacityChanged) {
					onUpdate = function onUpdate(now) {
						_applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity);
					};
				}

				self.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
				return true;
			};

			_registerModule('Gestures', {
				publicMethods: {

					initGestures: function initGestures() {

						// helper function that builds touch/pointer/mouse events
						var addEventNames = function addEventNames(pref, down, move, up, cancel) {
							_dragStartEvent = pref + down;
							_dragMoveEvent = pref + move;
							_dragEndEvent = pref + up;
							if (cancel) {
								_dragCancelEvent = pref + cancel;
							} else {
								_dragCancelEvent = '';
							}
						};

						_pointerEventEnabled = _features.pointerEvent;
						if (_pointerEventEnabled && _features.touch) {
							// we don't need touch events, if browser supports pointer events
							_features.touch = false;
						}

						if (_pointerEventEnabled) {
							if (navigator.pointerEnabled) {
								addEventNames('pointer', 'down', 'move', 'up', 'cancel');
							} else {
								// IE10 pointer events are case-sensitive
								addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
							}
						} else if (_features.touch) {
							addEventNames('touch', 'start', 'move', 'end', 'cancel');
							_likelyTouchDevice = true;
						} else {
							addEventNames('mouse', 'down', 'move', 'up');
						}

						_upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent + ' ' + _dragCancelEvent;
						_downEvents = _dragStartEvent;

						if (_pointerEventEnabled && !_likelyTouchDevice) {
							_likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
						}
						// make variable public
						self.likelyTouchDevice = _likelyTouchDevice;

						_globalEventHandlers[_dragStartEvent] = _onDragStart;
						_globalEventHandlers[_dragMoveEvent] = _onDragMove;
						_globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken

						if (_dragCancelEvent) {
							_globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
						}

						// Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
						if (_features.touch) {
							_downEvents += ' mousedown';
							_upMoveEvents += ' mousemove mouseup';
							_globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
							_globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
							_globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
						}

						if (!_likelyTouchDevice) {
							// don't allow pan to next slide from zoomed state on Desktop
							_options.allowPanToNext = false;
						}
					}

				}
			});

			/*>>gestures*/

			/*>>show-hide-transition*/
			/**
	   * show-hide-transition.js:
	   *
	   * Manages initial opening or closing transition.
	   *
	   * If you're not planning to use transition for gallery at all,
	   * you may set options hideAnimationDuration and showAnimationDuration to 0,
	   * and just delete startAnimation function.
	   * 
	   */

			var _showOrHideTimeout,
			    _showOrHide = function _showOrHide(item, img, out, completeFn) {

				if (_showOrHideTimeout) {
					clearTimeout(_showOrHideTimeout);
				}

				_initialZoomRunning = true;
				_initialContentSet = true;

				// dimensions of small thumbnail {x:,y:,w:}.
				// Height is optional, as calculated based on large image.
				var thumbBounds;
				if (item.initialLayout) {
					thumbBounds = item.initialLayout;
					item.initialLayout = null;
				} else {
					thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
				}

				var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;

				var onComplete = function onComplete() {
					_stopAnimation('initialZoom');
					if (!out) {
						_applyBgOpacity(1);
						if (img) {
							img.style.display = 'block';
						}
						framework.addClass(template, 'pswp--animated-in');
						_shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
					} else {
						self.template.removeAttribute('style');
						self.bg.removeAttribute('style');
					}

					if (completeFn) {
						completeFn();
					}
					_initialZoomRunning = false;
				};

				// if bounds aren't provided, just open gallery without animation
				if (!duration || !thumbBounds || thumbBounds.x === undefined) {

					_shout('initialZoom' + (out ? 'Out' : 'In'));

					_currZoomLevel = item.initialZoomLevel;
					_equalizePoints(_panOffset, item.initialPosition);
					_applyCurrentZoomPan();

					template.style.opacity = out ? 0 : 1;
					_applyBgOpacity(1);

					if (duration) {
						setTimeout(function () {
							onComplete();
						}, duration);
					} else {
						onComplete();
					}

					return;
				}

				var startAnimation = function startAnimation() {
					var closeWithRaf = _closedByScroll,
					    fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;

					// apply hw-acceleration to image
					if (item.miniImg) {
						item.miniImg.style.webkitBackfaceVisibility = 'hidden';
					}

					if (!out) {
						_currZoomLevel = thumbBounds.w / item.w;
						_panOffset.x = thumbBounds.x;
						_panOffset.y = thumbBounds.y - _initalWindowScrollY;

						self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
						_applyCurrentZoomPan();
					}

					_registerStartAnimation('initialZoom');

					if (out && !closeWithRaf) {
						framework.removeClass(template, 'pswp--animated-in');
					}

					if (fadeEverything) {
						if (out) {
							framework[(closeWithRaf ? 'remove' : 'add') + 'Class'](template, 'pswp--animate_opacity');
						} else {
							setTimeout(function () {
								framework.addClass(template, 'pswp--animate_opacity');
							}, 30);
						}
					}

					_showOrHideTimeout = setTimeout(function () {

						_shout('initialZoom' + (out ? 'Out' : 'In'));

						if (!out) {

							// "in" animation always uses CSS transitions (instead of rAF).
							// CSS transition work faster here, 
							// as developer may also want to animate other things, 
							// like ui on top of sliding area, which can be animated just via CSS

							_currZoomLevel = item.initialZoomLevel;
							_equalizePoints(_panOffset, item.initialPosition);
							_applyCurrentZoomPan();
							_applyBgOpacity(1);

							if (fadeEverything) {
								template.style.opacity = 1;
							} else {
								_applyBgOpacity(1);
							}

							_showOrHideTimeout = setTimeout(onComplete, duration + 20);
						} else {

							// "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
							var destZoomLevel = thumbBounds.w / item.w,
							    initialPanOffset = {
								x: _panOffset.x,
								y: _panOffset.y
							},
							    initialZoomLevel = _currZoomLevel,
							    initalBgOpacity = _bgOpacity,
							    onUpdate = function onUpdate(now) {

								if (now === 1) {
									_currZoomLevel = destZoomLevel;
									_panOffset.x = thumbBounds.x;
									_panOffset.y = thumbBounds.y - _currentWindowScrollY;
								} else {
									_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
									_panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
									_panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
								}

								_applyCurrentZoomPan();
								if (fadeEverything) {
									template.style.opacity = 1 - now;
								} else {
									_applyBgOpacity(initalBgOpacity - now * initalBgOpacity);
								}
							};

							if (closeWithRaf) {
								_animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
							} else {
								onUpdate(1);
								_showOrHideTimeout = setTimeout(onComplete, duration + 20);
							}
						}
					}, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
					// create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
					// Which avoids lag at the beginning of scale transition.
				};
				startAnimation();
			};

			/*>>show-hide-transition*/

			/*>>items-controller*/
			/**
	  *
	  * Controller manages gallery items, their dimensions, and their content.
	  * 
	  */

			var _items,
			    _tempPanAreaSize = {},
			    _imagesToAppendPool = [],
			    _initialContentSet,
			    _initialZoomRunning,
			    _controllerDefaultOptions = {
				index: 0,
				errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
				forceProgressiveLoading: false, // TODO
				preload: [1, 1],
				getNumItemsFn: function getNumItemsFn() {
					return _items.length;
				}
			};

			var _getItemAt,
			    _getNumItems,
			    _initialIsLoop,
			    _getZeroBounds = function _getZeroBounds() {
				return {
					center: { x: 0, y: 0 },
					max: { x: 0, y: 0 },
					min: { x: 0, y: 0 }
				};
			},
			    _calculateSingleItemPanBounds = function _calculateSingleItemPanBounds(item, realPanElementW, realPanElementH) {
				var bounds = item.bounds;

				// position of element when it's centered
				bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
				bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;

				// maximum pan position
				bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;

				bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;

				// minimum pan position
				bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
				bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
			},
			    _calculateItemSize = function _calculateItemSize(item, viewportSize, zoomLevel) {

				if (item.src && !item.loadError) {
					var isInitial = !zoomLevel;

					if (isInitial) {
						if (!item.vGap) {
							item.vGap = { top: 0, bottom: 0 };
						}
						// allows overriding vertical margin for individual items
						_shout('parseVerticalMargin', item);
					}

					_tempPanAreaSize.x = viewportSize.x;
					_tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;

					if (isInitial) {
						var hRatio = _tempPanAreaSize.x / item.w;
						var vRatio = _tempPanAreaSize.y / item.h;

						item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
						//item.fillRatio = hRatio > vRatio ? hRatio : vRatio;

						var scaleMode = _options.scaleMode;

						if (scaleMode === 'orig') {
							zoomLevel = 1;
						} else if (scaleMode === 'fit') {
							zoomLevel = item.fitRatio;
						}

						if (zoomLevel > 1) {
							zoomLevel = 1;
						}

						item.initialZoomLevel = zoomLevel;

						if (!item.bounds) {
							// reuse bounds object
							item.bounds = _getZeroBounds();
						}
					}

					if (!zoomLevel) {
						return;
					}

					_calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);

					if (isInitial && zoomLevel === item.initialZoomLevel) {
						item.initialPosition = item.bounds.center;
					}

					return item.bounds;
				} else {
					item.w = item.h = 0;
					item.initialZoomLevel = item.fitRatio = 1;
					item.bounds = _getZeroBounds();
					item.initialPosition = item.bounds.center;

					// if it's not image, we return zero bounds (content is not zoomable)
					return item.bounds;
				}
			},
			    _appendImage = function _appendImage(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {

				if (item.loadError) {
					return;
				}

				if (img) {

					item.imageAppended = true;
					_setImageSize(item, img, item === self.currItem && _renderMaxResolution);

					baseDiv.appendChild(img);

					if (keepPlaceholder) {
						setTimeout(function () {
							if (item && item.loaded && item.placeholder) {
								item.placeholder.style.display = 'none';
								item.placeholder = null;
							}
						}, 500);
					}
				}
			},
			    _preloadImage = function _preloadImage(item) {
				item.loading = true;
				item.loaded = false;
				var img = item.img = framework.createEl('pswp__img', 'img');
				var onComplete = function onComplete() {
					item.loading = false;
					item.loaded = true;

					if (item.loadComplete) {
						item.loadComplete(item);
					} else {
						item.img = null; // no need to store image object
					}
					img.onload = img.onerror = null;
					img = null;
				};
				img.onload = onComplete;
				img.onerror = function () {
					item.loadError = true;
					onComplete();
				};

				img.src = item.src; // + '?a=' + Math.random();

				return img;
			},
			    _checkForError = function _checkForError(item, cleanUp) {
				if (item.src && item.loadError && item.container) {

					if (cleanUp) {
						item.container.innerHTML = '';
					}

					item.container.innerHTML = _options.errorMsg.replace('%url%', item.src);
					return true;
				}
			},
			    _setImageSize = function _setImageSize(item, img, maxRes) {
				if (!item.src) {
					return;
				}

				if (!img) {
					img = item.container.lastChild;
				}

				var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
				    h = maxRes ? item.h : Math.round(item.h * item.fitRatio);

				if (item.placeholder && !item.loaded) {
					item.placeholder.style.width = w + 'px';
					item.placeholder.style.height = h + 'px';
				}

				img.style.width = w + 'px';
				img.style.height = h + 'px';
			},
			    _appendImagesPool = function _appendImagesPool() {

				if (_imagesToAppendPool.length) {
					var poolItem;

					for (var i = 0; i < _imagesToAppendPool.length; i++) {
						poolItem = _imagesToAppendPool[i];
						if (poolItem.holder.index === poolItem.index) {
							_appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
						}
					}
					_imagesToAppendPool = [];
				}
			};

			_registerModule('Controller', {

				publicMethods: {

					lazyLoadItem: function lazyLoadItem(index) {
						index = _getLoopedId(index);
						var item = _getItemAt(index);

						if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) {
							return;
						}

						_shout('gettingData', index, item);

						if (!item.src) {
							return;
						}

						_preloadImage(item);
					},
					initController: function initController() {
						framework.extend(_options, _controllerDefaultOptions, true);
						self.items = _items = items;
						_getItemAt = self.getItemAt;
						_getNumItems = _options.getNumItemsFn; //self.getNumItems;


						_initialIsLoop = _options.loop;
						if (_getNumItems() < 3) {
							_options.loop = false; // disable loop if less then 3 items
						}

						_listen('beforeChange', function (diff) {

							var p = _options.preload,
							    isNext = diff === null ? true : diff >= 0,
							    preloadBefore = Math.min(p[0], _getNumItems()),
							    preloadAfter = Math.min(p[1], _getNumItems()),
							    i;

							for (i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
								self.lazyLoadItem(_currentItemIndex + i);
							}
							for (i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
								self.lazyLoadItem(_currentItemIndex - i);
							}
						});

						_listen('initialLayout', function () {
							self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
						});

						_listen('mainScrollAnimComplete', _appendImagesPool);
						_listen('initialZoomInEnd', _appendImagesPool);

						_listen('destroy', function () {
							var item;
							for (var i = 0; i < _items.length; i++) {
								item = _items[i];
								// remove reference to DOM elements, for GC
								if (item.container) {
									item.container = null;
								}
								if (item.placeholder) {
									item.placeholder = null;
								}
								if (item.img) {
									item.img = null;
								}
								if (item.preloader) {
									item.preloader = null;
								}
								if (item.loadError) {
									item.loaded = item.loadError = false;
								}
							}
							_imagesToAppendPool = null;
						});
					},

					getItemAt: function getItemAt(index) {
						if (index >= 0) {
							return _items[index] !== undefined ? _items[index] : false;
						}
						return false;
					},

					allowProgressiveImg: function allowProgressiveImg() {
						// 1. Progressive image loading isn't working on webkit/blink 
						//    when hw-acceleration (e.g. translateZ) is applied to IMG element.
						//    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
						//    
						// 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
						//    That's why it's disabled on touch devices (mainly because of swipe transition)
						//    
						// 3. Progressive image loading sometimes doesn't work in IE (up to 11).

						// Don't allow progressive loading on non-large touch devices
						return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
						// 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
					},

					setContent: function setContent(holder, index) {

						if (_options.loop) {
							index = _getLoopedId(index);
						}

						var prevItem = self.getItemAt(holder.index);
						if (prevItem) {
							prevItem.container = null;
						}

						var item = self.getItemAt(index),
						    img;

						if (!item) {
							holder.el.innerHTML = '';
							return;
						}

						// allow to override data
						_shout('gettingData', index, item);

						holder.index = index;
						holder.item = item;

						// base container DIV is created only once for each of 3 holders
						var baseDiv = item.container = framework.createEl('pswp__zoom-wrap');

						if (!item.src && item.html) {
							if (item.html.tagName) {
								baseDiv.appendChild(item.html);
							} else {
								baseDiv.innerHTML = item.html;
							}
						}

						_checkForError(item);

						_calculateItemSize(item, _viewportSize);

						if (item.src && !item.loadError && !item.loaded) {

							item.loadComplete = function (item) {

								// gallery closed before image finished loading
								if (!_isOpen) {
									return;
								}

								// check if holder hasn't changed while image was loading
								if (holder && holder.index === index) {
									if (_checkForError(item, true)) {
										item.loadComplete = item.img = null;
										_calculateItemSize(item, _viewportSize);
										_applyZoomPanToItem(item);

										if (holder.index === _currentItemIndex) {
											// recalculate dimensions
											self.updateCurrZoomItem();
										}
										return;
									}
									if (!item.imageAppended) {
										if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) {
											_imagesToAppendPool.push({
												item: item,
												baseDiv: baseDiv,
												img: item.img,
												index: index,
												holder: holder,
												clearPlaceholder: true
											});
										} else {
											_appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
										}
									} else {
										// remove preloader & mini-img
										if (!_initialZoomRunning && item.placeholder) {
											item.placeholder.style.display = 'none';
											item.placeholder = null;
										}
									}
								}

								item.loadComplete = null;
								item.img = null; // no need to store image element after it's added

								_shout('imageLoadComplete', index, item);
							};

							if (framework.features.transform) {

								var placeholderClassName = 'pswp__img pswp__img--placeholder';
								placeholderClassName += item.msrc ? '' : ' pswp__img--placeholder--blank';

								var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
								if (item.msrc) {
									placeholder.src = item.msrc;
								}

								_setImageSize(item, placeholder);

								baseDiv.appendChild(placeholder);
								item.placeholder = placeholder;
							}

							if (!item.loading) {
								_preloadImage(item);
							}

							if (self.allowProgressiveImg()) {
								// just append image
								if (!_initialContentSet && _features.transform) {
									_imagesToAppendPool.push({
										item: item,
										baseDiv: baseDiv,
										img: item.img,
										index: index,
										holder: holder
									});
								} else {
									_appendImage(index, item, baseDiv, item.img, true, true);
								}
							}
						} else if (item.src && !item.loadError) {
							// image object is created every time, due to bugs of image loading & delay when switching images
							img = framework.createEl('pswp__img', 'img');
							img.style.opacity = 1;
							img.src = item.src;
							_setImageSize(item, img);
							_appendImage(index, item, baseDiv, img, true);
						}

						if (!_initialContentSet && index === _currentItemIndex) {
							_currZoomElementStyle = baseDiv.style;
							_showOrHide(item, img || item.img);
						} else {
							_applyZoomPanToItem(item);
						}

						holder.el.innerHTML = '';
						holder.el.appendChild(baseDiv);
					},

					cleanSlide: function cleanSlide(item) {
						if (item.img) {
							item.img.onload = item.img.onerror = null;
						}
						item.loaded = item.loading = item.img = item.imageAppended = false;
					}

				}
			});

			/*>>items-controller*/

			/*>>tap*/
			/**
	   * tap.js:
	   *
	   * Displatches tap and double-tap events.
	   * 
	   */

			var tapTimer,
			    tapReleasePoint = {},
			    _dispatchTapEvent = function _dispatchTapEvent(origEvent, releasePoint, pointerType) {
				var e = document.createEvent('CustomEvent'),
				    eDetail = {
					origEvent: origEvent,
					target: origEvent.target,
					releasePoint: releasePoint,
					pointerType: pointerType || 'touch'
				};

				e.initCustomEvent('pswpTap', true, true, eDetail);
				origEvent.target.dispatchEvent(e);
			};

			_registerModule('Tap', {
				publicMethods: {
					initTap: function initTap() {
						_listen('firstTouchStart', self.onTapStart);
						_listen('touchRelease', self.onTapRelease);
						_listen('destroy', function () {
							tapReleasePoint = {};
							tapTimer = null;
						});
					},
					onTapStart: function onTapStart(touchList) {
						if (touchList.length > 1) {
							clearTimeout(tapTimer);
							tapTimer = null;
						}
					},
					onTapRelease: function onTapRelease(e, releasePoint) {
						if (!releasePoint) {
							return;
						}

						if (!_moved && !_isMultitouch && !_numAnimations) {
							var p0 = releasePoint;
							if (tapTimer) {
								clearTimeout(tapTimer);
								tapTimer = null;

								// Check if taped on the same place
								if (_isNearbyPoints(p0, tapReleasePoint)) {
									_shout('doubleTap', p0);
									return;
								}
							}

							if (releasePoint.type === 'mouse') {
								_dispatchTapEvent(e, releasePoint, 'mouse');
								return;
							}

							var clickedTagName = e.target.tagName.toUpperCase();
							// avoid double tap delay on buttons and elements that have class pswp__single-tap
							if (clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap')) {
								_dispatchTapEvent(e, releasePoint);
								return;
							}

							_equalizePoints(tapReleasePoint, p0);

							tapTimer = setTimeout(function () {
								_dispatchTapEvent(e, releasePoint);
								tapTimer = null;
							}, 300);
						}
					}
				}
			});

			/*>>tap*/

			/*>>desktop-zoom*/
			/**
	   *
	   * desktop-zoom.js:
	   *
	   * - Binds mousewheel event for paning zoomed image.
	   * - Manages "dragging", "zoomed-in", "zoom-out" classes.
	   *   (which are used for cursors and zoom icon)
	   * - Adds toggleDesktopZoom function.
	   * 
	   */

			var _wheelDelta;

			_registerModule('DesktopZoom', {

				publicMethods: {

					initDesktopZoom: function initDesktopZoom() {

						if (_oldIE) {
							// no zoom for old IE (<=8)
							return;
						}

						if (_likelyTouchDevice) {
							// if detected hardware touch support, we wait until mouse is used,
							// and only then apply desktop-zoom features
							_listen('mouseUsed', function () {
								self.setupDesktopZoom();
							});
						} else {
							self.setupDesktopZoom(true);
						}
					},

					setupDesktopZoom: function setupDesktopZoom(onInit) {

						_wheelDelta = {};

						var events = 'wheel mousewheel DOMMouseScroll';

						_listen('bindEvents', function () {
							framework.bind(template, events, self.handleMouseWheel);
						});

						_listen('unbindEvents', function () {
							if (_wheelDelta) {
								framework.unbind(template, events, self.handleMouseWheel);
							}
						});

						self.mouseZoomedIn = false;

						var hasDraggingClass,
						    updateZoomable = function updateZoomable() {
							if (self.mouseZoomedIn) {
								framework.removeClass(template, 'pswp--zoomed-in');
								self.mouseZoomedIn = false;
							}
							if (_currZoomLevel < 1) {
								framework.addClass(template, 'pswp--zoom-allowed');
							} else {
								framework.removeClass(template, 'pswp--zoom-allowed');
							}
							removeDraggingClass();
						},
						    removeDraggingClass = function removeDraggingClass() {
							if (hasDraggingClass) {
								framework.removeClass(template, 'pswp--dragging');
								hasDraggingClass = false;
							}
						};

						_listen('resize', updateZoomable);
						_listen('afterChange', updateZoomable);
						_listen('pointerDown', function () {
							if (self.mouseZoomedIn) {
								hasDraggingClass = true;
								framework.addClass(template, 'pswp--dragging');
							}
						});
						_listen('pointerUp', removeDraggingClass);

						if (!onInit) {
							updateZoomable();
						}
					},

					handleMouseWheel: function handleMouseWheel(e) {

						if (_currZoomLevel <= self.currItem.fitRatio) {
							if (_options.modal) {

								if (!_options.closeOnScroll || _numAnimations || _isDragging) {
									e.preventDefault();
								} else if (_transformKey && Math.abs(e.deltaY) > 2) {
									// close PhotoSwipe
									// if browser supports transforms & scroll changed enough
									_closedByScroll = true;
									self.close();
								}
							}
							return true;
						}

						// allow just one event to fire
						e.stopPropagation();

						// https://developer.mozilla.org/en-US/docs/Web/Events/wheel
						_wheelDelta.x = 0;

						if ('deltaX' in e) {
							if (e.deltaMode === 1 /* DOM_DELTA_LINE */) {
									// 18 - average line height
									_wheelDelta.x = e.deltaX * 18;
									_wheelDelta.y = e.deltaY * 18;
								} else {
								_wheelDelta.x = e.deltaX;
								_wheelDelta.y = e.deltaY;
							}
						} else if ('wheelDelta' in e) {
							if (e.wheelDeltaX) {
								_wheelDelta.x = -0.16 * e.wheelDeltaX;
							}
							if (e.wheelDeltaY) {
								_wheelDelta.y = -0.16 * e.wheelDeltaY;
							} else {
								_wheelDelta.y = -0.16 * e.wheelDelta;
							}
						} else if ('detail' in e) {
							_wheelDelta.y = e.detail;
						} else {
							return;
						}

						_calculatePanBounds(_currZoomLevel, true);

						var newPanX = _panOffset.x - _wheelDelta.x,
						    newPanY = _panOffset.y - _wheelDelta.y;

						// only prevent scrolling in nonmodal mode when not at edges
						if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) {
							e.preventDefault();
						}

						// TODO: use rAF instead of mousewheel?
						self.panTo(newPanX, newPanY);
					},

					toggleDesktopZoom: function toggleDesktopZoom(centerPoint) {
						centerPoint = centerPoint || { x: _viewportSize.x / 2 + _offset.x, y: _viewportSize.y / 2 + _offset.y };

						var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
						var zoomOut = _currZoomLevel === doubleTapZoomLevel;

						self.mouseZoomedIn = !zoomOut;

						self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
						framework[(!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
					}

				}
			});

			/*>>desktop-zoom*/

			/*>>history*/
			/**
	   *
	   * history.js:
	   *
	   * - Back button to close gallery.
	   * 
	   * - Unique URL for each slide: example.com/&pid=1&gid=3
	   *   (where PID is picture index, and GID and gallery index)
	   *   
	   * - Switch URL when slides change.
	   * 
	   */

			var _historyDefaultOptions = {
				history: true,
				galleryUID: 1
			};

			var _historyUpdateTimeout,
			    _hashChangeTimeout,
			    _hashAnimCheckTimeout,
			    _hashChangedByScript,
			    _hashChangedByHistory,
			    _hashReseted,
			    _initialHash,
			    _historyChanged,
			    _closedFromURL,
			    _urlChangedOnce,
			    _windowLoc,
			    _supportsPushState,
			    _getHash = function _getHash() {
				return _windowLoc.hash.substring(1);
			},
			    _cleanHistoryTimeouts = function _cleanHistoryTimeouts() {

				if (_historyUpdateTimeout) {
					clearTimeout(_historyUpdateTimeout);
				}

				if (_hashAnimCheckTimeout) {
					clearTimeout(_hashAnimCheckTimeout);
				}
			},


			// pid - Picture index
			// gid - Gallery index
			_parseItemIndexFromURL = function _parseItemIndexFromURL() {
				var hash = _getHash(),
				    params = {};

				if (hash.length < 5) {
					// pid=1
					return params;
				}

				var i,
				    vars = hash.split('&');
				for (i = 0; i < vars.length; i++) {
					if (!vars[i]) {
						continue;
					}
					var pair = vars[i].split('=');
					if (pair.length < 2) {
						continue;
					}
					params[pair[0]] = pair[1];
				}
				if (_options.galleryPIDs) {
					// detect custom pid in hash and search for it among the items collection
					var searchfor = params.pid;
					params.pid = 0; // if custom pid cannot be found, fallback to the first item
					for (i = 0; i < _items.length; i++) {
						if (_items[i].pid === searchfor) {
							params.pid = i;
							break;
						}
					}
				} else {
					params.pid = parseInt(params.pid, 10) - 1;
				}
				if (params.pid < 0) {
					params.pid = 0;
				}
				return params;
			},
			    _updateHash = function _updateHash() {

				if (_hashAnimCheckTimeout) {
					clearTimeout(_hashAnimCheckTimeout);
				}

				if (_numAnimations || _isDragging) {
					// changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
					// that's why we update hash only when no animations running
					_hashAnimCheckTimeout = setTimeout(_updateHash, 500);
					return;
				}

				if (_hashChangedByScript) {
					clearTimeout(_hashChangeTimeout);
				} else {
					_hashChangedByScript = true;
				}

				var pid = _currentItemIndex + 1;
				var item = _getItemAt(_currentItemIndex);
				if (item.hasOwnProperty('pid')) {
					// carry forward any custom pid assigned to the item
					pid = item.pid;
				}
				var newHash = _initialHash + '&' + 'gid=' + _options.galleryUID + '&' + 'pid=' + pid;

				if (!_historyChanged) {
					if (_windowLoc.hash.indexOf(newHash) === -1) {
						_urlChangedOnce = true;
					}
					// first time - add new hisory record, then just replace
				}

				var newURL = _windowLoc.href.split('#')[0] + '#' + newHash;

				if (_supportsPushState) {

					if ('#' + newHash !== window.location.hash) {
						history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
					}
				} else {
					if (_historyChanged) {
						_windowLoc.replace(newURL);
					} else {
						_windowLoc.hash = newHash;
					}
				}

				_historyChanged = true;
				_hashChangeTimeout = setTimeout(function () {
					_hashChangedByScript = false;
				}, 60);
			};

			_registerModule('History', {

				publicMethods: {
					initHistory: function initHistory() {

						framework.extend(_options, _historyDefaultOptions, true);

						if (!_options.history) {
							return;
						}

						_windowLoc = window.location;
						_urlChangedOnce = false;
						_closedFromURL = false;
						_historyChanged = false;
						_initialHash = _getHash();
						_supportsPushState = 'pushState' in history;

						if (_initialHash.indexOf('gid=') > -1) {
							_initialHash = _initialHash.split('&gid=')[0];
							_initialHash = _initialHash.split('?gid=')[0];
						}

						_listen('afterChange', self.updateURL);
						_listen('unbindEvents', function () {
							framework.unbind(window, 'hashchange', self.onHashChange);
						});

						var returnToOriginal = function returnToOriginal() {
							_hashReseted = true;
							if (!_closedFromURL) {

								if (_urlChangedOnce) {
									history.back();
								} else {

									if (_initialHash) {
										_windowLoc.hash = _initialHash;
									} else {
										if (_supportsPushState) {

											// remove hash from url without refreshing it or scrolling to top
											history.pushState('', document.title, _windowLoc.pathname + _windowLoc.search);
										} else {
											_windowLoc.hash = '';
										}
									}
								}
							}

							_cleanHistoryTimeouts();
						};

						_listen('unbindEvents', function () {
							if (_closedByScroll) {
								// if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
								// this is done to keep the scroll position
								returnToOriginal();
							}
						});
						_listen('destroy', function () {
							if (!_hashReseted) {
								returnToOriginal();
							}
						});
						_listen('firstUpdate', function () {
							_currentItemIndex = _parseItemIndexFromURL().pid;
						});

						var index = _initialHash.indexOf('pid=');
						if (index > -1) {
							_initialHash = _initialHash.substring(0, index);
							if (_initialHash.slice(-1) === '&') {
								_initialHash = _initialHash.slice(0, -1);
							}
						}

						setTimeout(function () {
							if (_isOpen) {
								// hasn't destroyed yet
								framework.bind(window, 'hashchange', self.onHashChange);
							}
						}, 40);
					},
					onHashChange: function onHashChange() {

						if (_getHash() === _initialHash) {

							_closedFromURL = true;
							self.close();
							return;
						}
						if (!_hashChangedByScript) {

							_hashChangedByHistory = true;
							self.goTo(_parseItemIndexFromURL().pid);
							_hashChangedByHistory = false;
						}
					},
					updateURL: function updateURL() {

						// Delay the update of URL, to avoid lag during transition, 
						// and to not to trigger actions like "refresh page sound" or "blinking favicon" to often

						_cleanHistoryTimeouts();

						if (_hashChangedByHistory) {
							return;
						}

						if (!_historyChanged) {
							_updateHash(); // first time
						} else {
							_historyUpdateTimeout = setTimeout(_updateHash, 800);
						}
					}

				}
			});

			/*>>history*/
			framework.extend(self, publicMethods);
		};
		return PhotoSwipe;
	});

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05
	* http://photoswipe.com
	* Copyright (c) 2017 Dmitry Semenov; */
	/**
	*
	* UI on top of main sliding area (caption, arrows, close button, etc.).
	* Built just using public methods/properties of PhotoSwipe.
	* 
	*/
	(function (root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
			module.exports = factory();
		} else {
			root.PhotoSwipeUI_Default = factory();
		}
	})(undefined, function () {

		'use strict';

		var PhotoSwipeUI_Default = function PhotoSwipeUI_Default(pswp, framework) {

			var ui = this;
			var _overlayUIUpdated = false,
			    _controlsVisible = true,
			    _fullscrenAPI,
			    _controls,
			    _captionContainer,
			    _fakeCaptionContainer,
			    _indexIndicator,
			    _shareButton,
			    _shareModal,
			    _shareModalHidden = true,
			    _initalCloseOnScrollValue,
			    _isIdle,
			    _listen,
			    _loadingIndicator,
			    _loadingIndicatorHidden,
			    _loadingIndicatorTimeout,
			    _galleryHasOneSlide,
			    _options,
			    _defaultUIOptions = {
				barsSize: { top: 44, bottom: 'auto' },
				closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'],
				timeToIdle: 4000,
				timeToIdleOutside: 1000,
				loadingIndicatorDelay: 1000, // 2s

				addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl /*, isFake */) {
					if (!item.title) {
						captionEl.children[0].innerHTML = '';
						return false;
					}
					captionEl.children[0].innerHTML = item.title;
					return true;
				},

				closeEl: true,
				captionEl: true,
				fullscreenEl: true,
				zoomEl: true,
				shareEl: true,
				counterEl: true,
				arrowEl: true,
				preloaderEl: true,

				tapToClose: false,
				tapToToggleControls: true,

				clickToCloseNonZoomable: true,

				shareButtons: [{ id: 'facebook', label: 'Share on Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}' }, { id: 'twitter', label: 'Tweet', url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' }, { id: 'pinterest', label: 'Pin it', url: 'http://www.pinterest.com/pin/create/button/' + '?url={{url}}&media={{image_url}}&description={{text}}' }, { id: 'download', label: 'Download image', url: '{{raw_image_url}}', download: true }],
				getImageURLForShare: function getImageURLForShare() /* shareButtonData */{
					return pswp.currItem.src || '';
				},
				getPageURLForShare: function getPageURLForShare() /* shareButtonData */{
					return window.location.href;
				},
				getTextForShare: function getTextForShare() /* shareButtonData */{
					return pswp.currItem.title || '';
				},

				indexIndicatorSep: ' / ',
				fitControlsWidth: 1200

			},
			    _blockControlsTap,
			    _blockControlsTapTimeout;

			var _onControlsTap = function _onControlsTap(e) {
				if (_blockControlsTap) {
					return true;
				}

				e = e || window.event;

				if (_options.timeToIdle && _options.mouseUsed && !_isIdle) {
					// reset idle timer
					_onIdleMouseMove();
				}

				var target = e.target || e.srcElement,
				    uiElement,
				    clickedClass = target.getAttribute('class') || '',
				    found;

				for (var i = 0; i < _uiElements.length; i++) {
					uiElement = _uiElements[i];
					if (uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name) > -1) {
						uiElement.onTap();
						found = true;
					}
				}

				if (found) {
					if (e.stopPropagation) {
						e.stopPropagation();
					}
					_blockControlsTap = true;

					// Some versions of Android don't prevent ghost click event 
					// when preventDefault() was called on touchstart and/or touchend.
					// 
					// This happens on v4.3, 4.2, 4.1, 
					// older versions strangely work correctly, 
					// but just in case we add delay on all of them)	
					var tapDelay = framework.features.isOldAndroid ? 600 : 30;
					_blockControlsTapTimeout = setTimeout(function () {
						_blockControlsTap = false;
					}, tapDelay);
				}
			},
			    _fitControlsInViewport = function _fitControlsInViewport() {
				return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
			},
			    _togglePswpClass = function _togglePswpClass(el, cName, add) {
				framework[(add ? 'add' : 'remove') + 'Class'](el, 'pswp__' + cName);
			},


			// add class when there is just one item in the gallery
			// (by default it hides left/right arrows and 1ofX counter)
			_countNumItems = function _countNumItems() {
				var hasOneSlide = _options.getNumItemsFn() === 1;

				if (hasOneSlide !== _galleryHasOneSlide) {
					_togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
					_galleryHasOneSlide = hasOneSlide;
				}
			},
			    _toggleShareModalClass = function _toggleShareModalClass() {
				_togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
			},
			    _toggleShareModal = function _toggleShareModal() {

				_shareModalHidden = !_shareModalHidden;

				if (!_shareModalHidden) {
					_toggleShareModalClass();
					setTimeout(function () {
						if (!_shareModalHidden) {
							framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
						}
					}, 30);
				} else {
					framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
					setTimeout(function () {
						if (_shareModalHidden) {
							_toggleShareModalClass();
						}
					}, 300);
				}

				if (!_shareModalHidden) {
					_updateShareURLs();
				}
				return false;
			},
			    _openWindowPopup = function _openWindowPopup(e) {
				e = e || window.event;
				var target = e.target || e.srcElement;

				pswp.shout('shareLinkClick', e, target);

				if (!target.href) {
					return false;
				}

				if (target.hasAttribute('download')) {
					return true;
				}

				window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,' + 'location=yes,width=550,height=420,top=100,left=' + (window.screen ? Math.round(screen.width / 2 - 275) : 100));

				if (!_shareModalHidden) {
					_toggleShareModal();
				}

				return false;
			},
			    _updateShareURLs = function _updateShareURLs() {
				var shareButtonOut = '',
				    shareButtonData,
				    shareURL,
				    image_url,
				    page_url,
				    share_text;

				for (var i = 0; i < _options.shareButtons.length; i++) {
					shareButtonData = _options.shareButtons[i];

					image_url = _options.getImageURLForShare(shareButtonData);
					page_url = _options.getPageURLForShare(shareButtonData);
					share_text = _options.getTextForShare(shareButtonData);

					shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url)).replace('{{image_url}}', encodeURIComponent(image_url)).replace('{{raw_image_url}}', image_url).replace('{{text}}', encodeURIComponent(share_text));

					shareButtonOut += '<a href="' + shareURL + '" target="_blank" ' + 'class="pswp__share--' + shareButtonData.id + '"' + (shareButtonData.download ? 'download' : '') + '>' + shareButtonData.label + '</a>';

					if (_options.parseShareButtonOut) {
						shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
					}
				}
				_shareModal.children[0].innerHTML = shareButtonOut;
				_shareModal.children[0].onclick = _openWindowPopup;
			},
			    _hasCloseClass = function _hasCloseClass(target) {
				for (var i = 0; i < _options.closeElClasses.length; i++) {
					if (framework.hasClass(target, 'pswp__' + _options.closeElClasses[i])) {
						return true;
					}
				}
			},
			    _idleInterval,
			    _idleTimer,
			    _idleIncrement = 0,
			    _onIdleMouseMove = function _onIdleMouseMove() {
				clearTimeout(_idleTimer);
				_idleIncrement = 0;
				if (_isIdle) {
					ui.setIdle(false);
				}
			},
			    _onMouseLeaveWindow = function _onMouseLeaveWindow(e) {
				e = e ? e : window.event;
				var from = e.relatedTarget || e.toElement;
				if (!from || from.nodeName === 'HTML') {
					clearTimeout(_idleTimer);
					_idleTimer = setTimeout(function () {
						ui.setIdle(true);
					}, _options.timeToIdleOutside);
				}
			},
			    _setupFullscreenAPI = function _setupFullscreenAPI() {
				if (_options.fullscreenEl && !framework.features.isOldAndroid) {
					if (!_fullscrenAPI) {
						_fullscrenAPI = ui.getFullscreenAPI();
					}
					if (_fullscrenAPI) {
						framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
						ui.updateFullscreen();
						framework.addClass(pswp.template, 'pswp--supports-fs');
					} else {
						framework.removeClass(pswp.template, 'pswp--supports-fs');
					}
				}
			},
			    _setupLoadingIndicator = function _setupLoadingIndicator() {
				// Setup loading indicator
				if (_options.preloaderEl) {

					_toggleLoadingIndicator(true);

					_listen('beforeChange', function () {

						clearTimeout(_loadingIndicatorTimeout);

						// display loading indicator with delay
						_loadingIndicatorTimeout = setTimeout(function () {

							if (pswp.currItem && pswp.currItem.loading) {

								if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) {
									// show preloader if progressive loading is not enabled, 
									// or image width is not defined yet (because of slow connection)
									_toggleLoadingIndicator(false);
									// items-controller.js function allowProgressiveImg
								}
							} else {
								_toggleLoadingIndicator(true); // hide preloader
							}
						}, _options.loadingIndicatorDelay);
					});
					_listen('imageLoadComplete', function (index, item) {
						if (pswp.currItem === item) {
							_toggleLoadingIndicator(true);
						}
					});
				}
			},
			    _toggleLoadingIndicator = function _toggleLoadingIndicator(hide) {
				if (_loadingIndicatorHidden !== hide) {
					_togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
					_loadingIndicatorHidden = hide;
				}
			},
			    _applyNavBarGaps = function _applyNavBarGaps(item) {
				var gap = item.vGap;

				if (_fitControlsInViewport()) {

					var bars = _options.barsSize;
					if (_options.captionEl && bars.bottom === 'auto') {
						if (!_fakeCaptionContainer) {
							_fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
							_fakeCaptionContainer.appendChild(framework.createEl('pswp__caption__center'));
							_controls.insertBefore(_fakeCaptionContainer, _captionContainer);
							framework.addClass(_controls, 'pswp__ui--fit');
						}
						if (_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)) {

							var captionSize = _fakeCaptionContainer.clientHeight;
							gap.bottom = parseInt(captionSize, 10) || 44;
						} else {
							gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
						}
					} else {
						gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
					}

					// height of top bar is static, no need to calculate it
					gap.top = bars.top;
				} else {
					gap.top = gap.bottom = 0;
				}
			},
			    _setupIdle = function _setupIdle() {
				// Hide controls when mouse is used
				if (_options.timeToIdle) {
					_listen('mouseUsed', function () {

						framework.bind(document, 'mousemove', _onIdleMouseMove);
						framework.bind(document, 'mouseout', _onMouseLeaveWindow);

						_idleInterval = setInterval(function () {
							_idleIncrement++;
							if (_idleIncrement === 2) {
								ui.setIdle(true);
							}
						}, _options.timeToIdle / 2);
					});
				}
			},
			    _setupHidingControlsDuringGestures = function _setupHidingControlsDuringGestures() {

				// Hide controls on vertical drag
				_listen('onVerticalDrag', function (now) {
					if (_controlsVisible && now < 0.95) {
						ui.hideControls();
					} else if (!_controlsVisible && now >= 0.95) {
						ui.showControls();
					}
				});

				// Hide controls when pinching to close
				var pinchControlsHidden;
				_listen('onPinchClose', function (now) {
					if (_controlsVisible && now < 0.9) {
						ui.hideControls();
						pinchControlsHidden = true;
					} else if (pinchControlsHidden && !_controlsVisible && now > 0.9) {
						ui.showControls();
					}
				});

				_listen('zoomGestureEnded', function () {
					pinchControlsHidden = false;
					if (pinchControlsHidden && !_controlsVisible) {
						ui.showControls();
					}
				});
			};

			var _uiElements = [{
				name: 'caption',
				option: 'captionEl',
				onInit: function onInit(el) {
					_captionContainer = el;
				}
			}, {
				name: 'share-modal',
				option: 'shareEl',
				onInit: function onInit(el) {
					_shareModal = el;
				},
				onTap: function onTap() {
					_toggleShareModal();
				}
			}, {
				name: 'button--share',
				option: 'shareEl',
				onInit: function onInit(el) {
					_shareButton = el;
				},
				onTap: function onTap() {
					_toggleShareModal();
				}
			}, {
				name: 'button--zoom',
				option: 'zoomEl',
				onTap: pswp.toggleDesktopZoom
			}, {
				name: 'counter',
				option: 'counterEl',
				onInit: function onInit(el) {
					_indexIndicator = el;
				}
			}, {
				name: 'button--close',
				option: 'closeEl',
				onTap: pswp.close
			}, {
				name: 'button--arrow--left',
				option: 'arrowEl',
				onTap: pswp.prev
			}, {
				name: 'button--arrow--right',
				option: 'arrowEl',
				onTap: pswp.next
			}, {
				name: 'button--fs',
				option: 'fullscreenEl',
				onTap: function onTap() {
					if (_fullscrenAPI.isFullscreen()) {
						_fullscrenAPI.exit();
					} else {
						_fullscrenAPI.enter();
					}
				}
			}, {
				name: 'preloader',
				option: 'preloaderEl',
				onInit: function onInit(el) {
					_loadingIndicator = el;
				}
			}];

			var _setupUIElements = function _setupUIElements() {
				var item, classAttr, uiElement;

				var loopThroughChildElements = function loopThroughChildElements(sChildren) {
					if (!sChildren) {
						return;
					}

					var l = sChildren.length;
					for (var i = 0; i < l; i++) {
						item = sChildren[i];
						classAttr = item.className;

						for (var a = 0; a < _uiElements.length; a++) {
							uiElement = _uiElements[a];

							if (classAttr.indexOf('pswp__' + uiElement.name) > -1) {

								if (_options[uiElement.option]) {
									// if element is not disabled from options

									framework.removeClass(item, 'pswp__element--disabled');
									if (uiElement.onInit) {
										uiElement.onInit(item);
									}

									//item.style.display = 'block';
								} else {
									framework.addClass(item, 'pswp__element--disabled');
									//item.style.display = 'none';
								}
							}
						}
					}
				};
				loopThroughChildElements(_controls.children);

				var topBar = framework.getChildByClass(_controls, 'pswp__top-bar');
				if (topBar) {
					loopThroughChildElements(topBar.children);
				}
			};

			ui.init = function () {

				// extend options
				framework.extend(pswp.options, _defaultUIOptions, true);

				// create local link for fast access
				_options = pswp.options;

				// find pswp__ui element
				_controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');

				// create local link
				_listen = pswp.listen;

				_setupHidingControlsDuringGestures();

				// update controls when slides change
				_listen('beforeChange', ui.update);

				// toggle zoom on double-tap
				_listen('doubleTap', function (point) {
					var initialZoomLevel = pswp.currItem.initialZoomLevel;
					if (pswp.getZoomLevel() !== initialZoomLevel) {
						pswp.zoomTo(initialZoomLevel, point, 333);
					} else {
						pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
					}
				});

				// Allow text selection in caption
				_listen('preventDragEvent', function (e, isDown, preventObj) {
					var t = e.target || e.srcElement;
					if (t && t.getAttribute('class') && e.type.indexOf('mouse') > -1 && (t.getAttribute('class').indexOf('__caption') > 0 || /(SMALL|STRONG|EM)/i.test(t.tagName))) {
						preventObj.prevent = false;
					}
				});

				// bind events for UI
				_listen('bindEvents', function () {
					framework.bind(_controls, 'pswpTap click', _onControlsTap);
					framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);

					if (!pswp.likelyTouchDevice) {
						framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
					}
				});

				// unbind events for UI
				_listen('unbindEvents', function () {
					if (!_shareModalHidden) {
						_toggleShareModal();
					}

					if (_idleInterval) {
						clearInterval(_idleInterval);
					}
					framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
					framework.unbind(document, 'mousemove', _onIdleMouseMove);
					framework.unbind(_controls, 'pswpTap click', _onControlsTap);
					framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
					framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);

					if (_fullscrenAPI) {
						framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
						if (_fullscrenAPI.isFullscreen()) {
							_options.hideAnimationDuration = 0;
							_fullscrenAPI.exit();
						}
						_fullscrenAPI = null;
					}
				});

				// clean up things when gallery is destroyed
				_listen('destroy', function () {
					if (_options.captionEl) {
						if (_fakeCaptionContainer) {
							_controls.removeChild(_fakeCaptionContainer);
						}
						framework.removeClass(_captionContainer, 'pswp__caption--empty');
					}

					if (_shareModal) {
						_shareModal.children[0].onclick = null;
					}
					framework.removeClass(_controls, 'pswp__ui--over-close');
					framework.addClass(_controls, 'pswp__ui--hidden');
					ui.setIdle(false);
				});

				if (!_options.showAnimationDuration) {
					framework.removeClass(_controls, 'pswp__ui--hidden');
				}
				_listen('initialZoomIn', function () {
					if (_options.showAnimationDuration) {
						framework.removeClass(_controls, 'pswp__ui--hidden');
					}
				});
				_listen('initialZoomOut', function () {
					framework.addClass(_controls, 'pswp__ui--hidden');
				});

				_listen('parseVerticalMargin', _applyNavBarGaps);

				_setupUIElements();

				if (_options.shareEl && _shareButton && _shareModal) {
					_shareModalHidden = true;
				}

				_countNumItems();

				_setupIdle();

				_setupFullscreenAPI();

				_setupLoadingIndicator();
			};

			ui.setIdle = function (isIdle) {
				_isIdle = isIdle;
				_togglePswpClass(_controls, 'ui--idle', isIdle);
			};

			ui.update = function () {
				// Don't update UI if it's hidden
				if (_controlsVisible && pswp.currItem) {

					ui.updateIndexIndicator();

					if (_options.captionEl) {
						_options.addCaptionHTMLFn(pswp.currItem, _captionContainer);

						_togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
					}

					_overlayUIUpdated = true;
				} else {
					_overlayUIUpdated = false;
				}

				if (!_shareModalHidden) {
					_toggleShareModal();
				}

				_countNumItems();
			};

			ui.updateFullscreen = function (e) {

				if (e) {
					// some browsers change window scroll position during the fullscreen
					// so PhotoSwipe updates it just in case
					setTimeout(function () {
						pswp.setScrollOffset(0, framework.getScrollY());
					}, 50);
				}

				// toogle pswp--fs class on root element
				framework[(_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class'](pswp.template, 'pswp--fs');
			};

			ui.updateIndexIndicator = function () {
				if (_options.counterEl) {
					_indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
				}
			};

			ui.onGlobalTap = function (e) {
				e = e || window.event;
				var target = e.target || e.srcElement;

				if (_blockControlsTap) {
					return;
				}

				if (e.detail && e.detail.pointerType === 'mouse') {

					// close gallery if clicked outside of the image
					if (_hasCloseClass(target)) {
						pswp.close();
						return;
					}

					if (framework.hasClass(target, 'pswp__img')) {
						if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
							if (_options.clickToCloseNonZoomable) {
								pswp.close();
							}
						} else {
							pswp.toggleDesktopZoom(e.detail.releasePoint);
						}
					}
				} else {

					// tap anywhere (except buttons) to toggle visibility of controls
					if (_options.tapToToggleControls) {
						if (_controlsVisible) {
							ui.hideControls();
						} else {
							ui.showControls();
						}
					}

					// tap to close gallery
					if (_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target))) {
						pswp.close();
						return;
					}
				}
			};
			ui.onMouseOver = function (e) {
				e = e || window.event;
				var target = e.target || e.srcElement;

				// add class when mouse is over an element that should close the gallery
				_togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
			};

			ui.hideControls = function () {
				framework.addClass(_controls, 'pswp__ui--hidden');
				_controlsVisible = false;
			};

			ui.showControls = function () {
				_controlsVisible = true;
				if (!_overlayUIUpdated) {
					ui.update();
				}
				framework.removeClass(_controls, 'pswp__ui--hidden');
			};

			ui.supportsFullscreen = function () {
				var d = document;
				return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
			};

			ui.getFullscreenAPI = function () {
				var dE = document.documentElement,
				    api,
				    tF = 'fullscreenchange';

				if (dE.requestFullscreen) {
					api = {
						enterK: 'requestFullscreen',
						exitK: 'exitFullscreen',
						elementK: 'fullscreenElement',
						eventK: tF
					};
				} else if (dE.mozRequestFullScreen) {
					api = {
						enterK: 'mozRequestFullScreen',
						exitK: 'mozCancelFullScreen',
						elementK: 'mozFullScreenElement',
						eventK: 'moz' + tF
					};
				} else if (dE.webkitRequestFullscreen) {
					api = {
						enterK: 'webkitRequestFullscreen',
						exitK: 'webkitExitFullscreen',
						elementK: 'webkitFullscreenElement',
						eventK: 'webkit' + tF
					};
				} else if (dE.msRequestFullscreen) {
					api = {
						enterK: 'msRequestFullscreen',
						exitK: 'msExitFullscreen',
						elementK: 'msFullscreenElement',
						eventK: 'MSFullscreenChange'
					};
				}

				if (api) {
					api.enter = function () {
						// disable close-on-scroll in fullscreen
						_initalCloseOnScrollValue = _options.closeOnScroll;
						_options.closeOnScroll = false;

						if (this.enterK === 'webkitRequestFullscreen') {
							pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
						} else {
							return pswp.template[this.enterK]();
						}
					};
					api.exit = function () {
						_options.closeOnScroll = _initalCloseOnScrollValue;

						return document[this.exitK]();
					};
					api.isFullscreen = function () {
						return document[this.elementK];
					};
				}

				return api;
			};
		};
		return PhotoSwipeUI_Default;
	});

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	//IN-AR TRY ON
	'use strict';

	var detectDevice = __webpack_require__(111);

	/**
	 * Delete the QR code, if it is not needed
	 */
	function deleteQR() {
	    if ($('#imageQRCode').children().length) {
	        $('#imageQRCode').children().remove();
	        $('#imageQRCode').attr('title', '');
	    }
	}

	/**
	 * Create the QR code and place it in the modal. It is only used in desktop devices
	 * @param {String} linkARView The link of the Try On AR site, which should be included in the QR
	 */
	function generateQR(linkARView) {
	    $('#imageQRCode').children().remove();

	    // (ESLint) The QRCodejs is included in productDetails.isml
	    //eslint-disable-next-line no-undef
	    new QRCode(document.getElementById('imageQRCode'), {
	        text: linkARView,
	        width: 128,
	        height: 128,
	        colorDark: '#000',
	        colorLight: '#fff',
	        // (ESLint) The QRCodejs is included in productDetails.isml
	        correctLevel: QRCode.CorrectLevel.H //eslint-disable-line no-undef
	    });

	    $('#imageQRCode img').addClass('cc-qr-code');
	}

	/**
	 * Update the link of the Try On AR site (and the QR Code), if the feature is enaled
	 * for the selected variation group.\
	 * Otherwise, delete the QR Code and hide the Try On button.\
	 * The function is called when the user changes the variotion group/variant.
	 *
	 * @param {Boolean} availableTryOnAR Flag that indicates if the try on feature
	 *      is enabled for the selected variation group.
	 * @param {String} linkARView Link of the Try On AR site, used for the QR code.
	 */
	function updateTryOnButton(availableTryOnAR, linkARView) {
	    //Used when user changes variants
	    if (availableTryOnAR) {
	        $('.js-try-on-container').removeClass('d-none');
	        // Update data attributes
	        $('.js-tryOn-button').attr('data-link-arview', linkARView);
	        // Create new QR code
	        if (!detectDevice.detectMobile()) {
	            generateQR(linkARView);
	        }
	    } else {
	        $('.js-tryOn-button').attr('data-link-arview', '');
	        deleteQR();
	        $('.js-try-on-container').addClass('d-none');
	    }
	}

	/**
	 * Open the Try On AR site.
	 * @param {String} linkARView Link of the Try On AR site, used for redirection.
	 */
	function openTryOnARWindow(linkARView) {
	    window.open(linkARView, "_self");
	}

	module.exports = {
	    updateTryOnButton: updateTryOnButton,
	    generateQR: generateQR,
	    openTryOnARWindow: openTryOnARWindow
	};

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * appends params to a url
	 * @param {string} url - Original url
	 * @param {Object} params - Parameters to append
	 * @returns {string} result url with appended parameters
	 */

	function appendToUrl(url, params) {
	    var newUrl = url;
	    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
	        return key + '=' + encodeURIComponent(params[key]);
	    }).join('&');

	    return newUrl;
	}

	module.exports = {
	    addAndRemoveToWishlist: function addAndRemoveToWishlist() {
	        $('.add-to-wish-list').on('click', function (e) {
	            e.preventDefault();

	            if ($('.b-pdp__availability').hasClass('d-none') && $('.cc-pdp-col-description__wrp .cc-single-size-tile').length > 0 && $('.cc-pdp-col-description__wrp .cc-single-size-tile.selected').length === 0) {
	                $('.b-pdp__availability').removeClass('d-none');

	                return;
	            }

	            var addUrl = $(this).data('add-href');
	            var removeUrl = $(this).data('remove-href');
	            var button = $(this);
	            var buttonContentAdd = $(this).find('.wishlist-content-add');
	            var buttonContentRemove = $(this).find('.wishlist-content-remove');
	            var pid = $(this).closest('.product-detail').attr('data-pid');
	            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
	            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
	            var loggedin = $('.js-userIcon').length > 0;
	            optionId = optionId || null;
	            optionVal = optionVal || null;
	            removeUrl = removeUrl + '?pid=' + pid;
	            if (!addUrl || !removeUrl || !pid) {
	                return;
	            }

	            var isRedirectToLogin = false;
	            if (loggedin == false) {

	                var urlParams = {
	                    rurl: 4,
	                    pid: pid,
	                    oid: optionId,
	                    oval: optionVal
	                };

	                addUrl = appendToUrl(addUrl, urlParams);
	                isRedirectToLogin = true;
	            }

	            if (button.hasClass("to-add")) {

	                //analytics add to wishlist event
	                $('body').trigger('analytics:addToWishlist', pid);

	                $.spinner().start();
	                $.ajax({
	                    url: addUrl,
	                    type: 'post',
	                    dataType: 'json',
	                    data: {
	                        pid: pid,
	                        optionId: optionId,
	                        optionVal: optionVal
	                    },
	                    success: function success(data) {
	                        //see Wishlist-AddProduct
	                        if (isRedirectToLogin) {
	                            isRedirectToLogin = false;
	                            if (data.redirectUrl) {
	                                window.location.href = data.redirectUrl;
	                            }
	                            return;
	                        }
	                        $.spinner().stop();
	                        if (!data.success && data.isFull) {
	                            $('#wishlist-modal-body').text(data.maxProductsMessage);
	                            $('#wishlist-modal').modal('show');
	                        } else if (data.success) {
	                            buttonContentAdd.addClass('d-none');
	                            buttonContentRemove.removeClass('d-none');
	                            button.removeClass('to-add').addClass('to-remove');
	                        }
	                        if (!data.isFull) {
	                            window.ProductsInWishlist = data.productsArr;
	                            var counter = parseInt(data.wishlistSize);
	                            if (counter > 0) {
	                                $('.js-wishlistNumber').removeClass('d-none');
	                            }
	                            $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                            $('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').html(counter);
	                        }
	                    },
	                    error: function error(err) {
	                        if (err.responseJSON.redirectUrl) {
	                            window.location.href = err.responseJSON.redirectUrl;
	                        }
	                    }
	                });
	            } else if (button.hasClass('to-remove') && loggedin == true) {

	                //analytics remove from wishlist event
	                $('body').trigger('analytics:removeFromWishlist', pid);

	                $.spinner().start();
	                $.ajax({
	                    url: removeUrl,
	                    type: 'get',
	                    dataType: 'json',
	                    data: {},
	                    success: function success(data) {
	                        //see Wishlist-RemoveProduct
	                        $.spinner().stop();
	                        buttonContentAdd.removeClass('d-none');
	                        buttonContentRemove.addClass('d-none');
	                        button.removeClass('to-remove').addClass('to-add');
	                        //------------------------------
	                        window.ProductsInWishlist = data.productsArr;
	                        var counter = parseInt(data.wishlistSize);
	                        if (counter > 0) {
	                            $('.js-wishlistNumber').removeClass('d-none');
	                        } else {
	                            $('.js-wishlistNumber').addClass('d-none');
	                        }
	                        $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                        $('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').html(counter);
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }

	};

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    init: function init() {
	        this.pdpRow = document.querySelector('.cc-main-wrapper');
	        this.carousel = this.pdpRow.querySelector('.js-pdp-overlay-main-carousel');
	        this.containers = this.carousel.querySelectorAll('.cc-pdp-carousel-item');
	        this.isZoomOn = false;
	        this.scale = 2;
	        this.isDragging = false; // Variable to track if we are dragging
	        this.lastTouchX = 0; // Previous touch position
	        this.lastTouchY = 0; // Previous touch position
	        this.bindEvents();
	    },

	    // Calculate the distance between two touched points (pinch)
	    getDistanceBetweenTouches: function getDistanceBetweenTouches(event) {
	        if (typeof event !== "undefined") {
	            var touch1 = event.touches[0];
	            var touch2 = event.touches[1];
	            var dx = touch2.pageX - touch1.pageX;
	            var dy = touch2.pageY - touch1.pageY;
	            return Math.sqrt(dx * dx + dy * dy);
	        }
	    },

	    // Apply zoom to the image
	    applyZoom: function applyZoom() {
	        var _this = this;

	        if (this.img) {
	            // Apply the smooth zoom transition
	            this.img.style.transition = 'transform 0.5s ease-out';
	            this.img.style.transform = 'scale(' + this.scale + ')';
	            // Remove the transition after the animation completes
	            setTimeout(function () {
	                if (_this.img) {
	                    _this.img.style.transition = 'none';
	                }
	            }, 500); // 500ms matches the duration of the transition
	        }
	    },

	    bindEvents: function bindEvents() {
	        var _this2 = this;

	        $('body').on('product:statusUpdate', function () {
	            $('body').off('product:statusUpdate');
	            _this2.init();
	        });

	        this.containers.forEach(function (container) {
	            container.addEventListener('pointerdown', function (event) {
	                event.stopImmediatePropagation();
	                _this2.setJsObj(event);
	                _this2.switchImage(event);
	                if (event.pointerType === 'mouse') {
	                    _this2.mouseActivateZoom(event);
	                }
	            });
	        });

	        this.pdpRow.addEventListener('mousemove', function (event) {
	            if (_this2.isZoomOn) {
	                _this2.setJsObj(event);
	                _this2.mouseZoom(event);
	            }
	        });

	        this.carousel.addEventListener('touchstart', function (event) {
	            event.stopImmediatePropagation();
	            _this2.setJsObj(event);
	            _this2.isDragged = false;
	            _this2.zoomXnew = '';
	            _this2.zoomYnew = '';

	            // Manage pinch
	            if (event.touches.length === 2) {
	                _this2.startDistance = _this2.getDistanceBetweenTouches(event);
	                _this2.isPinching = true;
	            }

	            // Manage drag
	            if (event.touches.length === 1) {
	                _this2.isDragging = true;
	                _this2.lastTouchX = event.touches[0].pageX;
	                _this2.lastTouchY = event.touches[0].pageY;
	            }
	        });

	        this.carousel.addEventListener('touchmove', function (event) {
	            _this2.isDragged = true;

	            // Manage zoom
	            if (_this2.isZoomOn) {
	                event.preventDefault();
	                event.stopImmediatePropagation();
	                _this2.setJsObj(event);
	                _this2.touchZoom(event);
	            }

	            // Manage drag
	            if (_this2.isDragging && event.touches.length === 1 && _this2.isZoomOn) {
	                event.preventDefault();
	                var touch = event.touches[0];
	                var deltaX = touch.pageX - _this2.lastTouchX;
	                var deltaY = touch.pageY - _this2.lastTouchY;

	                // Let's move the image
	                _this2.moveImage(deltaX, deltaY);

	                // Update the previous position
	                _this2.lastTouchX = touch.pageX;
	                _this2.lastTouchY = touch.pageY;
	            }

	            // Manage pinch
	            if (_this2.isPinching && event.touches.length === 2) {
	                var newDistance = _this2.getDistanceBetweenTouches(event);
	                var scaleChange = newDistance / _this2.startDistance;
	                _this2.scale = Math.max(1, Math.min(5, _this2.scale * scaleChange)); // Limitiamo la scala da 1 a 5
	                _this2.startDistance = newDistance;
	                _this2.applyZoom();
	            }
	        });

	        this.carousel.addEventListener('touchend', function (event) {
	            event.stopImmediatePropagation();
	            _this2.setJsObj(event);

	            // Reset pinch
	            if (_this2.isPinching && event.touches.length < 2) {
	                _this2.isPinching = false;
	            }

	            // End drag management
	            if (_this2.isDragging) {
	                _this2.isDragging = false;
	            }

	            if (!_this2.isDragged) {
	                _this2.isZoomOn = !_this2.isZoomOn;
	                if (_this2.isZoomOn) {
	                    _this2.carousel.classList.add('zoom-active');
	                    event.preventDefault();
	                    event.stopImmediatePropagation();
	                    _this2.setJsObj(event);
	                    _this2.touchZoom(event);
	                } else {
	                    _this2.resetZoom();
	                    _this2.isDragging = false;
	                    _this2.isZoomOn = false;
	                }
	            }
	        });

	        window.addEventListener('resize', function () {
	            _this2.resetZoom();
	        });
	    },


	    moveImage: function moveImage(deltaX, deltaY) {
	        if (this.img) {
	            var currentZoomX = parseFloat(this.img.dataset.zoomx) || 0;
	            var currentZoomY = parseFloat(this.img.dataset.zoomy) || 0;

	            // Let's calculate the new position of the image
	            var newZoomX = currentZoomX + deltaX / this.img.clientWidth * 100; // Percentage of width
	            var newZoomY = currentZoomY + deltaY / this.img.clientHeight * 100; // Percentage of height

	            // We limit the translation values
	            newZoomX = this.returnValueWithLimit(newZoomX, 50);
	            newZoomY = this.returnValueWithLimit(newZoomY, 50);

	            // Let's apply the translation and zoom
	            this.img.style.transform = 'translate(' + newZoomX + '%, ' + newZoomY + '%) scale(' + this.scale + ')';
	            this.img.dataset.zoomx = newZoomX;
	            this.img.dataset.zoomy = newZoomY;
	        }
	    },

	    switchImage: function switchImage() {
	        if (typeof this.img !== 'undefined') {
	            var imgUrl = this.img.currentSrc.split('?')[0];
	            this.img.dataset.src = imgUrl;
	            this.container.querySelectorAll('source').forEach(function (source) {
	                var sourceArray = source.srcset.split(',');
	                if (sourceArray.length > 1) {
	                    source.srcset = sourceArray[1];
	                }
	            });
	        }
	    },

	    setJsObj: function setJsObj(event) {
	        if (typeof event !== 'undefined') {
	            this.selfTarget = event.target;
	            if (this.selfTarget.closest('.cc-container-dis-picture') !== null) {
	                this.container = this.selfTarget.closest('.cc-container-dis-picture');
	                this.img = this.container.querySelector('img');
	            }
	        }
	    },

	    touchZoom: function touchZoom(event) {
	        var _this3 = this;

	        if (typeof event !== 'undefined') {
	            if (this.selfTarget.closest('.cc-container-dis-picture') !== null && !this.selfTarget.closest('.cc-container-dis-picture').classList.contains('thumb')) {
	                var zoomValues = this.zoomValues(event);
	                var constantPerc = this.constantPerc();

	                var zoomXold = typeof this.img.dataset.zoomx !== 'undefined' ? parseFloat(this.img.dataset.zoomx) : 0;
	                var zoomYold = typeof this.img.dataset.zoomy !== 'undefined' ? parseFloat(this.img.dataset.zoomy) : 0;

	                var zoomX = zoomValues.x * constantPerc * -1;
	                var zoomY = zoomValues.y * constantPerc * -1;

	                if (this.zoomXnew === '' && this.zoomXnew === '') {
	                    this.zoomXnew = zoomX;
	                    this.zoomYnew = zoomY;
	                }

	                if (typeof this.img.dataset.zoomx !== 'undefined') {
	                    zoomX = (zoomXold + (this.zoomXnew - zoomX)) * -1;
	                    zoomY = (zoomYold + (this.zoomYnew - zoomY)) * -1;
	                }

	                zoomX = this.returnValueWithLimit(zoomX, constantPerc);
	                zoomY = this.returnValueWithLimit(zoomY, constantPerc);
	                this.zoomXold = zoomX * -1;
	                this.zoomYold = zoomY * -1;

	                this.img.style.transform = 'translate(' + zoomX + '%, ' + zoomY + '%) scale(' + this.scale + ')';
	                setTimeout(function () {
	                    _this3.img.style.transition = 'none';
	                }, 200);
	            } else {
	                this.resetZoom();
	            }
	        }
	    },

	    mouseActivateZoom: function mouseActivateZoom(event) {
	        if (typeof event !== 'undefined') {
	            this.isZoomOn = !this.isZoomOn;
	            if (this.isZoomOn) {
	                this.carousel.classList.add('zoom-active');
	                this.mouseZoom(event);
	            } else {
	                this.resetZoom();
	            }
	        }
	    },

	    mouseZoom: function mouseZoom(event) {
	        var _this4 = this;

	        if (typeof event !== 'undefined') {
	            if (this.selfTarget.closest('.cc-container-dis-picture') !== null && !this.selfTarget.closest('.cc-container-dis-picture').classList.contains('thumb')) {
	                var isImage = this.container.querySelector('img') !== null;
	                var zoomValues = this.zoomValues(event);
	                var constantPerc = this.constantPerc();
	                var zoomX = zoomValues.x * constantPerc;
	                var zoomY = zoomValues.y * constantPerc;
	                var zoomOutCursor = $('.js-pdp-overlay-main-carousel').closest('.cc-image-overlay__wrp').data('zoom-out-cursor');

	                if (isImage) {
	                    this.img.style.transform = 'translate(' + zoomX + '%, ' + zoomY + '%) scale(' + this.scale + ')';
	                    this.img.style.cursor = 'url("' + zoomOutCursor + '"),auto';
	                } else {
	                    this.selfTarget.style.cursor = 'auto';
	                }

	                setTimeout(function () {
	                    if (isImage) {
	                        _this4.img.style.transition = 'none';
	                    }
	                }, 200);
	            } else {
	                this.resetZoom();
	            }
	        }
	    },

	    resetZoom: function resetZoom() {
	        this.isZoomOn = false;
	        this.carousel.classList.remove('zoom-active');
	        this.containers.forEach(function (container) {
	            var img = container.querySelector('img');
	            if (img) {
	                img.style.transition = '';
	                img.style.transform = '';
	                img.style.cursor = '';
	                delete img.dataset.zoomx;
	                delete img.dataset.zoomy;
	            }
	        });
	    },

	    constantPerc: function constantPerc() {
	        var constantPerc = 50 * this.scale - 50;
	        return constantPerc;
	    },

	    zoomValues: function zoomValues(event) {
	        if (typeof event !== 'undefined') {
	            var containerW = this.container.clientWidth;
	            var containerH = this.container.clientHeight;
	            var containerRect = this.container.getBoundingClientRect();
	            var containerXfrom = containerRect.x;
	            var containerYfrom = containerRect.y + window.pageYOffset;
	            var pageX = event.pageX ? event.pageX : event.changedTouches[0].pageX;
	            var pageY = event.pageY ? event.pageY : event.changedTouches[0].pageY;
	            var zoomXValue = (containerXfrom + containerW / 2 - pageX) / (containerW / 2);
	            var zoomYValue = (containerYfrom + containerH / 2 - pageY) / (containerH / 2);
	            zoomXValue = zoomXValue > 1 ? 1 : zoomXValue;
	            zoomXValue = zoomXValue < -1 ? -1 : zoomXValue;
	            zoomYValue = zoomYValue > 1 ? 1 : zoomYValue;
	            zoomYValue = zoomYValue < -1 ? -1 : zoomYValue;

	            return {
	                x: zoomXValue,
	                y: zoomYValue
	            };
	        }
	    },

	    returnValueWithLimit: function returnValueWithLimit(value, max) {
	        value = value > max ? max : value;
	        value = value < -max ? -max : value;
	        return value;
	    }
	};

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

	'use strict';

	var BRAND_LOGO_THRESHOLD = 4.5;

	function resizeBrandLogo() {
	    var $brandLogo = $('[data-target="brandLogo"]')[0];
	    if ($brandLogo.naturalWidth / $brandLogo.naturalHeight >= BRAND_LOGO_THRESHOLD) {
	        $brandLogo.classList.remove('short-logo');
	        $brandLogo.classList.add('long-logo');
	    } else {
	        $brandLogo.classList.remove('long-logo');
	        $brandLogo.classList.add('short-logo');
	    }
	}

	module.exports = {
	    init: function init() {
	        $(window).on('load', function () {
	            resizeBrandLogo();
	        });
	    }
	};

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * appends params to a url
	 * @param {string} url - Original url
	 * @param {Object} params - Parameters to append
	 * @returns {string} result url with appended parameters
	 */

	function appendToUrl(url, params) {
	    var newUrl = url;
	    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
	        return key + '=' + encodeURIComponent(params[key]);
	    }).join('&');

	    return newUrl;
	}

	module.exports = {

	    addAndRemoveToWishlist: function addAndRemoveToWishlist() {

	        $('.container').on('click', '.add-to-wish-list', function (e) {

	            // Mobile users are redirect to size selection if no size is chosen
	            var reminderSizeSelectHint = document.querySelector('.js-reminder-hint');
	            if (reminderSizeSelectHint && window.innerWidth <= 768) {
	                reminderSizeSelectHint.scrollIntoView({
	                    behavior: 'smooth',
	                    block: 'center'
	                });
	            }

	            e.stopPropagation();
	            e.preventDefault();
	            e.stopImmediatePropagation();
	            var loggedin = $('.js-userIcon').length > 0 ? true : false;

	            if (!$(this).closest('.product-tile').find('.js-tile-open-overlay').hasClass('js-noSize') && $(this).closest('.cc-col-tile').find('.js-sizeBtn.active').length === 0) {
	                $(this).closest('.product-tile').addClass('js-addWishlist');
	                $(this).closest('.product-tile').find('.js-tile-open-overlay').trigger('click');
	                return;
	            }

	            if ($(this).closest('.product-tile').find('.js-tile-open-overlay').hasClass('js-noSize') && loggedin == false) {
	                window.location.href = $('.loginLink').attr('href');

	                return;
	            }

	            var addUrl = $(this).data('add-href');
	            var removeUrl = $(this).data('remove-href');
	            var button = $(this);
	            var buttonContentAdd = $(this).find('.wishlist-content-add');
	            var buttonContentRemove = $(this).find('.wishlist-content-remove');
	            var pid = $(this).closest('.product-tile').find('.add-to-cart').attr('data-pid');
	            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
	            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');

	            optionId = optionId || null;
	            optionVal = optionVal || null;
	            removeUrl = removeUrl + '?pid=' + pid;

	            if (!addUrl || !removeUrl || !pid) {
	                return;
	            }

	            var isRedirectToLogin = false;
	            if (loggedin == false) {

	                var urlParams = {
	                    rurl: 4,
	                    pid: pid,
	                    oid: optionId,
	                    oval: optionVal
	                };

	                addUrl = appendToUrl(addUrl, urlParams);
	                isRedirectToLogin = true;
	            }

	            if (button.hasClass("to-add")) {

	                //analytics add to wishlist event
	                $('body').trigger('analytics:addToWishlist', pid);

	                $.spinner().start();
	                $.ajax({
	                    url: addUrl,
	                    type: 'post',
	                    dataType: 'json',
	                    data: {
	                        pid: pid,
	                        optionId: optionId,
	                        optionVal: optionVal
	                    },
	                    success: function success(data) {
	                        //see Wishlist-AddProduct
	                        if (isRedirectToLogin) {
	                            isRedirectToLogin = false;
	                            if (data.redirectUrl) {
	                                window.location.href = data.redirectUrl;
	                            }
	                            return;
	                        }
	                        if (data.success) {
	                            buttonContentAdd.addClass('d-none');
	                            buttonContentRemove.removeClass('d-none');
	                            button.removeClass('to-add').addClass('to-remove');
	                            $('.js-tileWrapper').removeClass('js-tileWrapperHover');
	                            $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	                        } else {
	                            if (data.isFull) {
	                                $('#wishlist-modal-body').text(data.maxProductsMessage);
	                                $('#wishlist-modal').modal('show');
	                            }
	                        }
	                        if (!data.isFull) {
	                            window.ProductsInWishlist = data.productsArr;
	                            var counter = parseInt(data.wishlistSize);
	                            if (counter > 0) {
	                                $('.js-wishlistNumber').removeClass('d-none');
	                            }
	                            $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                        }

	                        if ($('[data-action="Search-Show"]').length > 0) {
	                            $('.js-header').removeClass('cc-header__tag__scrollDown');
	                        }
	                        $.spinner().stop();
	                    },
	                    error: function error(err) {
	                        if (err.responseJSON.redirectUrl) {
	                            window.location.href = err.responseJSON.redirectUrl;
	                        }
	                    }
	                });
	            } else if (button.hasClass('to-remove') && loggedin == true) {

	                //analytics remove from wishlist event
	                $('body').trigger('analytics:removeFromWishlist', pid);

	                $.spinner().start();
	                $.ajax({
	                    url: removeUrl,
	                    type: 'get',
	                    dataType: 'json',
	                    data: {},
	                    success: function success(data) {
	                        //see Wishlist-RemoveProduct
	                        $.spinner().stop();
	                        buttonContentAdd.removeClass('d-none');
	                        buttonContentRemove.addClass('d-none');
	                        button.removeClass('to-remove').addClass('to-add');
	                        //------------------------------
	                        window.ProductsInWishlist = data.productsArr;
	                        var counter = parseInt(data.wishlistSize);
	                        if (counter > 0) {
	                            $('.js-wishlistNumber').removeClass('d-none');
	                        }
	                        $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }
	};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-undef */
	'use strict';

	var userPositionHelper = __webpack_require__(94);
	var storelocatorTemplateHelper = __webpack_require__(93);

	var PID;
	var autocomplete,
	    geocodeRestrictionCountry = false,
	    isPopUpLoading = true;

	//global variables to avoid multiple calls to ajax functions
	var SERVICE_STORES_CALLED = false,
	    SERVICE_CUSTOMER_CALLED = false,
	    isFirstSearch = true;

	/**
	 * @description create a store tile in find-in-store modal
	 * @param {Object} store - a store object
	 * @return {String} the template populated with stores's data
	 */
	function createTemplateSingleStore(store, controllerURL) {
	    var template = $($('#singleStoreTile')[0].content.children[0]),
	        storePhone = store.phone,
	        storeID = store.ID,
	        distance = store.dist && store.dist !== 'null' ? store.dist + ' ' + store.dUnit : '',
	        storeDetailUrl = controllerURL + '?storeID=' + storeID + '&distance=' + store.dist + '&distanceUnit=' + store.dUnit,
	        type,
	        brand;
	    // set
	    template.find('.js-storeContainer').attr('id', storeID);
	    var $storeInfo = template.find('.js-storeId');
	    $storeInfo.data('store-id', storeID);

	    if (store.brand === 'f') {
	        brand = 'flagship';
	    } else {
	        brand = store.brand;
	    }
	    $storeInfo.attr('storebrand', brand);

	    if (store.type === 'o') {
	        type = 'original';
	    } else {
	        type = store.type;
	    }
	    $storeInfo.attr('type', type);
	    var $storeNameSection = template.find('.js-storeName');
	    $storeNameSection.attr('href', storeDetailUrl);
	    $storeNameSection.html(store.name);
	    template.find('.js-storeDistance').html(distance);

	    var $address1 = template.find('.js-storeAddress');
	    var $address2 = template.find('.js-storeAddress2');
	    storelocatorTemplateHelper.fillStoreAddress(template, store, $address1, $address2);

	    template.find('.js-storeCity').html(store.city ? store.city + ',' : '');
	    template.find('.js-storeStateCode').html(store.sCode ? store.sCode + ',' : '');
	    template.find('.js-storeDistrict').html(store.district ? store.district + ',' : '');
	    template.find('.js-storeSubdistrict').html(store.subdistrict ? store.subdistrict + ',' : '');
	    template.find('.js-postalCode').html(store.pCode);
	    var $phone = template.find('.js-storePhone');
	    $phone.html(storePhone);
	    $phone.attr('href', 'tel:' + storePhone);
	    template.find('.js-storeHours').html(unescape(store.hours ? store.hours : ''));
	    var storeTemplate = template.clone();

	    return storeTemplate[0].outerHTML;
	}

	//sorts and loops all the stores received from ajax call
	function processResponse(response) {
	    var htmlToAppend = '';
	    var storesArr = response.stores;
	    storesArr.forEach(function (store) {
	        htmlToAppend += createTemplateSingleStore(store, response.controllerURL);
	    });
	    $('#storeLoadMore').removeClass('d-none');
	    return htmlToAppend;
	}

	//If there are more of 6 stores (2 in case of Breakpoint S) the others stay hidden, then is possible display other stores
	function loadMore() {
	    var storeToShow;

	    if ($(window).width() <= 767) {
	        storeToShow = 2;
	    } else {
	        storeToShow = 6;
	    }

	    var i = 0;
	    var $storeDescription = $('.storeDescription');
	    var length = $storeDescription.length;
	    var hidden = $('#storeLoadMore').hasClass('d-none');
	    $('.storeDescription').each(function (index) {
	        if (i === storeToShow) {
	            return false;
	        }
	        var $this = $(this);
	        if ($this.hasClass('d-none')) {
	            $this.removeClass('d-none');
	            i += 1;
	            if (index === length - 1) {
	                $('#storeLoadMore').addClass('d-none');
	                hidden = true;
	            }
	        } else {
	            if ($(window).width() <= 767) {
	                storeToShow = 4;
	            }
	            return true;
	        }
	    });
	    if (!hidden && length > 0) {
	        $('#storeLoadMore').removeClass('d-none');
	    } else if (length === 0) {
	        $('#storeLoadMore').addClass('d-none');
	    }
	}

	//Is the core function, make the call to Stores Controller to get all result Stores
	function callServiceByParams(latParam, longParam, isGeoLocationSearch) {
	    if (SERVICE_STORES_CALLED) {
	        return;
	    }
	    SERVICE_STORES_CALLED = true;
	    var $destination = $('#modalFindInStore .modal-body');
	    $destination.html('');
	    var $containerLoader = $(".modal-container-loader");
	    $containerLoader.spinner().stop();
	    $containerLoader.spinner().start();
	    //var $searchStoreButton = $("#searchStore");
	    var $buttonFind = $("#findInStoreButton");
	    var pidParam = PID || $buttonFind.attr('data-pid');

	    //build string query, example:
	    ///on/demandware.store/Sites-bata-in-Site/en_IN/Stores-FindStores?pid=170R_2018_5435415_04&lat=xx&long=xx&userPositionLat=xx&userPositionLong=xx

	    var urlControllerBase = $buttonFind.attr('data-url-target');
	    var result = urlControllerBase;
	    var userPosition = userPositionHelper.getUserPosition(isGeoLocationSearch);

	    result += '?pid=';
	    if (pidParam) {
	        result += pidParam;
	    }
	    if (latParam) {
	        result += '&lat=' + latParam;
	    }
	    if (longParam) {
	        result += '&long=' + longParam;
	    }

	    /* set the position of the user, to calculate the distances.
	    This has to be done in this way because if the user lands without any access to his position (like his address or the geolocation)
	    the stores must be displayed without distances */
	    if (userPosition.lat && userPosition.long) {
	        result += '&userPositionLat=' + userPosition.lat;
	        result += '&userPositionLong=' + userPosition.long;
	    } else if (!isGeoLocationSearch && latParam && longParam) {
	        result += '&userPositionLat=' + latParam;
	        result += '&userPositionLong=' + longParam;
	    }

	    if (isFirstSearch) {
	        result += '&radius=false';
	        isFirstSearch = false;
	    }

	    $.ajax({
	        url: result,
	        success: function success(response) {
	            if (response.count === 0) {
	                var errorResponseHTML = '<div class="no-results">' + response.msg + '</div>';
	                $destination.html(errorResponseHTML);
	                $destination.addClass('show-instore-flex');
	            } else {
	                $destination.html(processResponse(response));
	                $destination.removeClass('show-instore-flex');
	            }
	            loadMore();
	            $containerLoader.spinner().stop();
	            // $searchStoreButton.removeClass('clicked');
	            SERVICE_STORES_CALLED = false;
	        },
	        error: function error(err) {
	            if (err && err.responseJSON) {
	                var errorResponseHTML = '<div class="no-results">' + err.responseJSON.msg + '</div>';
	                $destination.html(errorResponseHTML);
	            }
	            loadMore();
	            $containerLoader.spinner().stop();
	            // $searchStoreButton.removeClass('clicked');
	            SERVICE_STORES_CALLED = false;
	        }
	        // timeout: 15000 // sets timeout to 15 seconds // to enable
	    });
	}

	function getSuggestion(predictions) {
	    var userPosition = userPositionHelper.getUserPosition(true);
	    if (!predictions) {
	        callServiceByParams();
	        return;
	    }
	    var geocoder = new google.maps.Geocoder();
	    geocoder.geocode({ placeId: predictions[0].place_id }, function (results) {
	        var lat = results[0].geometry.location.lat();
	        var long = results[0].geometry.location.lng();
	        //if the user has not setted a position for his address, set the values
	        var isGeoLocationSearch = false;
	        if (!userPosition.lat && !userPosition.long) {
	            userPositionHelper.setUserPosition(lat, long, 'userAddress');
	            isGeoLocationSearch = true;
	        }
	        callServiceByParams(lat, long, isGeoLocationSearch);
	    });
	}

	function getOtherAddress(customerAddress) {
	    var userAddr = customerAddress;
	    if (userAddr) {
	        var service = new google.maps.places.AutocompleteService();
	        var options;
	        if (geocodeRestrictionCountry) {
	            options = {
	                input: userAddr,
	                componentRestrictions: {
	                    country: geocodeRestrictionCountry
	                }
	            };
	        } else {
	            options = {
	                input: userAddr
	            };
	        }
	        service.getPlacePredictions(options, getSuggestion);
	    }
	}

	//Try to use Lat and Long from browser
	function geolocationInit(customerAddress) {

	    var options = {
	        enableHighAccuracy: true,
	        timeout: 5000,
	        maximumAge: 0
	    };

	    function success(pos) {
	        var crd = pos.coords;
	        var lat = crd.latitude,
	            long = crd.longitude;
	        userPositionHelper.setUserPosition(lat, long, 'userGeolocation');
	        callServiceByParams(lat, long, true);
	    }

	    function error() {
	        if (customerAddress) {
	            getOtherAddress(customerAddress);
	            return;
	        }
	        var $buttonFind = $("#findInStoreButton");
	        var customerAddressSetted = $buttonFind.attr('data-address-customer');
	        if (customerAddressSetted) {
	            getOtherAddress(customerAddressSetted);
	        } else {
	            callServiceByParams();
	        }
	    }
	    navigator.geolocation.getCurrentPosition(success, error, options);
	}

	function geolocalizationButtonListner() {
	    $('#storeLocationButton').click(function () {
	        geolocationInit();
	    });
	}

	function searchButtonListner() {
	    $('#searchStore').click(function () {
	        var queryParam = $('#queryStoreParam')[0].value;
	        if (queryParam !== "") {
	            var service = new google.maps.places.AutocompleteService();
	            var options;
	            var placeTypes = $('#queryStoreParam').attr('data-place-types');
	            if (geocodeRestrictionCountry) {
	                options = {
	                    input: queryParam,
	                    types: placeTypes !== "" ? placeTypes.split(',') : [],
	                    componentRestrictions: {
	                        country: geocodeRestrictionCountry
	                    }
	                };
	            } else {
	                options = {
	                    input: queryParam,
	                    types: placeTypes !== "" ? placeTypes.split(',') : []
	                };
	            }
	            service.getPlacePredictions(options, getSuggestion);
	        } else {
	            geolocationInit();
	        }
	    });
	}

	function fillInAddress() {
	    var place = autocomplete.getPlace();
	    if (!place || !place.geometry) {
	        return;
	    }
	    var lat = place.geometry.location.lat();
	    var long = place.geometry.location.lng();
	    callServiceByParams(lat, long, false);
	}

	function loadMoreButtonListner() {
	    $('#storeLoadMore').click(function () {
	        loadMore();
	    });
	}

	function initAutocomplete(geocodeRestriction) {
	    if (autocomplete) {
	        return;
	    }
	    var placeTypes = $('#queryStoreParam').attr('data-place-types');
	    if (geocodeRestriction) {
	        autocomplete = new google.maps.places.Autocomplete(document.getElementById('queryStoreParam'), {
	            types: placeTypes !== "" ? placeTypes.split(',') : [],
	            componentRestrictions: {
	                country: geocodeRestriction
	            }
	        });
	    } else {
	        autocomplete = new google.maps.places.Autocomplete(document.getElementById('queryStoreParam'), {
	            types: placeTypes !== "" ? placeTypes.split(',') : []
	        });
	    }
	    autocomplete.addListener("place_changed", fillInAddress);
	}

	//Call Stores controller to get the customer address and Country restriction setting (it, en, etc.)
	//for google suggestions preferences
	function loggedCustomerNoGeo() {
	    if (SERVICE_CUSTOMER_CALLED) {
	        return;
	    }
	    SERVICE_CUSTOMER_CALLED = true;
	    var $buttonFind = $("#findInStoreButton");
	    var urlControllerBase = $buttonFind.attr('data-url-customer');
	    var result = urlControllerBase;
	    $.ajax({
	        url: result,
	        success: function success(response) {
	            var geocodeCountry = response.result.geocodeRestriction;
	            var customerAddress = response.result.customerAddress;
	            var $buttonFind = $("#findInStoreButton");
	            $buttonFind.attr('data-address-customer', customerAddress);
	            geocodeRestrictionCountry = geocodeCountry;
	            initAutocomplete(geocodeCountry);
	            geolocationInit(customerAddress);
	            SERVICE_CUSTOMER_CALLED = false;
	        },
	        error: function error() {
	            initAutocomplete();
	            geolocationInit();
	            SERVICE_CUSTOMER_CALLED = false;
	        }
	    });
	}

	/**
	 * Makes the suggestion box visible only if the user has inserted at least 2 characters into the input field
	 */
	function noSuggestionBox() {
	    $('#queryStoreParam').on('input change focus keydown keyup', function (e) {
	        if ($('#queryStoreParam')[0].value.length < 2) {
	            //block the normal behavior every time except if the user has pressed the "enter" key or the modal is loading
	            if (e.which !== 13 && ($('#queryStoreParam')[0].value.length > 0 || !isPopUpLoading) || e.type === 'keydown') {
	                //stop scrolling the previous results if the user press the arrows keys
	                if ($('.pac-item').length > 0 && (e.which === 40 || e.which === 38)) {
	                    e.preventDefault();
	                }
	                e.stopImmediatePropagation();
	                isPopUpLoading = false;
	            }
	            $('.pac-container').addClass('d-none');
	        } else {
	            var $googleSuggestion = $('.pac-container');
	            $googleSuggestion.removeClass('pac-logo');
	            $googleSuggestion.removeClass('d-none');
	        }
	    });
	}

	/**
	 * trigger the search if the user press "enter"
	 */
	function enterKey() {
	    $('#queryStoreParam').keyup(function (e) {
	        //which = 13 -> enter key pressed
	        if (e.which === 13) {
	            $('#searchStore').trigger('click');
	        }
	    });
	}

	//Is Possible call this function only one time for each time is loaded a Variant(SKU) in PDP,
	//to avoid identical calls to the server.
	//Starts each listner in the modal and init geolocation
	function startAll() {
	    var $destination = $('#modalFindInStore .modal-body');
	    if (!$destination.hasClass('ajax-called')) {
	        $destination.addClass('ajax-called');
	        $destination.html('');
	        var $containerLoader = $(".modal-container-loader");
	        $containerLoader.spinner().start();
	        searchButtonListner();
	        // enterKeyPressListner(); // to enable to add enter key press feature
	        geolocalizationButtonListner();
	        loadMoreButtonListner();
	        loggedCustomerNoGeo();
	        noSuggestionBox();
	        enterKey();
	    } else {
	        return;
	    }
	}

	function start(productPid) {
	    if (productPid) {
	        PID = productPid;
	    } else {
	        PID = null;
	    }
	    //clear the input value on modal opening
	    $('#queryStoreParam').val('');
	    isFirstSearch = true;
	    startAll();
	}

	module.exports = {

	    init: function init() {
	        var $buttonFind = $("#findInStoreButton");
	        $buttonFind.on('click', function (e) {
	            var productTypeVal = $("#findInStoreButton").attr('data-product-type');
	            var productPid = $("#findInStoreButton").attr('data-pid');
	            if (productTypeVal === 'variant') {
	                $('.pdp-col-description .availability-msg .availability-msg-hint').addClass('d-none');
	                start(productPid);

	                //analytics storeAvailibility event
	                $('body').trigger('analytics:storeAvailibility');
	            } else {
	                e.stopPropagation();
	                $('.pdp-col-description .availability-msg .availability-msg-hint').removeClass('d-none');
	            }
	        });
	    }
	};

/***/ })

/******/ });